import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import {globalfunc} from '../globalfunc.js';
import { addDays } from 'date-fns';
const { getQuarter } = require("date-fns");
import { getCategory, getTeamByCompany } from './core/cacheService';
const CATEGORIES = {
    UNDERSTANDING: {
      name: 'Understanding & Clarity',
      questions: ['-OGSfTQqu71fi7f67Ztm', '-OGSgDcIZeg9vJ6JTUYJ'],
      weight: 0.25
    },
    EXECUTION: {
      name: 'Execution & Confidence',
      questions: ['-OGSh6nBCPhmZVVcSvO6', '-OGSi-yigX4U4lSn8z7h'],
      weight: 0.25
    },
    RESOURCES: {
      name: 'Resource & Support',
      questions: ['-OGSiV8s4nrPMhxK_zAe', '-OGSj6iv4BiFfUlwg290'],
      weight: 0.25
    },
    IMPACT: {
      name: 'Impact & Contribution',
      questions: ['-OGSjePG4WFU8A4YH0iB', '-OGSmPA41e8em6xyRJ-5'],
      weight: 0.25
    }
};
export default {
    namespaced: true,
    state: {
        datatable: [],
        TempDatatableAllCohort: [],
        TempDatatableAllTeam: [],
        team:[],
        teamHeight: '',
        teamselected: '',
        cohortSelected: '',
        teamkeys: [],
        cohortkeys: [],
        organizations: [],
        teamSetup: [],
        allResponse: [],
        allResponseCohorts: [],
        allQuarterScoreHistory: [],
        allQuarterScoreHistoryMonthly: [],
        sortBy: 'highest',
        quarterSelected: {},
        quarterSelectedCompare: {},
        organization1level: {},
        questionType: [],
        quarterOption: [],
        quarterOptionModal: [],
        quarterCompare: {
            before: '',
            after: ''
        },
        categoryMaster: {},
        questionMaster: {},
        questionMasterByCategory: [],
        questionSet1:{ // WHO-5
            1:'-MdMv_XgThL0o2iunlhE',
            2:'-MdMw8kfpZtxnppGUA1f',
            3:'-MdMyavdF-YvuyzW6cA5',
            4:'-MdMz-TodEXbj3AC68oP',
            5:'-MdMzwfySVTjhOAGoxTP'
        },
        questionSet2:{ // eRes
            1:'-MgaSDDhL-3mt78QHuYL',
            2:'-MgaSw_L3eW0WyF4ZplB',
            3:'-MgaTQObIM08enQK5p3F',
            4:'-MgaU6mpwzOgerV7w-IW',
            5:'-MgaUfGLnzhU0BcUv5Db'
        },
        questionSet3:{ // Culture
            1:'-MjPYFeALtFMAJkTEiFn',
            2:'-MjPZ15ImFhkjDiMI3gH',
            3:'-MjPZVq3sRBZJwtr7_Tx',
            4:'-MjP_2__thuvnVc_RY0k',
            5:'-MjP_R_bWBdQvFhf5BTY'
        },
        questionCultureCustom:[],
        questionSet4:{ // DEBI
            1:'DPSRRS',
            2:'OFRS',
            3:'OFES',
            4:'RPRS',
            5:'VAS'
        },
        questionSet5:{ // strategic_alignment
            1:'-OGSfTQqu71fi7f67Ztm',
            2:'-OGSgDcIZeg9vJ6JTUYJ',
            3:'-OGSh6nBCPhmZVVcSvO6',
            4:'-OGSi-yigX4U4lSn8z7h',
            5:'-OGSiV8s4nrPMhxK_zAe',
            6:'-OGSj6iv4BiFfUlwg290',
            7:'-OGSjePG4WFU8A4YH0iB',
            8:'-OGSmPA41e8em6xyRJ-5'
        },
        questionSet4_weight:{ // DEBI
            'DPSRRS':0.34,
            'OFRS':0.22,
            'OFES':0.11,
            'RPRS':0.22,
            'VAS':0.11,
        },
        questionSet4_max:{ // DEBI
            'DPSRRS':1,
            'OFRS':0.8,
            'OFES':1,
            'RPRS':1,
            'VAS':0.8,
        },
        QuarterOfMonth: {
            1:"1",
            2:"1",
            3:"1",
            4:"2",
            5:"2",
            6:"2",
            7:"3",
            8:"3",
            9:"3",
            10:"4",
            11:"4",
            12:"4"
        },
        showSnackbar: false,
        datalistallCohort: [],
        datalistallScoreHistory: [],
        datalistallScoreHistoryMonthly: [],
        allCohortOrderd: [],
        allCohort: {},
        chartData: [],
        chartLabel: [],
        chartMaxChange: '-',
        questionMasterArr: [],
    },
    mutations: {
        setsortBy(state:any, result:any) {
            state.sortBy = result
        },
        setTeam(state:any, result:any) {
            state.teamkeys = result
        },
        setCategoryMaster(state: any, result: any) {
            state.categoryMaster = result
        },
        setQuestionMaster(state: any, result: any) {
            state.questionMaster = result
        },
        setQuestionMasterArray(state: any, result: any) {
            state.questionMasterArr = result
        },
        setQuestionMasterByCategory(state: any, result: any) {
            state.questionMasterByCategory = result
        },
        setDataTable(state: any, result: any) {
            state.datatable = result
        },
        setTempDataTableAllCohort(state: any, result: any) {
            state.TempDatatableAllCohort = result
        },
        setTempDataTableAllTeam(state: any, result: any) {
            state.TempDatatableAllTeam = result
        },
        setDataTableAll(state: any, value: any) {
            state.datalistall = value
        },
        setDataTableAllCohort(state: any, value: any) {
            state.datalistallCohort = value
        },
        setDataTableAllScoreHistory(state: any, value: any) {
            state.datalistallScoreHistory = value
        },
        setDataTableAllScoreHistoryMonthly(state: any, value: any) {
            state.datalistallScoreHistoryMonthly = value
        },
        setDataExportAll(state: any, value: any) {
            state.dataexportall = value
        },
        setTeamHeight(state: any, value: any) {
            state.teamHeight = value
        },
        setCohortSelected(state: any, value: any) {
            state.cohortSelected = value
        },
        setAllCohort(state: any, value: any) {
            state.allCohort = value
        },
        setAllCohortOrderd(state: any, value: any) {
            state.allCohortOrderd = value
        },
        setTeamSelected(state: any, value: any) {
            state.teamselected = value
        },
        setOrganizations(state: any, value: any) {
            state.organizations = value
        },
        setTeamKeys(state: any, value: any) {
            state.teamkeys = value
        },
        setCohortKeys(state: any, value: any) {
            state.cohortkeys = value
        },
        setTeamSetup(state: any, value: any) {
            state.teamsetup = value
        },
        setquarterSelected(state: any, value: any) {
            state.quarterSelected = value
        },
        quarterSelectedCompare(state: any, value: any) {
            state.quarterSelectedCompare = value
        },
        setquarterCompare(state: any, value: any) {
            state.quarterCompare.before = value.before
            state.quarterCompare.after = value.after
        },
        setQuarterOption(state: any, value: any) {
            state.quarterOption = value
        },
        setQuarterOptionModal(state: any, value: any) {
            state.quarterOptionModal = value
        },
        setAllResponse(state: any, value: any) {
            state.allResponse = value
        },
        setAllResponseCohorts(state: any, value: any) {
            state.allResponseCohorts = value
        },
        setAllQuarterScoreHistory(state: any, value: any) {
            state.allQuarterScoreHistory = value
        },
        setAllQuarterScoreHistoryMonthly(state: any, value: any) {
            state.allQuarterScoreHistoryMonthly = value
        },
        setQuestionType(state: any, value: any) {
            state.questionType = value
        },
        setSnackbar(state: any, value: any) {
            state.showSnackbar = value
        },
        setChartDataScoreHistory(state: any, value: any) {
            state.chartData = value
        },
        setChartLabelScoreHistory(state: any, value: any) {
            state.chartLabel = value
        },
        setChartDataMaxChange(state: any, value: any) {
            state.chartMaxChange = value
        },
        setCultureCustom(state: any, value: any) {
            state.questionCultureCustom = value
        }
    },
    actions: {
        async getQuestionMaster({ commit, rootState, state }: any) {
            const categoryMaster = await getCategory()
            let categorySort: Array<any> = []
            const questionType: Array<any> = [];
            const dataMaster = {}
            const questionMaster: Array<any> = []
            const questionCultureCustom: Array<any> = []
            dataMaster['DEBI'] = 'Dynamic Engagement Behavior Index measuring true engagement'
            dataMaster['Index'] = 'Strategic Alignment Index measuring understanding and execution of priorities'
            dataMaster['Variance'] = 'Alignment Consistency Score showing uniformity of strategic understanding'
            dataMaster['Culture'] = 'Culture Index measuring organizational culture strength'
            const dataMasterByCategory: Array<any> = []
            dataMasterByCategory['nps'] = new Object()
            dataMasterByCategory['set1'] = new Object()
            dataMasterByCategory['engagement'] = new Object()
            dataMasterByCategory['engagement']['DEBI'] = 'DEBI'
            dataMasterByCategory['strategic_alignment'] = new Object()
            dataMasterByCategory['strategic_alignment']['Index'] = 'Index'
            dataMasterByCategory['strategic_alignment']['Variance'] = 'Variance'

            const snapshot = await firebase.database()
                .ref('questions')
                .orderByChild('report_card')
                .equalTo('Y')
                .once('value')

            snapshot.forEach((doc): any => {
                const data = doc.val()
                data.key = doc.key
                questionMaster[data.key] = data
                if(data.company == 'main' || data.company == rootState.authen.user.company){
                    dataMaster[data.key] = data.report_card_label
                    if(dataMasterByCategory[data.category] == undefined){
                        dataMasterByCategory[data.category] = new Object()
                        categorySort.push({category_id: data.category,category_name: categoryMaster[data.category].category})
                    }
                    if(data.nps !== undefined){
                        dataMasterByCategory['nps'][data.key] = data.report_card_label
                    }else{
                        if(_.find(state.questionSet1, function(o) { return o === data.key; })){ //WHO-5
                            dataMaster['WHO-5'] = data.report_card_label
                            dataMasterByCategory['set1']['WHO-5'] = data.report_card_label
                        }else if(_.find(state.questionSet2, function(o) { return o === data.key; })){  //eRes
                            dataMaster['eRes'] = data.report_card_label
                            dataMasterByCategory['set1']['eRes'] = data.report_card_label
                        }else if(_.find(state.questionSet3, function(o) { return o === data.key; })){  //Culture
                            dataMasterByCategory['set1']['Culture'] = data.report_card_label
                        }else{
                            if(data.index_score == undefined || data.index_score !== 'Y'){
                                dataMasterByCategory[data.category][data.key] = data.report_card_label
                            }
                            if(data.culture_index == true){
                                questionCultureCustom.push(data.key)
                                dataMaster['Culture_Custom'] = data.report_card_label
                                dataMasterByCategory['set1']['Culture_Custom'] = data.report_card_label
                            }
                        }
                    }
                    if(questionType[data.key] == undefined){
                        if(data.nps !== undefined){
                            if(data.nps == 'eNPS'){
                                questionType[data.key] = 'eNPS'
                            }else{
                                questionType[data.key] = 'NPS'
                            }
                        }else{
                            if(_.find(state.questionSet1, function(o) { return o === data.key; })){  //WHO-5
                                questionType['WHO-5'] = 'WHO-5'
                            }else if(_.find(state.questionSet2, function(o) { return o === data.key; })){  //eRes
                                questionType['eRes'] = 'eRes'
                            }else if(_.find(state.questionSet3, function(o) { return o === data.key; })){  //Culture
                                questionType['Culture'] = 'Culture'
                            }else{
                                if(data.index_score == undefined || data.index_score !== 'Y'){
                                    questionType[data.key] = data.type
                                }
                                if(data.culture_index == true){
                                    questionType['Culture'] = 'Culture'
                                }
                            }
                        }
                    }
                }
            });

            if(dataMaster['Culture_Custom']){
                dataMasterByCategory['set1']['Culture'] = dataMasterByCategory['set1']['Culture_Custom']
                delete dataMaster['Culture_Custom']
                delete dataMasterByCategory['set1']['Culture_Custom']
            }
            categorySort = _.orderBy(categorySort,['category_name'], ['asc'])
            categorySort.unshift({category_id: 'set1',category_name: 'set1'})
            categorySort.unshift({category_id: 'engagement',category_name: 'engagement'})
            categorySort.unshift({category_id: 'strategic_alignment',category_name: 'strategic_alignment'})
            categorySort.unshift({category_id: 'nps',category_name: 'nps'})
            const results: Array<any> = []
            _.forEach(categorySort, (value)=> {
                results[value.category_id] = dataMasterByCategory[value.category_id]
            });
            questionType['DEBI'] = 'DEBI'
            questionType['Index'] = 'Index'
            questionType['Variance'] = 'Variance'
            commit('setQuestionType', questionType)
            commit('setCategoryMaster', categoryMaster)
            commit('setQuestionMaster', dataMaster)
            commit('setQuestionMasterByCategory', results)
            commit('setQuestionMasterArray', questionMaster)
            commit('setCultureCustom', questionCultureCustom)
        },
        getQuarter({ commit, dispatch, rootState, state }: any) {
            const dateNow = new Date()
            const arrQuarter: Array<any> = [];
            const arrQuarterModal: Array<any> = [];
            let thisYear = format(dateNow, 'YYYY')
            let m = format(dateNow, 'M')
            let quarterSelected = {}
            let quarterStart = ""
            let quarterEnd = thisYear+state.QuarterOfMonth[m]
            quarterSelected = {"id":quarterEnd, "name": "MOST RECENT SCORES", "title": "MOST RECENT SCORES", "type": "recent"}
            
            let yearCompare = Number(quarterEnd.substr(0,4))
            let runQCompare = Number(quarterEnd.substr(4,1))
            runQCompare = runQCompare - 1
            if(runQCompare < 1){
                runQCompare = 4
                yearCompare = yearCompare - 1
            }
            commit('setquarterSelected', quarterSelected)
            commit('quarterSelectedCompare', {"id":String(yearCompare)+String(runQCompare), "name": "Q"+String(runQCompare)+" "+ String(yearCompare), "title": "Q"+String(runQCompare)+" "+ String(yearCompare), "type": ""})
            firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).orderBy("quarter").limit(1).get()
                .then(function (querySnapshot) {
                    querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        quarterStart = String(data['quarter'])
                    });
                    arrQuarter.push({"id":quarterEnd, "name": "MOST RECENT SCORES" , "title": "MOST RECENT SCORES", "type": "recent"})

                    let year = Number(quarterEnd.substr(0,4))
                    let runQ = Number(quarterEnd.substr(4,1))
                    do{
                        if(runQ < 1){
                            runQ = 4
                            year = year - 1
                        }
                        arrQuarter.push({"id":String(year)+String(runQ), "name": "Q"+String(runQ)+" "+ String(year), "title": "Q"+String(runQ)+" "+ String(year), "type": ""})
                        arrQuarterModal.push({"id":String(year)+String(runQ), "name": "Q"+String(runQ)+" "+ String(year), "title": "Q"+String(runQ)+" "+ String(year), "type": ""})
                        runQ--
                    }
                    while(Number(quarterStart) <= Number(String(year) + String(runQ)))
                    commit('setQuarterOption', arrQuarter)
                    commit('setQuarterOptionModal', arrQuarterModal)
            });
        },
        async getKeys({ commit, dispatch, rootState, state }: any) {
            const teamkeys: Array<any> = [];
            const cohortkeys: Array<any> = [];
            if(rootState.team.teamsall.length > 0){
                _.forEach(rootState.team.teamsall, (value)=> {
                    teamkeys[value.key] = value
                });
            }else{
                const team2 = await getTeamByCompany(rootState.authen.user.company)//(await firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value')).val()
                _.forEach(team2, (value,key)=> {
                    teamkeys[key] = value
                });
            }
            if(rootState.report.allCohortOrderd.length > 0){
                _.forEach(rootState.report.allCohortOrderd, (value)=> {
                    cohortkeys[value.key] = value
                });
            }else{
                const cohort2 = (await firebase.database().ref(`cohorts/${rootState.authen.user.company}`).once('value')).val()
                _.forEach(cohort2, (value,key)=> {
                    cohortkeys[key] = value
                });
            }
            commit('setTeamKeys', teamkeys)
            commit('setCohortKeys', cohortkeys)
        },
        async ensureTablePrerequisites({ dispatch, state }: any) {
            const pending: Array<any> = [];
            if(!state.quarterSelected || !state.quarterSelected.id){
                pending.push(dispatch('getQuarter'))
            }
            if(Object.keys(state.questionMasterByCategory || {}).length == 0){
                pending.push(dispatch('getQuestionMaster'))
            }
            if(Object.keys(state.organizations || {}).length == 0){
                pending.push(dispatch('getOrganization'))
            }
            if(
                Object.keys(state.teamkeys || {}).length == 0 ||
                Object.keys(state.cohortkeys || {}).length == 0
            ){
                pending.push(dispatch('getKeys'))
            }
            if(pending.length > 0){
                await Promise.all(pending)
            }
        },
        async getDataTableCohorts({ commit, dispatch, rootState, state }: any, selectCohort: any) {
            state.datatable = [];
            await dispatch('ensureTablePrerequisites')
            const dateNow = new Date()
            const questionMasterArr = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            if(!selectCohort && state.TempDatatableAllCohort.length > 2 && state.quarterSelected.type == 'recent'){
                setTimeout(() => {
                    commit('setDataTable', state.TempDatatableAllCohort)
                  }, 1000);
            }else{
                if(selectCohort && selectCohort !== 'all'){
                    commit('setCohortSelected', selectCohort)
                }else{
                    commit('setCohortSelected', '')
                }
                if(rootState.insightsCohorts.optionsCohort.length == 0){
                    const cohorts:Array<any> = [];
                    await firebase.database().ref(`cohorts/${rootState.authen.user.company}`).once('value', (snapshot) => {
                        snapshot.forEach((doc) => {
                            const cohort = doc.val()
                            cohort.key = doc.key
                            cohort.value = doc.val().name
                            cohorts.push(cohort)
                        });
                        let ordered = _.sortBy(cohorts, [function(o:any) { return o.name; }])
                        commit('setAllCohortOrderd', ordered)
                    });
                }else{
                    let ordered = rootState.insightsCohorts.optionsCohort
                    commit('setAllCohortOrderd', ordered)
                }
                if(Object.keys(state.allCohort).length == 0){
                    const allCohort = (await firebase.database().ref(`cohorts/${rootState.authen.user.company}`).once('value')).val()
                    commit('setAllCohort', allCohort)
                }
                if(state.quarterSelected.type == 'recent'){
                    const dateYesterday = format(addDays(dateNow, -1), 'YYYY-MM-DD')
                    const quarter = getQuarter(dateYesterday)
                    // const yearQuarter = 20231  // FIX Data
                    const yearQuarter = format(dateYesterday, 'YYYY') + quarter;
                    const datelast = format(dateYesterday, 'YYYY-MM-DD')

                    await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                    .then(async function (querySnapshot) {
                        if(querySnapshot.empty){
                            await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelectedCompare.id)).get()
                            .then(function (querySnapshot) {
                                const response: Array<any> = [];
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort){
                                        response[data.cohort] = data.members
                                    }
                                });
                                commit('setAllResponseCohorts', response)
                            });
                        }else{
                            const response: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    response[data.cohort] = data.members
                                }
                            });
                            commit('setAllResponseCohorts', response)
                        }
                    });
                    let citiesRef = firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", rootState.authen.user.company)
                    if(selectCohort){
                        citiesRef = citiesRef.where("cohort", "==", selectCohort)
                    }
                    citiesRef.get()
                    .then(function (querySnapshot) {
                        const dataItem: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(data.cohort){
                                dataItem[data.cohort+"_"+data.quest_id] = data
                            }
                        });
                        let citiesRef2 = firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company)
                        if(selectCohort){
                            citiesRef2 = citiesRef2.where("cohort", "==", selectCohort)
                        }
                        citiesRef2 = citiesRef2.where("quarter", "==", Number(yearQuarter))
                        citiesRef2.get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort !== undefined){
                                    dataItem[data.cohort+"_"+data.type] = data
                                }
                            });
                            const datatable: Array<any> = [];
                            _.forOwn(dataItem, function(value, key) {
                                let _tmp: { [key: string]: any } = {}
                                _tmp = value;
                                let temp_name = '';
                                if(state.allCohort[value.cohort]){
                                    temp_name = state.allCohort[value.cohort].name
                                }
            
                                _tmp['teamid'] = value.cohort;
                                _tmp['team'] = temp_name;
                                datatable.push(_tmp);
                            });
                            commit('setDataTableAllCohort', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                            dispatch('getDataTablebyCohort', { cohort: '', type: 'parent' })
                        });
                    });
                }else{
                    if(state.quarterSelected.type == 'compare'){
                        const response: Array<any> = [];
                        // const dataResponseBefore: { [key: string]: any; } = {}
                        // const dataResponseAfter: { [key: string]: any; } = {}
                        // const questionType: Array<any> = [];
                        const dataItemBefore: Array<any> = [];
                        const dataItemAfter: Array<any> = [];
                        
                        firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    response[data.cohort] = data.members
                                }
                            });
                        });
                        
                        firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    if(response[data.cohort] == undefined){
                                        response[data.cohort] = data.members
                                    }else if(response[data.cohort] !== undefined && response[data.cohort] < data.members ){
                                        response[data.cohort] = data.members
                                    }
                                }
                            });
                        });
                        let citiesRef = firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before))
                        if(selectCohort){
                            citiesRef = citiesRef.where("cohort", "==", selectCohort)
                        }
                        await citiesRef.get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItemBefore[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            let citiesRef2 = firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before))
                            if(selectCohort){
                                citiesRef2 = citiesRef2.where("cohort", "==", selectCohort)
                            }
                            citiesRef2.get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItemBefore[data.cohort+"_"+data.type] = data
                                    }
                                });
                            });
                        });
                        
                        let citiesRef3 = firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after))
                        if(selectCohort){
                            citiesRef3 = citiesRef3.where("cohort", "==", selectCohort)
                        }
                        await citiesRef3.get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItemAfter[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            let citiesRef4 = firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after))
                            if(selectCohort){
                                citiesRef4 = citiesRef4.where("cohort", "==", selectCohort)
                            }
                            citiesRef4.get()
                            .then(async function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItemAfter[data.cohort+"_"+data.type] = data
                                    }
                                });
                                let datatable:any = []
                                for (const [key, value] of Object.entries(dataItemAfter)) {
                                // _.forOwn(dataItemAfter, function(value:any, key) {
                                    if(dataItemBefore[key] !== undefined){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = value;
                                        let temp_name = '';
                                        if(state.allCohort[value.cohort]){
                                            temp_name = state.allCohort[value.cohort].name
                                        }
                                        if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][value.quest_id]){
                                            let nps_score_after:any = 0
                                            let nps_score_before:any = 0
                                            if(value.answer && Object.keys(value.answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                for (const [key2, response] of Object.entries(value.answer)) {
                                                    let numKey = Number(key2);
                                                    if(numKey >= 0 && numKey <= 6){
                                                        detractors+= response
                                                    }else if(numKey >=9 && numKey <= 10){
                                                        promotors+= response
                                                    }
                                                }
                                                nps_score_after =((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                            }
                                            if(dataItemBefore[key] && dataItemBefore[key].answer && Object.keys(dataItemBefore[key].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                for (const [key2, response] of Object.entries(dataItemBefore[key].answer)) {
                                                    let numKey = Number(key2);
                                                    if(numKey >= 0 && numKey <= 6){
                                                        detractors+= response
                                                    }else if(numKey >=9 && numKey <= 10){
                                                        promotors+= response
                                                    }
                                                }
                                                nps_score_before = ((promotors / Number(dataItemBefore[key].total)) - (detractors / Number(dataItemBefore[key].total)))*100
                                            }
                                            _tmp['percent'] = globalfunc.round(nps_score_after,0) - globalfunc.round(nps_score_before,0)
                                            _tmp['teamid'] = value.cohort;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }else if(_.find(state.questionSet1, function(o) { return o === _tmp.quest_id; })){ //WHO-5
                                            let datatableWHO5:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableWHO5 = _.filter(datatable, { 'quest_id': 'WHO-5', 'team': teamId })
                                            }
                                            if((!datatableWHO5 || datatableWHO5.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }
        
                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'WHO-5'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                                // _tmp['percent'] = (percentBefore.toFixed(1) * 1) - (percentAfter.toFixed(1) * 1)
                                            }
                                        }else if(_.find(state.questionSet2, function(o) { return o === _tmp.quest_id; })){ // eRes
                                            let datatableeRes:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableeRes = _.filter(datatable, { 'quest_id': 'eRes', 'team': teamId })
                                            }
                                            if((!datatableeRes || datatableeRes.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                }else{
                                                    percentBefore = 0
                                                }
        
                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                }else{
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'eRes'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                                // _tmp['percent'] = (percentBefore.toFixed(1) * 1) - (percentAfter.toFixed(1) * 1)
                                            }
                                        }else if(_.find(state.questionSet3, function(o) { return o === _tmp.quest_id; }) || _.find(questionCultureCustom, function(o) { return o === _tmp.quest_id; })){ // Culture
                                            // Check if Culture data already exists for this cohort
                                            let datatableCulture:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableCulture = _.filter(datatable, { 'quest_id': 'Culture', 'team': teamId })
                                            }
                                            if((!datatableCulture || datatableCulture.length == 0) && value.cohort){
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                
                                                // Calculate percentBefore and percentAfter based on custom or default questions
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const calculateCustomPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(const question of questionCultureCustom){
                                                            dataTeamSelect.push(dataSource[value.cohort+"_"+question])
                                                        }
                                                        
                                                        for(let i=0; i<dataTeamSelect.length; i++){
                                                            if(dataTeamSelect[i] && Object.keys(dataTeamSelect[i]).length > 0){
                                                                let questId = dataTeamSelect[i].quest_id
                                                                if(questionMasterArr[questId]){
                                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, questId, dataTeamSelect[i].answer);
                                                                    dataSum += result.dataSum;
                                                                    maxmimum += result.total;
                                                                }
                                                            }
                                                        }
                                                        
                                                        const percent = ((dataSum * 100) / maxmimum);
                                                        return isNaN(percent) ? 0 : percent;
                                                    };
                                                    
                                                    percentBefore = calculateCustomPercent(dataItemBefore);
                                                    percentAfter = calculateCustomPercent(dataItemAfter);
                                                }else{
                                                    // Default calculation using questionSet3
                                                    const calculateDefaultPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(let i=1; i<=5; i++){
                                                            dataTeamSelect.push(dataSource[value.cohort+"_"+state.questionSet3[i]])
                                                        }
                                                        
                                                        const allValid = dataTeamSelect.every((item, idx) => 
                                                            item && Object.keys(item).length > 0
                                                        );
                                                        
                                                        if(allValid){
                                                            for(let x=0; x<5; x++){
                                                                if(dataTeamSelect[x] && dataTeamSelect[x].answer && Object.keys(dataTeamSelect[x].answer).length > 0){
                                                                    for(let y=0; y<6; y++){
                                                                        if(dataTeamSelect[x].answer[y]){
                                                                            dataSum += (dataTeamSelect[x].answer[y]) * (5 - y)
                                                                            maxmimum += dataTeamSelect[x].answer[y] * 5
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            return ((dataSum * 100) / maxmimum);
                                                        }
                                                        return 0;
                                                    };
                                                    
                                                    percentBefore = calculateDefaultPercent(dataItemBefore);
                                                    percentAfter = calculateDefaultPercent(dataItemAfter);
                                                }
                                                _tmp['quest_id'] = 'Culture'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                                // _tmp['percent'] = (percentBefore.toFixed(1) * 1) - (percentAfter.toFixed(1) * 1)
                                            }
                                        }else if(_.find(state.questionSet4, function(o) { return o === _tmp.type; })){ // DEBI
                                            let datatableDEBI:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableDEBI = _.filter(datatable, { 'type': 'DEBI', 'team': teamId })
                                            }
                                            if((!datatableDEBI || datatableDEBI.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectBefore[0] || dataTeamSelectBefore[1] || dataTeamSelectBefore[2] || dataTeamSelectBefore[3] || dataTeamSelectBefore[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && dataTeamSelectBefore[x].total){
                                                            // dataSumBefore += ((dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total) * state.questionSet4_weight[dataTeamSelectBefore[x].type])
                                                            let score = (dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectBefore[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectBefore[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumBefore += score
                                                        }
                                                    }
                                                    percentBefore = dataSumBefore * 100
                                                }else{
                                                    percentBefore = 0
                                                }
        
                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectAfter[0] || dataTeamSelectAfter[1] || dataTeamSelectAfter[2] || dataTeamSelectAfter[3] || dataTeamSelectAfter[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && dataTeamSelectAfter[x].total){
                                                            // dataSumAfter += ((dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total) * state.questionSet4_weight[dataTeamSelectAfter[x].type])
                                                            let score = (dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectAfter[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectAfter[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumAfter += score
                                                        }
                                                    }
                                                    percentAfter = dataSumAfter * 100
                                                }else{
                                                    percentAfter = 0
                                                }
                                                _tmp['type'] = 'DEBI'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                                // _tmp['percent'] = (percentBefore.toFixed(1) * 1) - (percentAfter.toFixed(1) * 1)
                                            }
                                        }else if(_.find(state.questionSet5, function(o) { return o === _tmp.quest_id; })){ // Index & Variance
                                            // Index
                                            let datatableIndex:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableIndex = _.filter(datatable, { 'quest_id': 'Index', 'team': teamId })
                                            }
                                            if((!datatableIndex || datatableIndex.length == 0) && value.cohort){
                                                const dataTeamSelectBefore:any = {};
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemBefore[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentBefore = results.alignmentIndex * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentBefore = 0
                                                    }
                                                } else {
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter:any = {};
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemAfter[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentAfter = results.alignmentIndex * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentAfter = 0
                                                    }
                                                } else {
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'Index'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }

                                            //Variance
                                            let datatableVariance:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableVariance = _.filter(datatable, { 'quest_id': 'Variance', 'team': teamId })
                                            }
                                            if((!datatableVariance || datatableVariance.length == 0) && value.cohort){
                                                const dataTeamSelectBefore:any = {};
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemBefore[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentBefore = results.consistencyScore * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentBefore = 0
                                                    }
                                                } else {
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter:any = {};
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemAfter[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentAfter = results.consistencyScore * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentAfter = 0
                                                    }
                                                } else {
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'Variance'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_tmp.question_type == 'Scale'){
                                            _tmp['percent'] = (value.percent.toFixed(1) * 1) - (dataItemBefore[key].percent.toFixed(1) * 1)
                                            _tmp['teamid'] = value.cohort;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }else{
                                            _tmp['percent'] = Math.ceil(value.percent) - Math.ceil(dataItemBefore[key].percent)
                                            _tmp['teamid'] = value.cohort;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }
                                        // _tmp['teamid'] = value.cohort;
                                        // _tmp['team'] = temp_name;
                                        // datatable.push(_tmp);
                                    }
                                }
                                commit('setAllResponseCohorts', response)
                                commit('setDataTableAllCohort', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('getDataTablebyCohort', { cohort: '', type: 'parent' })
                            });
                        });
                    }else{
                        await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                        .then(function (querySnapshot) {
                            const response: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    response[data.cohort] = data.members
                                }
                            });
                            commit('setAllResponseCohorts', response)
                        });
                        // const questionType: Array<any> = [];
                        let citiesRef = firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id))
                        if(selectCohort){
                            citiesRef = citiesRef.where("cohort", "==", selectCohort)
                        }
                        citiesRef.get()
                        .then(function (querySnapshot) {
                            const datatable: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                let _tmp: { [key: string]: any } = {}
                                _tmp = doc.data();
                                if(_tmp.cohort){
                                    let temp_name = '';
                                    if(state.allCohort[doc.data().cohort]){
                                        temp_name = state.allCohort[doc.data().cohort].name
                                    }
                
                                    _tmp['teamid'] = doc.data().cohort;
                                    _tmp['team'] = temp_name;
                                    datatable.push(_tmp);
                                }
                            });
                            let citiesRef2 = firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id))
                            if(selectCohort){
                                citiesRef2 = citiesRef2.where("cohort", "==", selectCohort)
                            }
                            citiesRef2.get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = doc.data();
                                    if(_tmp.cohort){
                                        let temp_name = '';
                                        if(state.allCohort[doc.data().cohort]){
                                            temp_name = state.allCohort[doc.data().cohort].name
                                        }
                    
                                        _tmp['teamid'] = doc.data().cohort;
                                        _tmp['team'] = temp_name;
                                        datatable.push(_tmp);
                                    }
                                });
                                commit('setDataTableAllCohort', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('getDataTablebyCohort', { cohort: '', type: 'parent' })
                            });
                        });
                    }
                    
                }
            }
        },
        async getDataTable({ commit, dispatch, rootState, state }: any, selectTeam: any) {
            state.datatable = [];
            await dispatch('ensureTablePrerequisites')
            const dateNow = new Date()
            const questionMasterArr = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            if(!selectTeam && state.TempDatatableAllTeam.length > 2 && state.quarterSelected.type == 'recent'){
                setTimeout(() => {
                    commit('setDataTable', state.TempDatatableAllTeam)
                  }, 1000);
            }else{
                if (!selectTeam) {
                    if(!state.teamHeight){
                        if(rootState.team.teamsall.length >0){
                            let topmostArr: Array<any> = [];
                            _.forEach(rootState.team.teamsall, (value)=> {
                                if(value.parent == ''){
                                    topmostArr.push(value.key)
                                }
                            });
                            selectTeam = topmostArr[0]
                            if(topmostArr.length > 1){
                                selectTeam = _.find(topmostArr, (value) => {
                                const chk_topmost = _.find(rootState.team.teamsall, { parent: value });
                                return !!chk_topmost;
                                });
                            }
                            commit('setTeamHeight', selectTeam)
                        }else{
                            let topmostArr: Array<any> = [];
                            let teamAll: Array<any> = [];
                            try{
                                const teamData = await getTeamByCompany(rootState.authen.user.company)
                                for(const key in teamData){
                                    teamAll.push(teamData[key])
                                    if (!teamData[key].parent){
                                        topmostArr.push(key)
                                    } 

                                }
                                selectTeam = topmostArr[0]
                                if(topmostArr.length > 1){
                                    selectTeam = _.find(topmostArr, (value) => {
                                    const chk_topmost = _.find(teamAll, { parent: value });
                                    return !!chk_topmost;
                                });
                                }
                                commit('setTeamHeight', selectTeam)
                                
                            }catch(error){
                                console.log(error)
                            }
                            // await firebase.database().ref('team').orderByChild('company').equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
                            //     snapshot.forEach((doc): any => {
                            //         teamAll.push(doc.val())
                            //         if (!doc.val().parent){
                            //             topmostArr.push(doc.key)
                            //         } 
                            //     });
                            //     selectTeam = topmostArr[0]
                            //     if(topmostArr.length > 1){
                            //         selectTeam = _.find(topmostArr, (value) => {
                            //         const chk_topmost = _.find(teamAll, { parent: value });
                            //         return !!chk_topmost;
                            //     });
                            //     }
                            //     commit('setTeamHeight', selectTeam)
                            // });
                        }
                    }else{
                        selectTeam = state.teamHeight
                    }
                }
                commit('setTeamSelected', selectTeam)
                if(state.quarterSelected.type == 'recent'){
                    const dateYesterday = format(addDays(dateNow, -1), 'YYYY-MM-DD')
                    const quarter = getQuarter(dateYesterday)
                    // const yearQuarter = 20231  // FIX Data
                    const yearQuarter = format(dateYesterday, 'YYYY') + quarter;
                    const datelast = format(dateYesterday, 'YYYY-MM-DD')
                    
                    await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                    .then(async function (querySnapshot) {
                        if(querySnapshot.empty){
                            await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelectedCompare.id)).get()
                            .then(function (querySnapshot) {
                                const response: Array<any> = [];
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    response[data.team] = data.members
                                });
                                commit('setAllResponse', response)
                            });
                        }else{
                            const response: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                response[data.team] = data.members
                            });
                            commit('setAllResponse', response)
                        }
                    });
                    // const questionType: Array<any> = [];
                    firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).get()
                    .then(function (querySnapshot) {
                        const dataItem: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            dataItem[data.team+"_"+data.quest_id] = data
                            // if(questionType[data.quest_id] == undefined){
                            //     questionType[data.quest_id] = data.question_type
                            // }
                        });
                        firebase.firestore().collection('insight_teams_report_card_fix').where("company", "==", rootState.authen.user.company).where("parent_team", "==", state.teamselected).get()
                        .then(function (querySnapshot) {
                            // const dataItem: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItem[data.team+"_"+data.quest_id] = data
                                // if(questionType[data.quest_id] == undefined){
                                //     questionType[data.quest_id] = data.question_type
                                // }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(yearQuarter)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItem[data.team+"_"+data.type] = data
                                    }
                                });
                                const datatable: Array<any> = [];
                                _.forOwn(dataItem, function(value, key) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = value;
                                    let temp_name = '';
                                    if(state.teamkeys[value.team]){
                                    temp_name = state.teamkeys[value.team].name
                                    }
                
                                    _tmp['teamid'] = value.team;
                                    _tmp['team'] = temp_name;
                                    datatable.push(_tmp);
                                });
                                // commit('setQuestionType', questionType)
                                commit('setDataTableAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('getDataTablebyTeam', { team: '', type: 'parent' })
                            });
                        });
                    });
                }else{
                    if(state.quarterSelected.type == 'compare'){
                        const response: Array<any> = [];
                        // const dataResponseBefore: { [key: string]: any; } = {}
                        // const dataResponseAfter: { [key: string]: any; } = {}
                        // const questionType: Array<any> = [];
                        const dataItemBefore: Array<any> = [];
                        const dataItemAfter: Array<any> = [];
                        
                        firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                response[data.team] = data.members
                            });
                        });
                        
                        firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(response[data.team] == undefined){
                                    response[data.team] = data.members
                                }else if(response[data.team] !== undefined && response[data.team] < data.members ){
                                    response[data.team] = data.members
                                }
                            });
                        });
                        
                        await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItemBefore[data.team+"_"+data.quest_id] = data
                                // if(questionType[data.quest_id] == undefined){
                                //     questionType[data.quest_id] = data.question_type
                                // }
                            });
                            firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("parent_team", "==", state.teamselected).where("quarter", "==", Number(state.quarterCompare.before)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    dataItemBefore[data.team+"_"+data.quest_id] = data
                                    // if(questionType[data.quest_id] == undefined){
                                    //     questionType[data.quest_id] = data.question_type
                                    // }
                                });
                                firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                                .then(function (querySnapshot) {
                                    querySnapshot.forEach(function (doc) {
                                        const data = doc.data();
                                        if(data.team !== undefined){
                                            dataItemBefore[data.team+"_"+data.type] = data
                                        }
                                    });
                                });
                                // commit('setQuestionType', questionType)
                            });
                        });
                        
                        await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItemAfter[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("parent_team", "==", state.teamselected).where("quarter", "==", Number(state.quarterCompare.after)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    dataItemAfter[data.team+"_"+data.quest_id] = data
                                });
                                firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                                .then(async function (querySnapshot) {
                                    querySnapshot.forEach(function (doc) {
                                        const data = doc.data();
                                        if(data.team !== undefined){
                                            dataItemAfter[data.team+"_"+data.type] = data
                                        }
                                    });
                                    let datatable:any = []
                                    // _.forOwn(dataItemAfter, function(value:any, key) {
                                    for (const [key, value] of Object.entries(dataItemAfter)) {
                                        if(dataItemBefore[key] !== undefined){
                                            let _tmp: { [key: string]: any } = {}
                                            _tmp = value;
                                            let temp_name = '';
                                            if(state.teamkeys[value.team]){
                                                temp_name = state.teamkeys[value.team].name
                                            }
                                            if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][value.quest_id]){
                                                let nps_score_after:any = 0
                                                let nps_score_before:any = 0
                                                if(value.answer && Object.keys(value.answer).length > 0){
                                                    let promotors:any = 0
                                                    let detractors:any = 0
                                                    for (const [key2, response] of Object.entries(value.answer)) {
                                                        let numKey = Number(key2);
                                                        if(numKey >= 0 && numKey <= 6){
                                                            detractors+= response
                                                        }else if(numKey >=9 && numKey <= 10){
                                                            promotors+= response
                                                        }
                                                    }
                                                    nps_score_after =((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                                }
                                                if(dataItemBefore[key] && dataItemBefore[key].answer && Object.keys(dataItemBefore[key].answer).length > 0){
                                                    let promotors:any = 0
                                                    let detractors:any = 0
                                                    for (const [key2, response] of Object.entries(dataItemBefore[key].answer)) {
                                                        let numKey = Number(key2);
                                                        if(numKey >= 0 && numKey <= 6){
                                                            detractors+= response
                                                        }else if(numKey >=9 && numKey <= 10){
                                                            promotors+= response
                                                        }
                                                    }
                                                    nps_score_before = ((promotors / Number(dataItemBefore[key].total)) - (detractors / Number(dataItemBefore[key].total)))*100
                                                }
                                                _tmp['percent'] = globalfunc.round(nps_score_after,0) - globalfunc.round(nps_score_before,0)
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }else if(_.find(state.questionSet1, function(o) { return o === _tmp.quest_id; })){ //WHO-5
                                                let datatableWHO5:any
                                                if(datatable.length > 0 && _tmp.team){
                                                    let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                    datatableWHO5 = _.filter(datatable, { 'quest_id': 'WHO-5', 'team': teamId })
                                                }
                                                if((!datatableWHO5 || datatableWHO5.length == 0) && value.team){
                                                    const dataTeamSelectBefore: Array<any> = [];
                                                    let percentBefore:any = 0
                                                    let percentAfter:any = 0
                                                    let dataSumBefore:any = 0;
                                                    let dataSumAfter:any = 0;
                                                    let maxmimumBefore:any = 0;
                                                    let maxmimumAfter:any = 0;
                                                    
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[1]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[2]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[3]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[4]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[5]])
                                                    if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                        for(let x=0; x<5; x++){
                                                            if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                                for(let y=0; y<6; y++){
                                                                    if(dataTeamSelectBefore[x].answer[y]){
                                                                        dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                        maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                        // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                    }else{
                                                        percentBefore = 0
                                                        // _tmp['percent'] = 0
                                                    }

                                                    const dataTeamSelectAfter: Array<any> = [];
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[1]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[2]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[3]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[4]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[5]])
                                                    if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                        for(let x=0; x<5; x++){
                                                            if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                                for(let y=0; y<6; y++){
                                                                    if(dataTeamSelectAfter[x].answer[y]){
                                                                        dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                        maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                        // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                    }else{
                                                        percentAfter = 0
                                                        // _tmp['percent'] = 0
                                                    }
                                                    _tmp['quest_id'] = 'WHO-5'
                                                    let total:any = percentAfter - percentBefore
                                                    _tmp['percent'] = total.toFixed(1) * 1
                                                    _tmp['teamid'] = value.team;
                                                    _tmp['team'] = temp_name;
                                                    datatable.push(_tmp);
                                                }
                                            }else if(_.find(state.questionSet2, function(o) { return o === _tmp.quest_id; })){ // eRes
                                                let datatableeRes:any
                                                if(datatable.length > 0 && _tmp.team){
                                                    let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                    datatableeRes = _.filter(datatable, { 'quest_id': 'eRes', 'team': teamId })
                                                }
                                                if((!datatableeRes || datatableeRes.length == 0) && value.team){
                                                    const dataTeamSelectBefore: Array<any> = [];
                                                    let percentBefore:any = 0
                                                    let percentAfter:any = 0
                                                    let dataSumBefore:any = 0;
                                                    let dataSumAfter:any = 0;
                                                    let maxmimumBefore:any = 0;
                                                    let maxmimumAfter:any = 0;
                                                    
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[1]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[2]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[3]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[4]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[5]])
                                                    if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                        for(let x=0; x<5; x++){
                                                            if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                                for(let y=0; y<6; y++){
                                                                    if(dataTeamSelectBefore[x].answer[y]){
                                                                        dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                        maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    }else{
                                                        percentBefore = 0
                                                    }

                                                    const dataTeamSelectAfter: Array<any> = [];
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[1]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[2]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[3]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[4]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[5]])
                                                    if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                        for(let x=0; x<5; x++){
                                                            if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                                for(let y=0; y<6; y++){
                                                                    if(dataTeamSelectAfter[x].answer[y]){
                                                                        dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                        maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                    }
                                                                }
                                                            }
                                                        }
                                                        percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    }else{
                                                        percentAfter = 0
                                                    }
                                                    _tmp['quest_id'] = 'eRes'
                                                    let total:any = percentAfter - percentBefore
                                                    _tmp['percent'] = total.toFixed(1) * 1
                                                    _tmp['teamid'] = value.team;
                                                    _tmp['team'] = temp_name;
                                                    datatable.push(_tmp);
                                                }
                                            }else if(_.find(state.questionSet3, function(o) { return o === _tmp.quest_id; }) || _.find(questionCultureCustom, function(o) { return o === _tmp.quest_id; })){ // Culture
                                                // Check if Culture data already exists for this team
                                                let datatableCulture:any
                                                if(datatable.length > 0 && _tmp.team){
                                                    let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                    datatableCulture = _.filter(datatable, { 'quest_id': 'Culture', 'team': teamId })
                                                }
                                                
                                                if((!datatableCulture || datatableCulture.length == 0) && value.team){
                                                    let percentBefore:any = 0
                                                    let percentAfter:any = 0
                                                    
                                                    // Calculate percentBefore and percentAfter based on custom or default questions
                                                    if(questionCultureCustom.length > 0){
                                                        // Custom calculation (auto-detects Scale vs MC)
                                                        const calculateCustomPercent = (dataSource: any) => {
                                                            let dataSum = 0;
                                                            let maxmimum = 0;
                                                            const dataTeamSelect: Array<any> = [];
                                                            
                                                            for(const question of questionCultureCustom){
                                                                dataTeamSelect.push(dataSource[value.team+"_"+question])
                                                            }
                                                            
                                                            for(let i=0; i<dataTeamSelect.length; i++){
                                                                if(dataTeamSelect[i] && Object.keys(dataTeamSelect[i]).length > 0){
                                                                    let questId = dataTeamSelect[i].quest_id
                                                                    if(questionMasterArr[questId]){
                                                                        const result = globalfunc.calculateCultureScore(questionMasterArr, questId, dataTeamSelect[i].answer);
                                                                        dataSum += result.dataSum;
                                                                        maxmimum += result.total;
                                                                    }
                                                                }
                                                            }
                                                            
                                                            const percent = ((dataSum * 100) / maxmimum);
                                                            return isNaN(percent) ? 0 : percent;
                                                        };
                                                        
                                                        percentBefore = calculateCustomPercent(dataItemBefore);
                                                        percentAfter = calculateCustomPercent(dataItemAfter);
                                                    }else{
                                                        // Default calculation using questionSet3
                                                        const calculateDefaultPercent = (dataSource: any) => {
                                                            let dataSum = 0;
                                                            let maxmimum = 0;
                                                            const dataTeamSelect: Array<any> = [];
                                                            
                                                            for(let i=1; i<=5; i++){
                                                                dataTeamSelect.push(dataSource[value.team+"_"+state.questionSet3[i]])
                                                            }
                                                            
                                                            const allValid = dataTeamSelect.every((item, idx) => 
                                                                item && Object.keys(item).length > 0
                                                            );
                                                            
                                                            if(allValid){
                                                                for(let x=0; x<5; x++){
                                                                    if(dataTeamSelect[x] && dataTeamSelect[x].answer && Object.keys(dataTeamSelect[x].answer).length > 0){
                                                                        for(let y=0; y<6; y++){
                                                                            if(dataTeamSelect[x].answer[y]){
                                                                                dataSum += (dataTeamSelect[x].answer[y]) * (5 - y)
                                                                                maxmimum += dataTeamSelect[x].answer[y] * 5
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                                return ((dataSum * 100) / maxmimum);
                                                            }
                                                            return 0;
                                                        };
                                                        
                                                        percentBefore = calculateDefaultPercent(dataItemBefore);
                                                        percentAfter = calculateDefaultPercent(dataItemAfter);
                                                    }
                                                    
                                                    // Set final values and push to datatable
                                                    _tmp['quest_id'] = 'Culture'
                                                    let total:any = percentAfter - percentBefore
                                                    _tmp['percent'] = total.toFixed(1) * 1
                                                    _tmp['teamid'] = value.team;
                                                    _tmp['team'] = temp_name;
                                                    datatable.push(_tmp);
                                                }
                                            }else if(_.find(state.questionSet4, function(o) { return o === _tmp.type; })){ // DEBI
                                                let datatableDEBI:any
                                                if(datatable.length > 0 && _tmp.team){
                                                    let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                    datatableDEBI = _.filter(datatable, { 'type': 'DEBI', 'team': teamId })
                                                }
                                                if((!datatableDEBI || datatableDEBI.length == 0) && value.team){
                                                    const dataTeamSelectBefore: Array<any> = [];
                                                    let percentBefore:any = 0
                                                    let percentAfter:any = 0
                                                    let dataSumBefore:any = 0;
                                                    let dataSumAfter:any = 0;
                                                    
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[1]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[2]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[3]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[4]])
                                                    dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[5]])
                                                    if(dataTeamSelectBefore[0] || dataTeamSelectBefore[1] || dataTeamSelectBefore[2] || dataTeamSelectBefore[3] || dataTeamSelectBefore[4]){
                                                        for(let x=0; x<5; x++){
                                                            if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && dataTeamSelectBefore[x].total){
                                                                // dataSumBefore += ((dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total) * state.questionSet4_weight[dataTeamSelectBefore[x].type])
                                                                let score = (dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total)
                                                                let weight = state.questionSet4_weight[dataTeamSelectBefore[x].type]
                                                                let max = state.questionSet4_max[dataTeamSelectBefore[x].type]
                                                                if(score > max){
                                                                    score = 1
                                                                }else{
                                                                    score = score/max
                                                                }
                                                                score = score * weight
                                                                dataSumBefore += score
                                                            }
                                                        }
                                                        percentBefore = dataSumBefore * 100
                                                    }else{
                                                        percentBefore = 0
                                                    }

                                                    const dataTeamSelectAfter: Array<any> = [];
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[1]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[2]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[3]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[4]])
                                                    dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[5]])
                                                    if(dataTeamSelectAfter[0] || dataTeamSelectAfter[1] || dataTeamSelectAfter[2] || dataTeamSelectAfter[3] || dataTeamSelectAfter[4]){
                                                        for(let x=0; x<5; x++){
                                                            if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && dataTeamSelectAfter[x].total){
                                                                // dataSumAfter += ((dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total) * state.questionSet4_weight[dataTeamSelectAfter[x].type])
                                                                let score = (dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total)
                                                                let weight = state.questionSet4_weight[dataTeamSelectAfter[x].type]
                                                                let max = state.questionSet4_max[dataTeamSelectAfter[x].type]
                                                                if(score > max){
                                                                    score = 1
                                                                }else{
                                                                    score = score/max
                                                                }
                                                                score = score * weight
                                                                dataSumAfter += score
                                                            }
                                                        }
                                                        percentAfter = dataSumAfter * 100
                                                    }else{
                                                        percentAfter = 0
                                                    }
                                                    _tmp['type'] = 'DEBI'
                                                    let total:any = percentAfter - percentBefore
                                                    _tmp['percent'] = total.toFixed(1) * 1
                                                    _tmp['teamid'] = value.team;
                                                    _tmp['team'] = temp_name;
                                                    datatable.push(_tmp);
                                                }
                                            }else if(_.find(state.questionSet5, function(o) { return o === _tmp.quest_id; })){ // Index & Variance
                                                // Index
                                                let datatableIndex:any
                                                if(datatable.length > 0 && _tmp.team){
                                                    let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                    datatableIndex = _.filter(datatable, { 'quest_id': 'Index', 'team': teamId })
                                                }
                                                if((!datatableIndex || datatableIndex.length == 0) && value.team){
                                                    const dataTeamSelectBefore:any = {};
                                                    let percentBefore:any = 0
                                                    let percentAfter:any = 0
                                                    for(let i = 1; i < 9; i++){
                                                        let response = dataItemBefore[value.team+"_"+state.questionSet5[i]]
                                                        if(response && Object.keys(response).length > 0 && response.answer){
                                                            dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                            let dataAnswer:any = []
                                                            for(const choice in response.answer){
                                                                dataAnswer.push([Number(choice),response.answer[choice]])
                                                            }
                                                            dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                    
                                                        }
                                                    }
                                                    if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                        try {
                                                            const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                            const results = await dispatch('calculateMetrics', _averages);
                                                            percentBefore = results.alignmentIndex * 1;
                                                        } catch (error) {
                                                            console.error('Error calculating Index:', error);
                                                            percentBefore = 0
                                                        }
                                                    } else {
                                                        percentBefore = 0
                                                    }

                                                    const dataTeamSelectAfter:any = {};
                                                    for(let i = 1; i < 9; i++){
                                                        let response = dataItemAfter[value.team+"_"+state.questionSet5[i]]
                                                        if(response && Object.keys(response).length > 0 && response.answer){
                                                            dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                            let dataAnswer:any = []
                                                            for(const choice in response.answer){
                                                                dataAnswer.push([Number(choice),response.answer[choice]])
                                                            }
                                                            dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                    
                                                        }
                                                    }
                                                    if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                        try {
                                                            const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                            const results = await dispatch('calculateMetrics', _averages);
                                                            percentAfter = results.alignmentIndex * 1;
                                                        } catch (error) {
                                                            console.error('Error calculating Index:', error);
                                                            percentAfter = 0
                                                        }
                                                    } else {
                                                        percentAfter = 0
                                                    }
                                                    _tmp['quest_id'] = 'Index'
                                                    let total:any = percentAfter - percentBefore
                                                    _tmp['percent'] = total.toFixed(1) * 1
                                                    _tmp['teamid'] = value.team;
                                                    _tmp['team'] = temp_name;
                                                    datatable.push(_tmp);
                                                }

                                                //Variance
                                                let datatableVariance:any
                                                if(datatable.length > 0 && _tmp.team){
                                                    let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                    datatableVariance = _.filter(datatable, { 'quest_id': 'Variance', 'team': teamId })
                                                }
                                                if((!datatableVariance || datatableVariance.length == 0) && value.team){
                                                    const dataTeamSelectBefore:any = {};
                                                    let percentBefore:any = 0
                                                    let percentAfter:any = 0
                                                    for(let i = 1; i < 9; i++){
                                                        let response = dataItemBefore[value.team+"_"+state.questionSet5[i]]
                                                        if(response && Object.keys(response).length > 0 && response.answer){
                                                            dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                            let dataAnswer:any = []
                                                            for(const choice in response.answer){
                                                                dataAnswer.push([Number(choice),response.answer[choice]])
                                                            }
                                                            dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                    
                                                        }
                                                    }
                                                    if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                        try {
                                                            const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                            const results = await dispatch('calculateMetrics', _averages);
                                                            percentBefore = results.consistencyScore * 1;
                                                        } catch (error) {
                                                            console.error('Error calculating Index:', error);
                                                            percentBefore = 0
                                                        }
                                                    } else {
                                                        percentBefore = 0
                                                    }

                                                    const dataTeamSelectAfter:any = {};
                                                    for(let i = 1; i < 9; i++){
                                                        let response = dataItemAfter[value.team+"_"+state.questionSet5[i]]
                                                        if(response && Object.keys(response).length > 0 && response.answer){
                                                            dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                            let dataAnswer:any = []
                                                            for(const choice in response.answer){
                                                                dataAnswer.push([Number(choice),response.answer[choice]])
                                                            }
                                                            dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                    
                                                        }
                                                    }
                                                    if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                        try {
                                                            const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                            const results = await dispatch('calculateMetrics', _averages);
                                                            percentAfter = results.consistencyScore * 1;
                                                        } catch (error) {
                                                            console.error('Error calculating Index:', error);
                                                            percentAfter = 0
                                                        }
                                                    } else {
                                                        percentAfter = 0
                                                    }
                                                    _tmp['quest_id'] = 'Variance'
                                                    let total:any = percentAfter - percentBefore
                                                    _tmp['percent'] = total.toFixed(1) * 1
                                                    _tmp['teamid'] = value.team;
                                                    _tmp['team'] = temp_name;
                                                    datatable.push(_tmp);
                                                }
                                            }else if(_tmp.question_type == 'Scale'){
                                                _tmp['percent'] = (value.percent.toFixed(1) * 1) - (dataItemBefore[key].percent.toFixed(1) * 1)
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }else{
                                                _tmp['percent'] = Math.ceil(value.percent) - Math.ceil(dataItemBefore[key].percent)
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                            // _tmp['teamid'] = value.team;
                                            // _tmp['team'] = temp_name;
                                            // datatable.push(_tmp);
                                        }
                                    };
                                    commit('setAllResponse', response)
                                    commit('setDataTableAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                    dispatch('getDataTablebyTeam', { team: '', type: 'parent' })
                                });
                            });
                        });
                        
                    }else{
                        await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                        .then(async function (querySnapshot) {
                            const response: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                response[data.team] = data.members
                            });
                            commit('setAllResponse', response)
                        });
                        firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quarter", "==", Number(state.quarterSelected.id)).get()
                            .then(function (querySnapshot) {
                                const datatable: Array<any> = [];
                                querySnapshot.forEach(function (doc) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = doc.data();
                                    let temp_name = '';
                                    if(state.teamkeys[doc.data().team]){
                                        temp_name = state.teamkeys[doc.data().team].name
                                    }
                
                                    _tmp['teamid'] = doc.data().team;
                                    _tmp['team'] = temp_name;
                                    // if(questionType[_tmp.quest_id] == undefined){
                                    //     questionType[_tmp.quest_id] = _tmp.question_type
                                    // }
                                    datatable.push(_tmp);
                                });
                                firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("parent_team", "==", state.teamselected).where("quarter", "==", Number(state.quarterSelected.id)).get()
                                .then(function (querySnapshot) {
                                    querySnapshot.forEach(function (doc) {
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = doc.data();
                                        let temp_name = '';
                                        if(state.teamkeys[doc.data().team]){
                                        temp_name = state.teamkeys[doc.data().team].name
                                        }
                    
                                        _tmp['teamid'] = doc.data().team;
                                        _tmp['team'] = temp_name;
                                        // if(questionType[_tmp.quest_id] == undefined){
                                        //     questionType[_tmp.quest_id] = _tmp.question_type
                                        // }
                                        datatable.push(_tmp);
                                    });

                                    firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                                    .then(function (querySnapshot) {
                                        querySnapshot.forEach(function (doc) {
                                            let _tmp: { [key: string]: any } = {}
                                            _tmp = doc.data();
                                            if(_tmp.team !== undefined){
                                                let temp_name = '';
                                                if(state.teamkeys[doc.data().team]){
                                                temp_name = state.teamkeys[doc.data().team].name
                                                }
                            
                                                _tmp['teamid'] = doc.data().team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        });
                                        commit('setDataTableAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                        dispatch('getDataTablebyTeam', { team: '', type: 'parent' })
                                    });
                                });
                            });
                        // const questionType: Array<any> = [];
                    }
                    
                }
            }
        },
        async getDataTablebyCohort({ commit, state, dispatch, rootState }: any, data: any) {
            // let response: Array<any> = []; 
            // if(!state.cohortSelected){
            //     response = state.datalistallCohort
            // }else{
            //     response = _.filter(state.datalistallCohort, { 'id': state.cohortSelected })
            // }
            const questionMasterArr = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            let cohortSelected: Array<any> = [];
            if(!state.cohortSelected){
                cohortSelected = state.allCohortOrderd
            }else{
                let item = state.allCohort[state.cohortSelected]
                item.key = state.cohortSelected
                item.value = item.name
                cohortSelected.push(item)
            }
            if(cohortSelected.length > 1){
                /*** Set 1st Row ***/
                let tableData:any = [];
                let temp: Array<any> = [];
                temp.push('MOST RECENT SCORES')
                // temp.push("")
                _.forEach(cohortSelected, function (value) {
                    if (value.key) {
                        let _tmp2 = value;
                        _tmp2['type'] = 'child'
                        temp.push(value.key)
                    }
                });
                temp.push("*")
                tableData.push(temp)

                /*** Set 2nd Row ***/
                let temp2: Array<any> = [];
                temp2.push('NO. OF RESPONSES')
                // temp2.push(state.allResponseCohorts[state.cohortSelected])
                _.forEach(cohortSelected, function (value) {
                    if (value.key) {
                        temp2.push(state.allResponseCohorts[value.key])
                    }
                });
                temp2.push("*")
                tableData.push(temp2)

                for(const x in state.questionMasterByCategory){
                    /*** Next Row ***/
                    let tempCategory: Array<any> = [];
                    let tableDataByCategory:any = [];
                    tempCategory.push(x)
                    tableData.push(tempCategory)
                    // _.forEach(state.questionMasterByCategory[x], function (value, key) {
                    for (const key of Object.keys(state.questionMasterByCategory[x])) {
                        let temp3: Array<any> = [];
                        let overAll:any = 0;
                        if(x == 'set1' && key == 'WHO-5'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'WHO-5' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                let maxmimum:any = 0;
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[1] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[2] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[3] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[4] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[5] }))
                                if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelect[x][0].answer[y]){
                                                    dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                    maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                    total = total * 1
                                    overAll = total
                                }else{
                                    overAll = -999;
                                }
                            }
                            // }else{
                            //     overAll = -999;
                            // }
                        }else if(x == 'set1' && key == 'eRes'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'eRes' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                let maxmimum:any = 0;
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[1] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[2] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[3] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[4] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[5] }))
                                if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelect[x][0].answer[y]){
                                                    dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                    maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                    total = total * 1
                                    overAll = total
                                }else{
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'set1' && key == 'Culture'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Culture' })
                                overAll = dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : -999;
                            }else{
                                let dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                let maxmimum:any = 0;
                                
                                // Determine which questions to use
                                const questionsToUse = questionCultureCustom.length > 0 
                                    ? questionCultureCustom 
                                    : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                
                                // Collect data for all questions
                                for(const question of questionsToUse){
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': question }))
                                }
                                
                                // Check if all required data exists
                                // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                // For questionSet3: only calculate if ALL questions have answers
                                const hasAllData = questionCultureCustom.length > 0
                                    ? true  // Always calculate for custom questions
                                    : dataTeamSelect.every(item => item.length > 0);
                                
                                if(hasAllData){
                                    for(let i=0; i<dataTeamSelect.length; i++){
                                        if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                            if(questionCultureCustom.length > 0){
                                                // Custom calculation (auto-detects Scale vs MC)
                                                const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                dataSum += result.dataSum;
                                                maxmimum += result.total;
                                            }else{
                                                // Default calculation for questionSet3
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelect[i][0].answer[y]){
                                                        dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                        maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    // Only calculate if we have some data (maxmimum > 0)
                                    if(maxmimum > 0){
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        overAll = total * 1
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'engagement' && key == 'DEBI'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': 'DEBI' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[1] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[2] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[3] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[4] }))
                                dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[5] }))
                                if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                            // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                            let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                            let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                            let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                            if(score > max){
                                                score = 1
                                            }else{
                                                score = score/max
                                            }
                                            score = score * weight
                                            dataSum += score
                                        }
                                    }
                                    let total:any = (dataSum * 100).toFixed(1)
                                    total = total * 1
                                    overAll = total
                                }else{
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'strategic_alignment' && key == 'Index'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Index' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const teamResponses:any = {};
                                for(let i = 1; i < 9; i++){
                                    let response = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet5[i] })
                                    if(response && response.length > 0 && response[0].answer){
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer:any = []
                                        for(const choice in response[0].answer){
                                            dataAnswer.push([Number(choice),response[0].answer[choice]])
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer

                                    }
                                }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        overAll = results.alignmentIndex * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        overAll = -999;
                                    }
                                } else {
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'strategic_alignment' && key == 'Variance'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Variance' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const teamResponses:any = {};
                                  for(let i = 1; i < 9; i++){
                                    let response = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet5[i] })
                                    if(response && response.length > 0 && response[0].answer){
                                        
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer:any = []
                                        for(const choice in response[0].answer){
                                            dataAnswer.push([Number(choice),response[0].answer[choice]])
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer

                                    }
                                  }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        overAll = results.consistencyScore * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        overAll = -999;
                                    }
                                } else {
                                    overAll = -999;
                                }
                            }
                        }else{
                            const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': key })
                            if(dataTeamSelect.length > 0){
                                if(x == 'nps'){
                                    if(state.quarterSelected.type == 'compare'){
                                        overAll = Math.ceil(dataTeamSelect[0]['percent']);
                                    }else{
                                        if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                                            let promotors:any = 0
                                            let detractors:any = 0
                                            let nps_score:any = 0
                                            _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                                                if(key >= 0 && key <= 6){
                                                    detractors+= value
                                                }else if(key >=9 && key <= 10){
                                                    promotors+= value
                                                }
                                            });
                                            nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                                            let total:any = globalfunc.round(nps_score,0)
                                            overAll = total
                                        }
                                    }
                                }else if(dataTeamSelect[0]['question_type'] == 'Scale'){
                                    overAll = (dataTeamSelect[0]['percent'].toFixed(1)) * 1;
                                }else{
                                    overAll = Math.ceil(dataTeamSelect[0]['percent']);
                                }
                            }else{
                                overAll = -999;
                            }
                        }
                        temp3.push(key)
                        // temp3.push(overAll)
                        for (const item of cohortSelected) {
                        // _.forEach(cohortSelected, function (item) {
                            if (item.key) {
                                if(x == 'set1' && key == 'WHO-5'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': 'WHO-5' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }else{
                                        const dataItemByQuestion: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet1[1] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet1[2] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet1[3] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet1[4] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet1[5] }))
                                        if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                            for(let x=0; x<5; x++){
                                                if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                    for(let y=0; y<6; y++){
                                                        if(dataItemByQuestion[x][0].answer[y]){
                                                            dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                            maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            total = total * 1
                                            temp3.push(total)
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }
                                    // }else{
                                    //     temp3.push('-')
                                    // }
                                }else if(x == 'set1' && key == 'eRes'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': 'eRes' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }else{
                                        const dataItemByQuestion: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet2[1] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet2[2] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet2[3] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet2[4] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet2[5] }))
                                        if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                            for(let x=0; x<5; x++){
                                                if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                    for(let y=0; y<6; y++){
                                                        if(dataItemByQuestion[x][0].answer[y]){
                                                            dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                            maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            total = total * 1
                                            temp3.push(total)
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }
                                }else if(x == 'set1' && key == 'Culture'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': 'Culture' })
                                        temp3.push(dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : -999);
                                    }else{
                                        let dataTeamSelect: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        
                                        // Determine which questions to use
                                        const questionsToUse = questionCultureCustom.length > 0 
                                            ? questionCultureCustom 
                                            : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                        
                                        // Collect data for all questions
                                        for(const question of questionsToUse){
                                            dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': question }))
                                        }
                                        
                                        // Check if all required data exists
                                        // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                        // For questionSet3: only calculate if ALL questions have answers
                                        const hasAllData = questionCultureCustom.length > 0
                                            ? true  // Always calculate for custom questions
                                            : dataTeamSelect.every(item => item.length > 0);
                                        
                                        if(hasAllData){
                                            for(let i=0; i<dataTeamSelect.length; i++){
                                                if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                                    if(questionCultureCustom.length > 0){
                                                        // Custom calculation (auto-detects Scale vs MC)
                                                        const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                        dataSum += result.dataSum;
                                                        maxmimum += result.total;
                                                    }else{
                                                        // Default calculation for questionSet3
                                                        for(let y=0; y<6; y++){
                                                            if(dataTeamSelect[i][0].answer[y]){
                                                                dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                                maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            // Only calculate if we have some data (maxmimum > 0)
                                            if(maxmimum > 0){
                                                let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                                temp3.push(total * 1)
                                            }else{
                                                temp3.push(-999);
                                            }
                                        }else{
                                            temp3.push(-999);
                                        }
                                    }
                                }else if(x == 'engagement' && key == 'DEBI'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'type': 'DEBI' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }else{
                                        const dataItemByQuestion: Array<any> = [];
                                        let dataSum:any = 0;
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'type': state.questionSet4[1] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'type': state.questionSet4[2] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'type': state.questionSet4[3] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'type': state.questionSet4[4] }))
                                        dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': item.key, 'type': state.questionSet4[5] }))
                                        if(dataItemByQuestion[0].length > 0 || dataItemByQuestion[1].length > 0 || dataItemByQuestion[2].length > 0 || dataItemByQuestion[3].length > 0 || dataItemByQuestion[4].length > 0){
                                            for(let x=0; x<5; x++){
                                                if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && dataItemByQuestion[x][0].total){
                                                    // dataSum += ((dataItemByQuestion[x][0].answer / dataItemByQuestion[x][0].total) * state.questionSet4_weight[dataItemByQuestion[x][0].type])
                                                    let score = (dataItemByQuestion[x][0].answer / dataItemByQuestion[x][0].total)
                                                    let weight = state.questionSet4_weight[dataItemByQuestion[x][0].type]
                                                    let max = state.questionSet4_max[dataItemByQuestion[x][0].type]
                                                    if(score > max){
                                                        score = 1
                                                    }else{
                                                        score = score/max
                                                    }
                                                    score = score * weight
                                                    dataSum += score
                                                }
                                            }
                                            let total:any = (dataSum * 100).toFixed(1)
                                            total = total * 1
                                            temp3.push(total)
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }
                                }else if(x == 'strategic_alignment' && key == 'Index'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': 'Index' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }else{
                                        const teamResponses:any = {};
                                          for(let i = 1; i < 9; i++){
                                            let response = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet5[i] })
                                            if(response && response.length > 0 && response[0].answer){
                                                
                                                teamResponses[state.questionSet5[i]] = [];
                                                let dataAnswer:any = []
                                                for(const choice in response[0].answer){
                                                    dataAnswer.push([Number(choice),response[0].answer[choice]])
                                                }
                                                teamResponses[state.questionSet5[i]] = dataAnswer
        
                                            }
                                          }
                                        if (Object.keys(teamResponses).length > 0) {
                                            try {
                                                const _averages = await dispatch('calculateAverage', teamResponses);
                                                const results = await dispatch('calculateMetrics', _averages);
                                                let total:any = results.alignmentIndex * 1;
                                                temp3.push(total)
                                            } catch (error) {
                                                console.error('Error calculating Index:', error);
                                                temp3.push('-')
                                            }
                                        } else {
                                            temp3.push(-999)
                                        }
                                    }
                                }else if(x == 'strategic_alignment' && key == 'Variance'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': 'Variance' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push(-999)
                                        }
                                    }else{
                                        const teamResponses:any = {};
                                          for(let i = 1; i < 9; i++){
                                            let response = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': state.questionSet5[i] })
                                            if(response && response.length > 0 && response[0].answer){
                                                
                                                teamResponses[state.questionSet5[i]] = [];
                                                let dataAnswer:any = []
                                                for(const choice in response[0].answer){
                                                    dataAnswer.push([Number(choice),response[0].answer[choice]])
                                                }
                                                teamResponses[state.questionSet5[i]] = dataAnswer
        
                                            }
                                          }
                                        if (Object.keys(teamResponses).length > 0) {
                                            try {
                                                const _averages = await dispatch('calculateAverage', teamResponses);
                                                const results = await dispatch('calculateMetrics', _averages);
                                                let total:any = results.consistencyScore * 1;
                                                temp3.push(total)
                                            } catch (error) {
                                                console.error('Error calculating Index:', error);
                                                temp3.push(-999)
                                            }
                                        } else {
                                            temp3.push(-999)
                                        }
                                    }
                                }else{
                                    const dataItemByQuestion:any = _.filter(state.datalistallCohort, { 'teamid': item.key, 'quest_id': key })
                                    if(dataItemByQuestion.length > 0){
                                        if(x == 'nps'){
                                            if(state.quarterSelected.type == 'compare'){
                                                temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                            }else{
                                                if(dataItemByQuestion[0] && dataItemByQuestion[0].answer && Object.keys(dataItemByQuestion[0].answer).length > 0){
                                                    let promotors:any = 0
                                                    let detractors:any = 0
                                                    let nps_score:any = 0
                                                    _.forEach(dataItemByQuestion[0].answer, function (value, key:number) {
                                                        if(key >= 0 && key <= 6){
                                                            detractors+= value
                                                        }else if(key >=9 && key <= 10){
                                                            promotors+= value
                                                        }
                                                    });
                                                    nps_score = ((promotors / Number(dataItemByQuestion[0].total)) - (detractors / Number(dataItemByQuestion[0].total)))*100
                                                    let total:any = globalfunc.round(nps_score,0)
                                                    temp3.push(total)
                                                }
                                            }
                                        } else if(dataItemByQuestion[0]['question_type'] == 'Scale'){
                                            temp3.push((dataItemByQuestion[0]['percent'].toFixed(1)) * 1)
                                        }else{
                                            temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                        }
                                    }else{
                                        temp3.push(-999)
                                    }
                                }
                            }
                        }
                        temp3.push("*")
                        tableDataByCategory.push(temp3)
                    }
                    if(state.sortBy == 'lowest'){
                        tableDataByCategory.sort((a, b) => {
                            if (a[0] === 'Index') return -1;
                            if (b[0] === 'Index') return 1;
                            if(a[1] == -999 && b[1] == -999){
                                return (a[1] - b[1]) * -1; 
                            }else if(a[1] == -999 || b[1] == -999){
                                let x = (a[1] == -999)?a[1]: 0;
                                let y = (b[1] == -999)?b[1]: 0;
                                return y - x;
                            }else{
                                return (b[1] - a[1]) * -1; 
                            }
                        });
                    }else if(state.sortBy == 'highest'){
                        tableDataByCategory.sort((a, b) => {
                            if (a[0] === 'Index') return -1;
                            if (b[0] === 'Index') return 1;
                            return b[1] - a[1];
                        });
                    }
                    tableData = _.concat(tableData, tableDataByCategory);
                }
                commit('setDataTable', tableData)
                if(state.TempDatatableAllCohort.length == 0){
                    if(tableData.length > 2){
                        commit('setTempDataTableAllCohort', tableData)
                    }
                }
            }else{
                if(state.cohortSelected){
                    let tableData: any = [];

                    // let _tmp: Array<any> = [];
                    // _tmp['team_id'] = state.cohortSelected
                    // _tmp['type'] = 'child'
                    // state.teamsetup[state.cohortSelected] = _tmp

                    /*** Set 1st Row ***/
                    let temp: Array<any> = [];
                    temp.push('MOST RECENT SCORES')
                    // temp.push('Overall')
                    temp.push(state.cohortSelected)
                    tableData.push(temp)
                    
                    /*** Set 2nd Row ***/
                    let temp2: Array<any> = [];
                    temp2.push('NO. OF RESPONSES')
                    // temp2.push(state.allResponse[state.cohortSelected])
                    temp2.push(state.allResponseCohorts[state.cohortSelected])
                    // let totalAll = 0;
                    // _.forEach(datatable, function (value) {
                    //     totalAll += value.total
                    // });
                    // temp2[1] = totalAll;
                    // temp2.push(totalAll)
                    tableData.push(temp2)
                    for(const x in state.questionMasterByCategory){
                        /*** Next Row ***/
                        let tempCategory: Array<any> = [];
                        let tableDataByCategory:any = [];
                        tempCategory.push(x)
                        tableData.push(tempCategory)
                        _.forEach(state.questionMasterByCategory[x], function (value, key) {
                            let temp3: Array<any> = [];
                            let overAll:any = 0;
                            if(x == 'set1' && key == 'WHO-5'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'WHO-5' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[5] }))
                                    if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelect[x][0].answer[y]){
                                                        dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        overAll = total
                                    }else{
                                        overAll = -999;
                                    }
                                }
                                // }else{
                                //     overAll = -999;
                                // }
                            }else if(x == 'set1' && key == 'eRes'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'eRes' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[5] }))
                                    if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelect[x][0].answer[y]){
                                                        dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        overAll = total
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'set1' && key == 'Culture'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Culture' })
                                    overAll = dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : -999;
                                }else{
                                    let dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    
                                    // Determine which questions to use
                                    const questionsToUse = questionCultureCustom.length > 0 
                                        ? questionCultureCustom 
                                        : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                    
                                    // Collect data for all questions
                                    for(const question of questionsToUse){
                                        dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': question }))
                                    }
                                    
                                    // Check if all required data exists
                                    // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                    // For questionSet3: only calculate if ALL questions have answers
                                    const hasAllData = questionCultureCustom.length > 0
                                        ? true  // Always calculate for custom questions
                                        : dataTeamSelect.every(item => item.length > 0);
                                    
                                    if(hasAllData){
                                        for(let i=0; i<dataTeamSelect.length; i++){
                                            if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                    dataSum += result.dataSum;
                                                    maxmimum += result.total;
                                                }else{
                                                    // Default calculation for questionSet3
                                                    for(let y=0; y<6; y++){
                                                        if(dataTeamSelect[i][0].answer[y]){
                                                            dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                            maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // Only calculate if we have some data (maxmimum > 0)
                                        if(maxmimum > 0){
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            overAll = total * 1
                                        }else{
                                            overAll = -999;
                                        }
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'engagement' && key == 'DEBI'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': 'DEBI' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[5] }))
                                    if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                                // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                                let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                                let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                                let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                                if(score > max){
                                                    score = 1
                                                }else{
                                                    score = score/max
                                                }
                                                score = score * weight
                                                dataSum += score
                                            }
                                        }
                                        let total:any = (dataSum * 100).toFixed(1)
                                        total = total * 1
                                        overAll = total
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Index'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Index' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.alignmentIndex
                                            total = total * 1
                                            overAll = total
                                        });
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Variance'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Variance' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.consistencyScore
                                            total = total * 1
                                            overAll = total
                                        });
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else{
                                const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': key })
                                if(dataTeamSelect.length > 0){
                                    if(x == 'nps'){
                                        if(state.quarterSelected.type == 'compare'){
                                            overAll = Math.ceil(dataTeamSelect[0]['percent'])
                                        }else{
                                            if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                                            let promotors:any = 0
                                            let detractors:any = 0
                                            let nps_score:any = 0
                                            _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                                                if(key >= 0 && key <= 6){
                                                    detractors+= value
                                                }else if(key >=9 && key <= 10){
                                                    promotors+= value
                                                }
                                            });
                                            nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                                            let total:any = globalfunc.round(nps_score,0)
                                            overAll = total
                                        }
                                        }
                                    }else if(dataTeamSelect[0]['question_type'] == 'Scale'){
                                        overAll = (dataTeamSelect[0]['percent'].toFixed(1)) * 1;
                                    }else{
                                        overAll = Math.ceil(dataTeamSelect[0]['percent']);
                                    }
                                }else{
                                    overAll = -999;
                                }
                            }
                            temp3.push(key)
                            // temp3.push(overAll)
                            if(x == 'set1' && key == 'WHO-5'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'WHO-5' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push(-999)
                                    }
                                }else{
                                    const dataItemByQuestion: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[1] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[2] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[3] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[4] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet1[5] }))
                                    if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataItemByQuestion[x][0].answer[y]){
                                                        dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        temp3.push(total)
                                    }else{
                                        temp3.push(-999)
                                    }
                                }
                                // }else{
                                //     temp3.push('-')
                                // }
                            }else if(x == 'set1' && key == 'eRes'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'eRes' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push(-999)
                                    }
                                }else{
                                    const dataItemByQuestion: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[1] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[2] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[3] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[4] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet2[5] }))
                                    if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataItemByQuestion[x][0].answer[y]){
                                                        dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        temp3.push(total)
                                    }else{
                                        temp3.push(-999)
                                    }
                                }
                            }else if(x == 'set1' && key == 'Culture'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Culture' })
                                    temp3.push(dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : -999);
                                }else{
                                    let dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    
                                    // Determine which questions to use
                                    const questionsToUse = questionCultureCustom.length > 0 
                                        ? questionCultureCustom 
                                        : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                    
                                    // Collect data for all questions
                                    for(const question of questionsToUse){
                                        dataTeamSelect.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': question }))
                                    }
                                    
                                    // Check if all required data exists
                                    // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                    // For questionSet3: only calculate if ALL questions have answers
                                    const hasAllData = questionCultureCustom.length > 0
                                        ? true  // Always calculate for custom questions
                                        : dataTeamSelect.every(item => item.length > 0);
                                    
                                    if(hasAllData){
                                        for(let i=0; i<dataTeamSelect.length; i++){
                                            if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                    dataSum += result.dataSum;
                                                    maxmimum += result.total;
                                                }else{
                                                    // Default calculation for questionSet3
                                                    for(let y=0; y<6; y++){
                                                        if(dataTeamSelect[i][0].answer[y]){
                                                            dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                            maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // Only calculate if we have some data (maxmimum > 0)
                                        if(maxmimum > 0){
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            temp3.push(total * 1)
                                        }else{
                                            temp3.push(-999);
                                        }
                                    }else{
                                        temp3.push(-999);
                                    }
                                }
                            }else if(x == 'engagement' && key == 'DEBI'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': 'DEBI' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push(-999)
                                    }
                                }else{
                                    const dataItemByQuestion: Array<any> = [];
                                    let dataSum:any = 0;
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[1] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[2] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[3] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[4] }))
                                    dataItemByQuestion.push(_.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'type': state.questionSet4[5] }))
                                    if(dataItemByQuestion[0].length > 0 || dataItemByQuestion[1].length > 0 || dataItemByQuestion[2].length > 0 || dataItemByQuestion[3].length > 0 || dataItemByQuestion[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && dataItemByQuestion[x][0].total){
                                                // dataSum += ((dataItemByQuestion[x][0].answer / dataItemByQuestion[x][0].total) * state.questionSet4_weight[dataItemByQuestion[x][0].type])
                                                let score = (dataItemByQuestion[x][0].answer / dataItemByQuestion[x][0].total)
                                                let weight = state.questionSet4_weight[dataItemByQuestion[x][0].type]
                                                let max = state.questionSet4_max[dataItemByQuestion[x][0].type]
                                                if(score > max){
                                                    score = 1
                                                }else{
                                                    score = score/max
                                                }
                                                score = score * weight
                                                dataSum += score
                                            }
                                        }
                                        let total:any = (dataSum * 100).toFixed(1)
                                        total = total * 1
                                        temp3.push(total)
                                    }else{
                                        temp3.push(-999)
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Index'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Index' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push(-999)
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.alignmentIndex
                                            total = total * 1
                                            temp3.push(total)
                                        });
                                    }else{
                                        temp3.push(-999)
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Variance'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': 'Variance' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push(-999)
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.consistencyScore
                                            total = total * 1
                                            temp3.push(total)
                                        });
                                    }else{
                                        temp3.push(-999)
                                    }
                                }
                            }else{
                                const dataItemByQuestion:any = _.filter(state.datalistallCohort, { 'teamid': state.cohortSelected, 'quest_id': key })
                                if(dataItemByQuestion.length > 0){
                                    if(x == 'nps'){
                                        if(state.quarterSelected.type == 'compare'){
                                            temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                        }else{
                                            if(dataItemByQuestion[0] && dataItemByQuestion[0].answer && Object.keys(dataItemByQuestion[0].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                let nps_score:any = 0
                                                _.forEach(dataItemByQuestion[0].answer, function (value, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= value
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= value
                                                    }
                                                });
                                                nps_score = ((promotors / Number(dataItemByQuestion[0].total)) - (detractors / Number(dataItemByQuestion[0].total)))*100
                                                let total:any = globalfunc.round(nps_score,0)
                                                temp3.push(total)
                                            }
                                        }
                                    }else if(dataItemByQuestion[0]['question_type'] == 'Scale'){
                                        temp3.push((dataItemByQuestion[0]['percent'].toFixed(1)) * 1)
                                    }else{
                                        temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                    }
                                }else{
                                    temp3.push(-999)
                                }
                            }
                            tableDataByCategory.push(temp3)
                        });
                        if(state.sortBy == 'lowest'){
                            tableDataByCategory.sort((a, b) => {
                                if (a[0] === 'Index') return -1;
                                if (b[0] === 'Index') return 1;
                                if(a[1] == -999 && b[1] == -999){
                                    return (a[1] - b[1]) * -1; 
                                }else if(a[1] == -999 || b[1] == -999){
                                    let x = (a[1] == -999)?a[1]: 0;
                                    let y = (b[1] == -999)?b[1]: 0;
                                    return y - x;
                                }else{
                                    return (b[1] - a[1]) * -1; 
                                }
                            });
                        }else if(state.sortBy == 'highest'){
                            tableDataByCategory.sort((a, b) => {
                                if (a[0] === 'Index') return -1;
                                if (b[0] === 'Index') return 1;
                                return b[1] - a[1];
                            });
                        }
                        tableData = _.concat(tableData, tableDataByCategory);
                    }
                    commit('setDataTable', tableData)
                    if(state.TempDatatableAllCohort.length == 0){
                        if(tableData.length > 2){
                            commit('setTempDataTableAllCohort', tableData)
                        }
                    }
                }
            }
        },
        async getDataTablebyTeamScoreHistoryMonthly({ commit, state, dispatch, rootState }: any, obj: any) {
            let tableData:any = [];
            let tableLabel:any = [];
            let ScoreData:any = [];
            let selectedId:any = ''
            let questId = obj.questId
            let type = obj.type
            if(type == 'team'){
                selectedId = state.teamselected
            }else if(type == 'cohort'){
                if(obj.cohortId == 'all'){
                    selectedId = state.teamHeight
                }else{
                    selectedId = obj.cohortId
                }
            }
            for(const dateofmonth in state.allQuarterScoreHistoryMonthly){
                const dataTeamSelect:any = _.filter(state.datalistallScoreHistoryMonthly, { 'teamid': selectedId, 'quest_id': questId, 'date': dateofmonth })
                if(dataTeamSelect.length > 0){
                    if(dataTeamSelect[0]['question_type'] == 'Scale'){
                        tableData.push((dataTeamSelect[0]['percent'].toFixed(1)) * 1)
                        ScoreData.push({value:(dataTeamSelect[0]['percent'].toFixed(1)) * 1, date:dateofmonth})
                    }else{
                        tableData.push(Math.ceil(dataTeamSelect[0]['percent']))
                        ScoreData.push({value:Math.ceil(dataTeamSelect[0]['percent']), date:dateofmonth})
                    }
                    let month = format(dateofmonth, 'MMM')
                    let year = format(dateofmonth, 'YYYY')
                    tableLabel.push(String(month)+" "+ String(year))
                }
            }
            let max_change:any
            let ScoreDataSort = _.orderBy(ScoreData,['value', 'date'], ['desc', 'desc'])
            let maxScore = ScoreDataSort[0]
            let minScore = ScoreDataSort[ScoreDataSort.length - 1]
            if(maxScore.value == minScore.value){
                max_change = 0
            }else if(maxScore.date > minScore.date){
                if(minScore.value == 0){
                    max_change = '-'
                }else{
                    max_change =  ( ( maxScore.value - minScore.value) / minScore.value ) * 100
                }
            }else{
                if(maxScore.value == 0){
                    max_change = '-'
                }else{
                    max_change = ( (minScore.value - maxScore.value ) / maxScore.value ) * 100
                }
            }
            
            commit('setChartDataMaxChange',max_change)
            commit('setChartDataScoreHistory',tableData)
            commit('setChartLabelScoreHistory',tableLabel)
        },
        async getDataTablebyTeamScoreHistory({ commit, state, dispatch, rootState }: any, obj: any) {
            let tableData:any = [];
            let tableLabel:any = [];
            let ScoreData:any = [];
            let selectedId:any = ''
            let questId = obj.questId
            let type = obj.type
            const questionMasterArr = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            if(type == 'team'){
                selectedId = state.teamselected
            }else if(type == 'cohort'){
                if(obj.cohortId == 'all'){
                    selectedId = state.teamHeight
                }else{
                    selectedId = obj.cohortId
                }
            }
            for(const quarter in state.allQuarterScoreHistory){
                if(questId == 'WHO-5'){
                    const dataTeamSelect: Array<any> = [];
                    let dataSum:any = 0;
                    let maxmimum:any = 0;
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet1[1], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet1[2], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet1[3], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet1[4], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet1[5], 'quarter': Number(quarter) }))
                    if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                        for(let x=0; x<5; x++){
                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                for(let y=0; y<6; y++){
                                    if(dataTeamSelect[x][0].answer[y]){
                                        dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                        maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                    }
                                }
                            }
                        }
                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                        total = total * 1
                        tableData.push(total)
                        let year = Number(quarter.substr(0,4))
                        let runQ = Number(quarter.substr(4,1))
                        tableLabel.push("Q"+String(runQ)+" "+ String(year))
                        ScoreData.push({value:total, date:quarter})
                    }
                }else if(questId == 'eRes'){
                    const dataTeamSelect: Array<any> = [];
                    let dataSum:any = 0;
                    let maxmimum:any = 0;
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet2[1], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet2[2], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet2[3], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet2[4], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet2[5], 'quarter': Number(quarter) }))
                    if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                        for(let x=0; x<5; x++){
                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                for(let y=0; y<6; y++){
                                    if(dataTeamSelect[x][0].answer[y]){
                                        dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                        maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                    }
                                }
                            }
                        }
                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                        total = total * 1
                        tableData.push(total)
                        let year = Number(quarter.substr(0,4))
                        let runQ = Number(quarter.substr(4,1))
                        tableLabel.push("Q"+String(runQ)+" "+ String(year))
                        ScoreData.push({value:total, date:quarter})
                    }
                }else if(questId == 'Culture'){
                    let dataTeamSelect: Array<any> = [];
                    let dataSum:any = 0;
                    let maxmimum:any = 0;
                    
                    // Determine which questions to use
                    const questionsToUse = questionCultureCustom.length > 0 
                        ? questionCultureCustom 
                        : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                    
                    // Collect data for all questions
                    for(const question of questionsToUse){
                        dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': question, 'quarter': Number(quarter) }))
                    }
                    
                    // Check if all required data exists
                    // For questionCultureCustom: always calculate (even if some questions don't have answers)
                    // For questionSet3: only calculate if ALL questions have answers
                    const hasAllData = questionCultureCustom.length > 0
                        ? true  // Always calculate for custom questions
                        : dataTeamSelect.every(item => item.length > 0);
                    
                    if(hasAllData){
                        for(let i=0; i<dataTeamSelect.length; i++){
                            if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                if(questionCultureCustom.length > 0){
                                    // Custom calculation (auto-detects Scale vs MC)
                                    const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                    dataSum += result.dataSum;
                                    maxmimum += result.total;
                                }else{
                                    // Default calculation for questionSet3
                                    for(let y=0; y<6; y++){
                                        if(dataTeamSelect[i][0].answer[y]){
                                            dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                            maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                        }
                                    }
                                }
                            }
                        }
                        // Only calculate if we have some data (maxmimum > 0)
                        if(maxmimum > 0){
                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                            total = total * 1
                            tableData.push(total)
                            let year = Number(quarter.substr(0,4))
                            let runQ = Number(quarter.substr(4,1))
                            tableLabel.push("Q"+String(runQ)+" "+ String(year))
                            ScoreData.push({value:total, date:quarter})
                        }
                    }
                }else if(questId == 'DEBI'){
                    const dataTeamSelect: Array<any> = [];
                    let dataSum:any = 0;
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'type': state.questionSet4[1], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'type': state.questionSet4[2], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'type': state.questionSet4[3], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'type': state.questionSet4[4], 'quarter': Number(quarter) }))
                    dataTeamSelect.push(_.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'type': state.questionSet4[5], 'quarter': Number(quarter) }))
                    if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                        for(let x=0; x<5; x++){
                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                if(score > max){
                                    score = 1
                                }else{
                                    score = score/max
                                }
                                score = score * weight
                                dataSum += score
                            }
                        }
                        let total:any = (dataSum * 100).toFixed(1)
                        total = total * 1
                        tableData.push(total)
                        let year = Number(quarter.substr(0,4))
                        let runQ = Number(quarter.substr(4,1))
                        tableLabel.push("Q"+String(runQ)+" "+ String(year))
                        ScoreData.push({value:total, date:quarter})
                    }
                }else if(questId == 'Index'){
                    const dataTeamSelect:any = {};
                    for(let i = 1; i < 9; i++){
                        let response = _.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet5[i], 'quarter': Number(quarter) })
                        if(response && response.length > 0 && response[0].answer){
                            dataTeamSelect[state.questionSet5[i]] = [];
                            let dataAnswer:any = []
                            for(const choice in response[0].answer){
                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                            }
                            dataTeamSelect[state.questionSet5[i]] = dataAnswer

                        }
                    }
                    if (Object.keys(dataTeamSelect).length > 0) {
                        try {
                            const _averages = await dispatch('calculateAverage', dataTeamSelect);
                            const results = await dispatch('calculateMetrics', _averages);
                            let total:any = (results.alignmentIndex).toFixed(1)
                            total = total * 1
                            tableData.push(total)
                            let year = Number(quarter.substr(0,4))
                            let runQ = Number(quarter.substr(4,1))
                            tableLabel.push("Q"+String(runQ)+" "+ String(year))
                            ScoreData.push({value:total, date:quarter})
                        } catch (error) {
                            console.error('Error calculating Index:', error);
                            let total:any = 0
                            total = total * 1
                            tableData.push(total)
                            let year = Number(quarter.substr(0,4))
                            let runQ = Number(quarter.substr(4,1))
                            tableLabel.push("Q"+String(runQ)+" "+ String(year))
                            ScoreData.push({value:total, date:quarter})
                        }
                    } else {
                        let total:any = 0
                        total = total * 1
                        tableData.push(total)
                        let year = Number(quarter.substr(0,4))
                        let runQ = Number(quarter.substr(4,1))
                        tableLabel.push("Q"+String(runQ)+" "+ String(year))
                        ScoreData.push({value:total, date:quarter})
                    }
                }else if(questId == 'Variance'){
                    const dataTeamSelect:any = {};
                    for(let i = 1; i < 9; i++){
                        let response = _.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': state.questionSet5[i], 'quarter': Number(quarter) })
                        if(response && response.length > 0 && response[0].answer){
                            dataTeamSelect[state.questionSet5[i]] = [];
                            let dataAnswer:any = []
                            for(const choice in response[0].answer){
                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                            }
                            dataTeamSelect[state.questionSet5[i]] = dataAnswer

                        }
                    }
                    if (Object.keys(dataTeamSelect).length > 0) {
                        try {
                            const _averages = await dispatch('calculateAverage', dataTeamSelect);
                            const results = await dispatch('calculateMetrics', _averages);
                            let total:any = (results.consistencyScore).toFixed(1)
                            total = total * 1
                            tableData.push(total)
                            let year = Number(quarter.substr(0,4))
                            let runQ = Number(quarter.substr(4,1))
                            tableLabel.push("Q"+String(runQ)+" "+ String(year))
                            ScoreData.push({value:total, date:quarter})
                        } catch (error) {
                            console.error('Error calculating Index:', error);
                            let total:any = 0
                            total = total * 1
                            tableData.push(total)
                            let year = Number(quarter.substr(0,4))
                            let runQ = Number(quarter.substr(4,1))
                            tableLabel.push("Q"+String(runQ)+" "+ String(year))
                            ScoreData.push({value:total, date:quarter})
                        }
                    } else {
                        let total:any = 0
                        total = total * 1
                        tableData.push(total)
                        let year = Number(quarter.substr(0,4))
                        let runQ = Number(quarter.substr(4,1))
                        tableLabel.push("Q"+String(runQ)+" "+ String(year))
                        ScoreData.push({value:total, date:quarter})
                    }
                }else{
                    const dataTeamSelect:any = _.filter(state.datalistallScoreHistory, { 'teamid': selectedId, 'quest_id': questId, 'quarter': Number(quarter) })
                    if(dataTeamSelect.length > 0){
                        if(state.questionType[questId] == 'NPS' || state.questionType[questId] == 'eNPS'){
                            if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                                let promotors:any = 0
                                let detractors:any = 0
                                let nps_score:any = 0
                                _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                                    if(key >= 0 && key <= 6){
                                        detractors+= value
                                    }else if(key >=9 && key <= 10){
                                        promotors+= value
                                    }
                                });
                                nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                                let total:any = globalfunc.round(nps_score,0)
                                tableData.push((total && total > 0) ? `+` + total : total)
                                ScoreData.push({value:total, date:quarter})
                            }
                        }else if(dataTeamSelect[0]['question_type'] == 'Scale'){
                            tableData.push((dataTeamSelect[0]['percent'].toFixed(1)) * 1)
                            ScoreData.push({value:(dataTeamSelect[0]['percent'].toFixed(1)) * 1, date:quarter})
                        }else{
                            tableData.push(Math.ceil(dataTeamSelect[0]['percent']))
                            ScoreData.push({value:Math.ceil(dataTeamSelect[0]['percent']), date:quarter})
                        }
                        let year = Number(quarter.substr(0,4))
                        let runQ = Number(quarter.substr(4,1))
                        tableLabel.push("Q"+String(runQ)+" "+ String(year))
                    }
                }
            }
            let max_change:any
            let ScoreDataSort = _.orderBy(ScoreData,['value', 'date'], ['desc', 'desc'])
            let maxScore = ScoreDataSort[0]
            let minScore = ScoreDataSort[ScoreDataSort.length - 1]
            if(state.questionType[questId] == 'NPS' || state.questionType[questId] == 'eNPS'){
                if(maxScore.value == minScore.value){
                    max_change = 0
                }else if(maxScore.date > minScore.date){
                    max_change = maxScore.value - minScore.value
                }else{
                    max_change = minScore.value - maxScore.value
                }
            }else{
                if(maxScore.value == minScore.value){
                    max_change = 0
                }else if(maxScore.date > minScore.date){
                    if(minScore.value == 0){
                        max_change = '-'
                    }else{
                        max_change =  ( ( maxScore.value - minScore.value) / minScore.value ) * 100
                    }
                }else{
                    if(maxScore.value == 0){
                        max_change = '-'
                    }else{
                        max_change = ( (minScore.value - maxScore.value ) / maxScore.value ) * 100
                    }
                }
            }
            commit('setChartDataMaxChange',max_change)
            commit('setChartDataScoreHistory',tableData)
            commit('setChartLabelScoreHistory',tableLabel)
        },
        async getDataTablebyTeam({ commit, state, dispatch, rootState }: any, data: any) {
            const organizations = state.organizations
            const teams = organizations[state.teamselected]
            const questionMasterArr = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            const datatable = _.filter(state.datalistall, { 'teamid': state.teamselected })
            if (teams !== undefined) {
                const teamsetup: Array<any> = [];

                /*** Set 1st Row ***/
                let tableData:any = [];
                let temp: Array<any> = [];
                temp.push('MOST RECENT SCORES')
                // temp.push('Overall')
                temp.push(teams.team_id)
                _.forEach(teams.parent, function (value) {
                    if (value.team_id) {
                        let _tmp2 = value;
                        if(_tmp2.parent){
                            _tmp2['type'] = 'parent'
                            _tmp2['status'] = 'collapse'
                        }else{
                            _tmp2['type'] = 'child'
                        }
                        teamsetup[value.team_id] = _tmp2
                        // temp.push(state.teamkeys[value.team_id].name)
                        temp.push(value.team_id)
                    }
                });
                temp.push("*")
                tableData.push(temp)

                /*** Set 2nd Row ***/
                let temp2: Array<any> = [];
                temp2.push('NO. OF RESPONSES')
                temp2.push(state.allResponse[state.teamselected])
                _.forEach(teams.parent, function (value) {
                    if (value.team_id) {
                        temp2.push(state.allResponse[value.team_id])
                    }
                });
                temp2.push("*")
                tableData.push(temp2)
                for(const x in state.questionMasterByCategory){
                    /*** Next Row ***/
                    let tempCategory: Array<any> = [];
                    let tableDataByCategory:any = [];
                    tempCategory.push(x)
                    tableData.push(tempCategory)
                    // _.forEach(state.questionMasterByCategory[x], function (value, key) {
                    for (const key of Object.keys(state.questionMasterByCategory[x])) {
                        let temp3: Array<any> = [];
                        let overAll:any = 0;
                        if(x == 'set1' && key == 'WHO-5'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'WHO-5' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                let maxmimum:any = 0;
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[1] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[2] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[3] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[4] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[5] }))
                                if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelect[x][0].answer[y]){
                                                    dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                    maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                    total = total * 1
                                    overAll = total
                                }else{
                                    overAll = -999;
                                }
                            }
                            // }else{
                            //     overAll = -999;
                            // }
                        }else if(x == 'set1' && key == 'eRes'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'eRes' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                let maxmimum:any = 0;
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[1] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[2] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[3] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[4] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[5] }))
                                if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                            for(let y=0; y<6; y++){
                                                if(dataTeamSelect[x][0].answer[y]){
                                                    dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                    maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                }
                                            }
                                        }
                                    }
                                    let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                    total = total * 1
                                    overAll = total
                                }else{
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'set1' && key == 'Culture'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Culture' })
                                overAll = dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : -999;
                            }else{
                                let dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                let maxmimum:any = 0;
                                
                                // Determine which questions to use
                                const questionsToUse = questionCultureCustom.length > 0 
                                    ? questionCultureCustom 
                                    : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                
                                // Collect data for all questions
                                for(const question of questionsToUse){
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': question }))
                                }
                                
                                // Check if all required data exists
                                // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                // For questionSet3: only calculate if ALL questions have answers
                                const hasAllData = questionCultureCustom.length > 0
                                    ? true  // Always calculate for custom questions
                                    : dataTeamSelect.every(item => item.length > 0);
                                
                                if(hasAllData){
                                    for(let i=0; i<dataTeamSelect.length; i++){
                                        if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                            if(questionCultureCustom.length > 0){
                                                // Custom calculation (auto-detects Scale vs MC)
                                                const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                dataSum += result.dataSum;
                                                maxmimum += result.total;
                                            }else{
                                                // Default calculation for questionSet3
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelect[i][0].answer[y]){
                                                        dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                        maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    // Only calculate if we have some data (maxmimum > 0)
                                    if(maxmimum > 0){
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        overAll = total * 1
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'engagement' && key == 'DEBI'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'type': 'DEBI' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const dataTeamSelect: Array<any> = [];
                                let dataSum:any = 0;
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[1] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[2] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[3] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[4] }))
                                dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[5] }))
                                if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                    for(let x=0; x<5; x++){
                                        if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                            // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                            let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                            let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                            let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                            if(score > max){
                                                score = 1
                                            }else{
                                                score = score/max
                                            }
                                            score = score * weight
                                            dataSum += score
                                        }
                                    }
                                    let total:any = (dataSum * 100).toFixed(1)
                                    total = total * 1
                                    overAll = total
                                }else{
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'strategic_alignment' && key == 'Index'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Index' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const teamResponses:any = {};
                                for(let i = 1; i < 9; i++){
                                    let response = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet5[i] })
                                    if(response && response.length > 0 && response[0].answer){
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer:any = []
                                        for(const choice in response[0].answer){
                                            dataAnswer.push([Number(choice),response[0].answer[choice]])
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer

                                    }
                                }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        overAll = results.alignmentIndex * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        overAll = -999;
                                    }
                                } else {
                                    overAll = -999;
                                }
                            }
                        }else if(x == 'strategic_alignment' && key == 'Variance'){
                            if(state.quarterSelected.type == 'compare'){
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Variance' })
                                if(dataTeamSelect.length > 0){
                                    overAll = dataTeamSelect[0]['percent'];
                                }else{
                                    overAll = -999;
                                }
                            }else{
                                const teamResponses:any = {};
                                  for(let i = 1; i < 9; i++){
                                    let response = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet5[i] })
                                    if(response && response.length > 0 && response[0].answer){
                                        
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer:any = []
                                        for(const choice in response[0].answer){
                                            dataAnswer.push([Number(choice),response[0].answer[choice]])
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer

                                    }
                                  }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        overAll = results.consistencyScore * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        overAll = -999;
                                    }
                                } else {
                                    overAll = -999;
                                }
                            }
                        }else{
                            const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': key })
                            if(dataTeamSelect.length > 0){
                                if(x == 'nps'){
                                    if(state.quarterSelected.type == 'compare'){
                                        overAll = Math.ceil(dataTeamSelect[0]['percent']);
                                    }else{
                                        if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                                            let promotors:any = 0
                                            let detractors:any = 0
                                            let nps_score:any = 0
                                            _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                                                if(key >= 0 && key <= 6){
                                                    detractors+= value
                                                }else if(key >=9 && key <= 10){
                                                    promotors+= value
                                                }
                                            });
                                            nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                                            let total:any = globalfunc.round(nps_score,0)
                                            overAll = total
                                        }
                                    }
                                }else if(dataTeamSelect[0]['question_type'] == 'Scale'){
                                    overAll = (dataTeamSelect[0]['percent'].toFixed(1)) * 1;
                                }else{
                                    overAll = Math.ceil(dataTeamSelect[0]['percent']);
                                }
                            }else{
                                overAll = -999;
                            }
                        }
                        temp3.push(key)
                        temp3.push(overAll)
                        // _.forEach(teams.parent, function (item) {
                        for (const item of teams.parent) {
                            if (item.team_id) {
                                if(x == 'set1' && key == 'WHO-5'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': 'WHO-5' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push('-')
                                        }
                                    }else{
                                        const dataItemByQuestion: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet1[1] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet1[2] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet1[3] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet1[4] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet1[5] }))
                                        if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                            for(let x=0; x<5; x++){
                                                if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                    for(let y=0; y<6; y++){
                                                        if(dataItemByQuestion[x][0].answer[y]){
                                                            dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                            maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            total = total * 1
                                            temp3.push(total)
                                        }else{
                                            temp3.push('-')
                                        }
                                    }
                                    // }else{
                                    //     temp3.push('-')
                                    // }
                                }else if(x == 'set1' && key == 'eRes'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': 'eRes' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push('-')
                                        }
                                    }else{
                                        const dataItemByQuestion: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet2[1] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet2[2] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet2[3] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet2[4] }))
                                        dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet2[5] }))
                                        if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                            for(let x=0; x<5; x++){
                                                if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                    for(let y=0; y<6; y++){
                                                        if(dataItemByQuestion[x][0].answer[y]){
                                                            dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                            maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            total = total * 1
                                            temp3.push(total)
                                        }else{
                                            temp3.push('-')
                                        }
                                    }
                                }else if(x == 'set1' && key == 'Culture'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': 'Culture' })
                                        temp3.push(dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : '-');
                                    }else{
                                        let dataTeamSelect: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        
                                        // Determine which questions to use
                                        const questionsToUse = questionCultureCustom.length > 0 
                                            ? questionCultureCustom 
                                            : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                        
                                        // Collect data for all questions
                                        for(const question of questionsToUse){
                                            dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': question }))
                                        }
                                        
                                        // Check if all required data exists
                                        // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                        // For questionSet3: only calculate if ALL questions have answers
                                        const hasAllData = questionCultureCustom.length > 0
                                            ? true  // Always calculate for custom questions
                                            : dataTeamSelect.every(item => item.length > 0);
                                        
                                        if(hasAllData){
                                            for(let i=0; i<dataTeamSelect.length; i++){
                                                if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                                    if(questionCultureCustom.length > 0){
                                                        // Custom calculation (auto-detects Scale vs MC)
                                                        const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                        dataSum += result.dataSum;
                                                        maxmimum += result.total;
                                                    }else{
                                                        // Default calculation for questionSet3
                                                        for(let y=0; y<6; y++){
                                                            if(dataTeamSelect[i][0].answer[y]){
                                                                dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                                maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                            // Only calculate if we have some data (maxmimum > 0)
                                            if(maxmimum > 0){
                                                let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                                temp3.push(total * 1)
                                            }else{
                                                temp3.push('-');
                                            }
                                        }else{
                                            temp3.push('-');
                                        }
                                    }
                                }else if(x == 'engagement' && key == 'DEBI'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'type': 'DEBI' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push('-')
                                        }
                                    }else{
                                        const dataTeamSelect: Array<any> = [];
                                        let dataSum:any = 0;
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'type': state.questionSet4[1] }))
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'type': state.questionSet4[2] }))
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'type': state.questionSet4[3] }))
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'type': state.questionSet4[4] }))
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': item.team_id, 'type': state.questionSet4[5] }))
                                        if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                            for(let x=0; x<5; x++){
                                                if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                                    // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                                    let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                                    let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                                    let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                                    if(score > max){
                                                        score = 1
                                                    }else{
                                                        score = score/max
                                                    }
                                                    score = score * weight
                                                    dataSum += score
                                                }
                                            }
                                            let total:any = (dataSum * 100).toFixed(1)
                                            total = total * 1
                                            temp3.push(total)
                                        }else{
                                            temp3.push('-')
                                        }
                                    }
                                }else if(x == 'strategic_alignment' && key == 'Index'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': 'Index' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push('-')
                                        }
                                    }else{
                                        const teamResponses:any = {};
                                          for(let i = 1; i < 9; i++){
                                            let response = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet5[i] })
                                            if(response && response.length > 0 && response[0].answer){
                                                
                                                teamResponses[state.questionSet5[i]] = [];
                                                let dataAnswer:any = []
                                                for(const choice in response[0].answer){
                                                    dataAnswer.push([Number(choice),response[0].answer[choice]])
                                                }
                                                teamResponses[state.questionSet5[i]] = dataAnswer
        
                                            }
                                          }
                                        if (Object.keys(teamResponses).length > 0) {
                                            try {
                                                const _averages = await dispatch('calculateAverage', teamResponses);
                                                const results = await dispatch('calculateMetrics', _averages);
                                                let total:any = results.alignmentIndex * 1;
                                                temp3.push(total)
                                            } catch (error) {
                                                console.error('Error calculating Index:', error);
                                                temp3.push('-')
                                            }
                                        } else {
                                            temp3.push('-')
                                        }
                                    }
                                }else if(x == 'strategic_alignment' && key == 'Variance'){
                                    if(state.quarterSelected.type == 'compare'){
                                        const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': 'Variance' })
                                        if(dataTeamSelect.length > 0){
                                            temp3.push(dataTeamSelect[0]['percent'])
                                        }else{
                                            temp3.push('-')
                                        }
                                    }else{
                                        const teamResponses:any = {};
                                          for(let i = 1; i < 9; i++){
                                            let response = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': state.questionSet5[i] })
                                            if(response && response.length > 0 && response[0].answer){
                                                
                                                teamResponses[state.questionSet5[i]] = [];
                                                let dataAnswer:any = []
                                                for(const choice in response[0].answer){
                                                    dataAnswer.push([Number(choice),response[0].answer[choice]])
                                                }
                                                teamResponses[state.questionSet5[i]] = dataAnswer
        
                                            }
                                          }
                                        if (Object.keys(teamResponses).length > 0) {
                                            try {
                                                const _averages = await dispatch('calculateAverage', teamResponses);
                                                const results = await dispatch('calculateMetrics', _averages);
                                                let total:any = results.consistencyScore * 1;
                                                temp3.push(total)
                                            } catch (error) {
                                                console.error('Error calculating Index:', error);
                                                temp3.push('-')
                                            }
                                        } else {
                                            temp3.push('-')
                                        }
                                    }
                                }else{
                                    const dataItemByQuestion:any = _.filter(state.datalistall, { 'teamid': item.team_id, 'quest_id': key })
                                    if(dataItemByQuestion.length > 0){
                                        if(x == 'nps'){
                                            if(state.quarterSelected.type == 'compare'){
                                                temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                            }else{
                                                if(dataItemByQuestion[0] && dataItemByQuestion[0].answer && Object.keys(dataItemByQuestion[0].answer).length > 0){
                                                    let promotors:any = 0
                                                    let detractors:any = 0
                                                    let nps_score:any = 0
                                                    _.forEach(dataItemByQuestion[0].answer, function (value, key:number) {
                                                        if(key >= 0 && key <= 6){
                                                            detractors+= value
                                                        }else if(key >=9 && key <= 10){
                                                            promotors+= value
                                                        }
                                                    });
                                                    nps_score = ((promotors / Number(dataItemByQuestion[0].total)) - (detractors / Number(dataItemByQuestion[0].total)))*100
                                                    let total:any = globalfunc.round(nps_score,0)
                                                    temp3.push(total)
                                                }
                                            }
                                        } else if(dataItemByQuestion[0]['question_type'] == 'Scale'){
                                            temp3.push((dataItemByQuestion[0]['percent'].toFixed(1)) * 1)
                                        }else{
                                            temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                        }
                                    }else{
                                        temp3.push('-')
                                    }
                                }
                            }
                        }
                        temp3.push("*")
                        tableDataByCategory.push(temp3)
                    }
                    if(state.sortBy == 'lowest'){
                        tableDataByCategory.sort((a, b) => {
                            if (a[0] === 'Index') return -1;
                            if (b[0] === 'Index') return 1;
                            if(a[1] == -999 && b[1] == -999){
                                return (a[1] - b[1]) * -1; 
                            }else if(a[1] == -999 || b[1] == -999){
                                let x = (a[1] == -999)?a[1]: 0;
                                let y = (b[1] == -999)?b[1]: 0;
                                return y - x;
                            }else{
                                return (b[1] - a[1]) * -1; 
                            }
                        });
                    }else if(state.sortBy == 'highest'){
                        tableDataByCategory.sort((a, b) => {
                            if (a[0] === 'Index') return -1;
                            if (b[0] === 'Index') return 1;
                            return b[1] - a[1];
                        });
                    }
                    tableData = _.concat(tableData, tableDataByCategory);
                }
                // if(state.sortBy == 'lowest'){
                //     tableData.sort((a, b) => {
                //         if(a[0] != 'NO. OF RESPONSES' && b[0] != 'NO. OF RESPONSES' && a[0] != 'MOST RECENT SCORES' && b[0] != 'MOST RECENT SCORES' && a[1] != undefined && b[1] != undefined){
                //             if(a[1] == -999 && b[1] == -999){
                //                 return (a[1] - b[1]) * -1; 
                //             }else if(a[1] == -999 || b[1] == -999){
                //                 let x = (a[1] == -999)?a[1]: 0;
                //                 let y = (b[1] == -999)?b[1]: 0;
                //                 return y - x;
                //             }else{
                //                 return (b[1] - a[1]) * -1; 
                //             }
                //         }
                //     });
                // }else if(state.sortBy == 'highest'){
                //     tableData.sort((a, b) => {
                //         if(a[0] != 'NO. OF RESPONSES' && b[0] != 'NO. OF RESPONSES' && a[0] != 'MOST RECENT SCORES' && b[0] != 'MOST RECENT SCORES' && a[1] != undefined && b[1] != undefined){
                //             return b[1] - a[1];
                //         }
                //     });
                // }
                commit('setTeamSetup', teamsetup)
                commit('setDataTable', tableData)
                if(state.TempDatatableAllTeam.length == 0 && tableData.length > 2){
                    commit('setTempDataTableAllTeam', tableData)
                }
            }else{
                if(state.teamselected){
                    let tableData: any = [];

                    // let _tmp: Array<any> = [];
                    // _tmp['team_id'] = state.teamselected
                    // _tmp['type'] = 'child'
                    // state.teamsetup[state.teamselected] = _tmp

                    /*** Set 1st Row ***/
                    let temp: Array<any> = [];
                    temp.push('MOST RECENT SCORES')
                    // temp.push('Overall')
                    temp.push(state.teamselected)
                    tableData.push(temp)
                    
                    /*** Set 2nd Row ***/
                    let temp2: Array<any> = [];
                    temp2.push('NO. OF RESPONSES')
                    // temp2.push(state.allResponse[state.teamselected])
                    temp2.push(state.allResponse[state.teamselected])
                    // let totalAll = 0;
                    // _.forEach(datatable, function (value) {
                    //     totalAll += value.total
                    // });
                    // temp2[1] = totalAll;
                    // temp2.push(totalAll)
                    tableData.push(temp2)
                    for(const x in state.questionMasterByCategory){
                        /*** Next Row ***/
                        let tempCategory: Array<any> = [];
                        let tableDataByCategory:any = [];
                        tempCategory.push(x)
                        tableData.push(tempCategory)
                        _.forEach(state.questionMasterByCategory[x], function (value, key) {
                            let temp3: Array<any> = [];
                            let overAll:any = 0;
                            if(x == 'set1' && key == 'WHO-5'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'WHO-5' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[5] }))
                                    if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelect[x][0].answer[y]){
                                                        dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        overAll = total
                                    }else{
                                        overAll = -999;
                                    }
                                }
                                // }else{
                                //     overAll = -999;
                                // }
                            }else if(x == 'set1' && key == 'eRes'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'eRes' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[5] }))
                                    if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && Object.keys(dataTeamSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataTeamSelect[x][0].answer[y]){
                                                        dataSum += (dataTeamSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataTeamSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        overAll = total
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'set1' && key == 'Culture'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Culture' })
                                    overAll = dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : -999;
                                }else{
                                    let dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    
                                    // Determine which questions to use
                                    const questionsToUse = questionCultureCustom.length > 0 
                                        ? questionCultureCustom 
                                        : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                    
                                    // Collect data for all questions
                                    for(const question of questionsToUse){
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': question }))
                                    }
                                    
                                    // Check if all required data exists
                                    // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                    // For questionSet3: only calculate if ALL questions have answers
                                    const hasAllData = questionCultureCustom.length > 0
                                        ? true  // Always calculate for custom questions
                                        : dataTeamSelect.every(item => item.length > 0);
                                    
                                    if(hasAllData){
                                        for(let i=0; i<dataTeamSelect.length; i++){
                                            if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                    dataSum += result.dataSum;
                                                    maxmimum += result.total;
                                                }else{
                                                    // Default calculation for questionSet3
                                                    for(let y=0; y<6; y++){
                                                        if(dataTeamSelect[i][0].answer[y]){
                                                            dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                            maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // Only calculate if we have some data (maxmimum > 0)
                                        if(maxmimum > 0){
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            overAll = total * 1
                                        }else{
                                            overAll = -999;
                                        }
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'engagement' && key == 'DEBI'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'type': 'DEBI' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[5] }))
                                    if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                                // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                                let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                                let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                                let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                                if(score > max){
                                                    score = 1
                                                }else{
                                                    score = score/max
                                                }
                                                score = score * weight
                                                dataSum += score
                                            }
                                        }
                                        let total:any = (dataSum * 100).toFixed(1)
                                        total = total * 1
                                        overAll = total
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Index'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Index' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.alignmentIndex
                                            total = total * 1
                                            overAll = total
                                        });
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Variance'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Variance' })
                                    if(dataTeamSelect.length > 0){
                                        overAll = dataTeamSelect[0]['percent'];
                                    }else{
                                        overAll = -999;
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.consistencyScore
                                            total = total * 1
                                            overAll = total
                                        });
                                    }else{
                                        overAll = -999;
                                    }
                                }
                            }else{
                                const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': key })
                                if(dataTeamSelect.length > 0){
                                    if(x == 'nps'){
                                        if(state.quarterSelected.type == 'compare'){
                                            overAll = Math.ceil(dataTeamSelect[0]['percent'])
                                        }else{
                                            if(dataTeamSelect[0] && dataTeamSelect[0].answer && Object.keys(dataTeamSelect[0].answer).length > 0){
                                            let promotors:any = 0
                                            let detractors:any = 0
                                            let nps_score:any = 0
                                            _.forEach(dataTeamSelect[0].answer, function (value, key:number) {
                                                if(key >= 0 && key <= 6){
                                                    detractors+= value
                                                }else if(key >=9 && key <= 10){
                                                    promotors+= value
                                                }
                                            });
                                            nps_score = ((promotors / Number(dataTeamSelect[0].total)) - (detractors / Number(dataTeamSelect[0].total)))*100
                                            let total:any = globalfunc.round(nps_score,0)
                                            overAll = total
                                        }
                                        }
                                    }else if(dataTeamSelect[0]['question_type'] == 'Scale'){
                                        overAll = (dataTeamSelect[0]['percent'].toFixed(1)) * 1;
                                    }else{
                                        overAll = Math.ceil(dataTeamSelect[0]['percent']);
                                    }
                                }else{
                                    overAll = -999;
                                }
                            }
                            temp3.push(key)
                            // temp3.push(overAll)
                            if(x == 'set1' && key == 'WHO-5'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'WHO-5' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push('-')
                                    }
                                }else{
                                    const dataItemByQuestion: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[1] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[2] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[3] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[4] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet1[5] }))
                                    if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataItemByQuestion[x][0].answer[y]){
                                                        dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        temp3.push(total)
                                    }else{
                                        temp3.push('-')
                                    }
                                }
                            }else if(x == 'set1' && key == 'eRes'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'eRes' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push('-')
                                    }
                                }else{
                                    const dataItemByQuestion: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[1] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[2] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[3] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[4] }))
                                    dataItemByQuestion.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet2[5] }))
                                    if(dataItemByQuestion[0].length > 0 && dataItemByQuestion[1].length > 0 && dataItemByQuestion[2].length > 0 && dataItemByQuestion[3].length > 0 && dataItemByQuestion[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataItemByQuestion[x][0] && dataItemByQuestion[x][0].answer && Object.keys(dataItemByQuestion[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataItemByQuestion[x][0].answer[y]){
                                                        dataSum += (dataItemByQuestion[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataItemByQuestion[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                        total = total * 1
                                        temp3.push(total)
                                    }else{
                                        temp3.push('-')
                                    }
                                }
                            }else if(x == 'set1' && key == 'Culture'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Culture' })
                                    temp3.push(dataTeamSelect.length > 0 ? dataTeamSelect[0]['percent'] : '-');
                                }else{
                                    let dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    
                                    // Determine which questions to use
                                    const questionsToUse = questionCultureCustom.length > 0 
                                        ? questionCultureCustom 
                                        : [state.questionSet3[1], state.questionSet3[2], state.questionSet3[3], state.questionSet3[4], state.questionSet3[5]];
                                    
                                    // Collect data for all questions
                                    for(const question of questionsToUse){
                                        dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': question }))
                                    }
                                    
                                    // Check if all required data exists
                                    // For questionCultureCustom: always calculate (even if some questions don't have answers)
                                    // For questionSet3: only calculate if ALL questions have answers
                                    const hasAllData = questionCultureCustom.length > 0
                                        ? true  // Always calculate for custom questions
                                        : dataTeamSelect.every(item => item.length > 0);
                                    
                                    if(hasAllData){
                                        for(let i=0; i<dataTeamSelect.length; i++){
                                            if(dataTeamSelect[i][0] && dataTeamSelect[i][0].answer && Object.keys(dataTeamSelect[i][0].answer).length > 0){
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, dataTeamSelect[i][0].quest_id, dataTeamSelect[i][0].answer);
                                                    dataSum += result.dataSum;
                                                    maxmimum += result.total;
                                                }else{
                                                    // Default calculation for questionSet3
                                                    for(let y=0; y<6; y++){
                                                        if(dataTeamSelect[i][0].answer[y]){
                                                            dataSum += (dataTeamSelect[i][0].answer[y]) * (5 - y)
                                                            maxmimum += dataTeamSelect[i][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        // Only calculate if we have some data (maxmimum > 0)
                                        if(maxmimum > 0){
                                            let total:any = (((dataSum * 100) / maxmimum).toFixed(1))
                                            temp3.push(total * 1)
                                        }else{
                                            temp3.push('-');
                                        }
                                    }else{
                                        temp3.push('-');
                                    }
                                }
                            }else if(x == 'engagement' && key == 'DEBI'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'type': 'DEBI' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push('-')
                                    }
                                }else{
                                    const dataTeamSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[1] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[2] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[3] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[4] }))
                                    dataTeamSelect.push(_.filter(state.datalistall, { 'teamid': state.teamselected, 'type': state.questionSet4[5] }))
                                    if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                        for(let x=0; x<5; x++){
                                            if(dataTeamSelect[x][0] && dataTeamSelect[x][0].answer && dataTeamSelect[x][0].total){
                                                // dataSum += ((dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total) * state.questionSet4_weight[dataTeamSelect[x][0].type])
                                                let score = (dataTeamSelect[x][0].answer / dataTeamSelect[x][0].total)
                                                let weight = state.questionSet4_weight[dataTeamSelect[x][0].type]
                                                let max = state.questionSet4_max[dataTeamSelect[x][0].type]
                                                if(score > max){
                                                    score = 1
                                                }else{
                                                    score = score/max
                                                }
                                                score = score * weight
                                                dataSum += score
                                            }
                                        }
                                        let total:any = (dataSum * 100).toFixed(1)
                                        total = total * 1
                                        temp3.push(total)
                                    }else{
                                        temp3.push('-')
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Index'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Index' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push('-')
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.alignmentIndex
                                            total = total * 1
                                            temp3.push(total)
                                        });
                                    }else{
                                        temp3.push('-')
                                    }
                                }
                            }else if(x == 'strategic_alignment' && key == 'Variance'){
                                if(state.quarterSelected.type == 'compare'){
                                    const dataTeamSelect:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': 'Variance' })
                                    if(dataTeamSelect.length > 0){
                                        temp3.push(dataTeamSelect[0]['percent'])
                                    }else{
                                        temp3.push('-')
                                    }
                                }else{
                                    const teamResponses:any = {};
                                      for(let i = 1; i < 9; i++){
                                        let response = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': state.questionSet5[i] })
                                        if(response && response.length > 0 && response[0].answer){
                                            
                                            teamResponses[state.questionSet5[i]] = [];
                                            let dataAnswer:any = []
                                            for(const choice in response[0].answer){
                                                dataAnswer.push([Number(choice),response[0].answer[choice]])
                                            }
                                            teamResponses[state.questionSet5[i]] = dataAnswer
    
                                        }
                                      }
                                    if(Object.keys(teamResponses).length > 0){
                                        const averages = dispatch('calculateAverage', teamResponses);
                                        averages.then(async _averages => {
                                            const results = await dispatch('calculateMetrics',_averages)
                                            let total:any = results.consistencyScore
                                            total = total * 1
                                            temp3.push(total)
                                        });
                                    }else{
                                        temp3.push('-')
                                    }
                                }
                            }else{
                                const dataItemByQuestion:any = _.filter(state.datalistall, { 'teamid': state.teamselected, 'quest_id': key })
                                if(dataItemByQuestion.length > 0){
                                    if(x == 'nps'){
                                        if(state.quarterSelected.type == 'compare'){
                                            temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                        }else{
                                            if(dataItemByQuestion[0] && dataItemByQuestion[0].answer && Object.keys(dataItemByQuestion[0].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                let nps_score:any = 0
                                                _.forEach(dataItemByQuestion[0].answer, function (value, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= value
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= value
                                                    }
                                                });
                                                nps_score = ((promotors / Number(dataItemByQuestion[0].total)) - (detractors / Number(dataItemByQuestion[0].total)))*100
                                                let total:any = globalfunc.round(nps_score,0)
                                                temp3.push(total)
                                            }
                                        }
                                    }else if(dataItemByQuestion[0]['question_type'] == 'Scale'){
                                        temp3.push((dataItemByQuestion[0]['percent'].toFixed(1)) * 1)
                                    }else{
                                        temp3.push(Math.ceil(dataItemByQuestion[0]['percent']))
                                    }
                                }else{
                                    temp3.push(-999)
                                }
                            }
                            tableDataByCategory.push(temp3)
                        });
                        if(state.sortBy == 'lowest'){
                            tableDataByCategory.sort((a, b) => {
                                if (a[0] === 'Index') return -1;
                                if (b[0] === 'Index') return 1;
                                if(a[1] == -999 && b[1] == -999){
                                    return (a[1] - b[1]) * -1; 
                                }else if(a[1] == -999 || b[1] == -999){
                                    let x = (a[1] == -999)?a[1]: 0;
                                    let y = (b[1] == -999)?b[1]: 0;
                                    return y - x;
                                }else{
                                    return (b[1] - a[1]) * -1; 
                                }
                            });
                        }else if(state.sortBy == 'highest'){
                            tableDataByCategory.sort((a, b) => {
                                if (a[0] === 'Index') return -1;
                                if (b[0] === 'Index') return 1;
                                return b[1] - a[1];
                            });
                        }
                        tableData = _.concat(tableData, tableDataByCategory);
                    }
                    commit('setDataTable', tableData)
                    if(state.TempDatatableAllTeam.length == 0 && tableData.length > 2){
                        commit('setTempDataTableAllTeam', tableData)
                    }
                }
            }
        },
        async calculateAverage({ commit, state, dispatch, rootState }: any, teamResponses: any) {
            const weightMap = [4, 3, 2, 1, 0]; // คะแนนของแต่ละตัวเลือก
          
            const averages = {};
            for(const question in teamResponses){
                let totalScore = 0;
                let totalCount = 0;
                for(const responses in teamResponses[question]){
                    let option = teamResponses[question][responses][0]
                    let count = teamResponses[question][responses][1]
                    totalScore += weightMap[option] * count; // คำนวณคะแนนรวม
                    totalCount += count;   
                }
                const average = totalCount > 0 ? totalScore / totalCount : null; // ค่าเฉลี่ย
                averages[question] = average; // บันทึกค่าเฉลี่ยสำหรับคำถามนี้
            }
            return averages;
        },
        async calculateMetrics({ commit, dispatch, rootState, state }: any, responses: any) {
            // Validate input
            if (!responses || typeof responses !== 'object') {
              throw new Error('Responses must be an object with question keys');
            }
          
            // Get valid responses (non-null, non-undefined)
            const validResponses = Object.entries(responses)
              .filter(([_, value]) => value !== null && value !== undefined)
              .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
            if (Object.keys(validResponses).length === 0) {
              return {
                alignmentIndex: null,
                consistencyScore: null,
                categoryScores: {},
                responseRange: null,
                interpretations: {
                  alignment: 'Insufficient data',
                  consistency: 'Insufficient data'
                }
              };
            }
          
            // Calculate category scores and overall index
            const categoryScores = {};
            let totalWeight = 0;
            let weightedSum = 0;
          
            Object.entries(CATEGORIES).forEach(([key, category]) => {
              const categoryResponses = category.questions
                .filter(q => validResponses[q] !== undefined)
                .map(q => validResponses[q]);
              if (categoryResponses.length > 0) {
                const score = (categoryResponses.reduce((sum, r) => sum + r, 0) / categoryResponses.length) * 25;
                categoryScores[key] = score;
                weightedSum += score;
                totalWeight += 100;
              }
            });
          
            // Calculate alignment index
            const alignmentIndex = totalWeight > 0
              ? Math.round((weightedSum / totalWeight) * 100)
              : null;
          
            // Calculate consistency score
            const responseValues:any = Object.values(validResponses);
            const mean = responseValues.reduce((sum, val) => sum + val, 0) / responseValues.length;
            const variance = responseValues.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / responseValues.length;
            const maxVariance = 4; // Maximum possible variance on a 0-4 scale
            const consistencyScore = Math.round((1 - (variance / maxVariance)) * 100);
          
            // Calculate response range
            const sorted = [...responseValues].sort((a, b) => a - b);
            const q1 = sorted[Math.floor(sorted.length * 0.25)];
            const q3 = sorted[Math.floor(sorted.length * 0.75)];
            const responseRange = {
              min: sorted[0],
              max: sorted[sorted.length - 1],
              q1: q1,
              q3: q3,
              spread: q3 - q1
            };
          
            return {
              alignmentIndex,
              consistencyScore,
              categoryScores,
              responseRange,
              interpretations: {
                alignment: dispatch('interpretAlignmentIndex',alignmentIndex),
                consistency: dispatch('interpretConsistencyScore',consistencyScore)
              }
            };
        },
        async interpretAlignmentIndex({ commit, dispatch, rootState, state }: any, score: any) {
            if (score === null) return 'Insufficient data';
            if (score >= 90) return 'Exceptional';
            if (score >= 80) return 'Strong';
            if (score >= 70) return 'Moderate';
            if (score >= 60) return 'Needs attention';
            return 'Critical';
        },
        async interpretConsistencyScore({ commit, dispatch, rootState, state }: any, score: any) {
            if (score === null) return 'Insufficient data';
            if (score >= 90) return 'Exceptional consistency';
            if (score >= 80) return 'Strong consistency';
            if (score >= 70) return 'Moderate consistency';
            if (score >= 60) return 'Needs attention';
            return 'Critical inconsistency';
        },
        async getOrganization({ commit,state, rootState }: any) {
            if(Object.keys(state.organizations || {}).length == 0){
              const querySnapshot = await firebase.firestore()
                .collection('organization')
                .where("company", "==", rootState.authen.user.company)
                .get()
              const organizations: Array<any> = [];
              querySnapshot.forEach((doc) => {
                const organization = doc.data()
                organization.key = doc.id
                organizations[organization.team_id] = organization
              });
              commit('setOrganizations', organizations)
            }
        },
        async getTeamOfParent({ commit, dispatch, rootState, state }: any, item: any) {
            const organization1level = state.organization1level
            _.forEach(item, (value)=> {
                organization1level[value.team_id] = true
                if(value.parent){
                    dispatch('getTeamOfParent', value.parent)
                }
            });
        },
        async getDataExportCohort({ commit, dispatch, rootState, state }: any) {
            commit('setSnackbar', true)
            const dateNow = new Date()
            const questionCultureCustom = state.questionCultureCustom
            const questionMasterArr = state.questionMasterArr
            let cohortSelected: Array<any> = [];
            if(!state.cohortSelected){
                cohortSelected = state.allCohortOrderd
            }else{
                let item = state.allCohort[state.cohortSelected]
                item.key = state.cohortSelected
                item.value = item.name
                cohortSelected.push(item)
            }
            
            if(state.quarterSelected.type == 'recent'){
                const dateYesterday = format(addDays(dateNow, -1), 'YYYY-MM-DD')
                const quarter = getQuarter(dateYesterday)
                // const yearQuarter = 20231  // FIX Data
                const yearQuarter = format(dateYesterday, 'YYYY') + quarter;
                const datelast = format(dateYesterday, 'YYYY-MM-DD')

                if(cohortSelected.length > 1){
                    await firebase.firestore().collection('insight_teams_report_card_fix').where('company', "==", rootState.authen.user.company).get()
                    .then(function (querySnapshot) {
                        const dataItem: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(data.cohort){
                                dataItem[data.cohort+"_"+data.quest_id] = data
                            }
                        });
                        firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('quarter','==',Number(yearQuarter)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort !== undefined){
                                    dataItem[data.cohort+"_"+data.type] = data
                                }
                            });
                            const datatable: Array<any> = [];
                            _.forOwn(dataItem, function(value, key) {
                                let _tmp: { [key: string]: any } = {}
                                _tmp = value;
                                let temp_name = '';
                                if(state.allCohort[value.cohort]){
                                    temp_name = state.allCohort[value.cohort].name
                                }
            
                                _tmp['teamid'] = value.cohort;
                                _tmp['team'] = temp_name;
                                datatable.push(_tmp);
                            });
                            commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                            dispatch('genDataExportCohort')
                        });
                    });
                }else{
                    await firebase.firestore().collection('insight_teams_report_card_fix').where('company', "==", rootState.authen.user.company).where('cohort', '==', cohortSelected[0].key).get()
                    .then(function (querySnapshot) {
                        const dataItem: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            if(data.cohort){
                                dataItem[data.cohort+"_"+data.quest_id] = data
                            }
                        });
                        firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('cohort', '==', cohortSelected[0].key).where('quarter','==',Number(yearQuarter)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort !== undefined){
                                    dataItem[data.cohort+"_"+data.type] = data
                                }
                            });
                            const datatable: Array<any> = [];
                            _.forOwn(dataItem, function(value, key) {
                                let _tmp: { [key: string]: any } = {}
                                _tmp = value;
                                let temp_name = '';
                                if(state.allCohort[value.cohort]){
                                    temp_name = state.allCohort[value.cohort].name
                                }
            
                                _tmp['teamid'] = value.cohort;
                                _tmp['team'] = temp_name;
                                datatable.push(_tmp);
                            });
                            commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                            dispatch('genDataExportCohort')
                        });
                    });
                }
            }else{
                if(state.quarterSelected.type == 'compare'){
                    const dataItemBefore: Array<any> = [];
                    const dataItemAfter: Array<any> = [];
                    if(cohortSelected.length > 1){
                        await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItemBefore[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItemBefore[data.cohort+"_"+data.type] = data
                                    }
                                });
                            });
                        });

                        await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItemAfter[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                            .then(async function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItemAfter[data.cohort+"_"+data.type] = data
                                    }
                                });
                                let datatable:any = []
                                // _.forOwn(dataItemAfter, function(value, key) {
                                for (const [key, value] of Object.entries(dataItemAfter)) {
                                    if(dataItemBefore[key] !== undefined){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = value;
                                        let temp_name = '';
                                        if(state.allCohort[value.cohort]){
                                            temp_name = state.allCohort[value.cohort].name
                                        }
                                        if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][value.quest_id]){
                                            let nps_score_after:any = 0
                                            let nps_score_before:any = 0
                                            if(value.answer && Object.keys(value.answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(value.answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_after =((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                            }
                                            if(dataItemBefore[key] && dataItemBefore[key].answer && Object.keys(dataItemBefore[key].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(dataItemBefore[key].answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_before = ((promotors / Number(dataItemBefore[key].total)) - (detractors / Number(dataItemBefore[key].total)))*100
                                            }
                                            _tmp['percent'] = globalfunc.round(nps_score_after,0) - globalfunc.round(nps_score_before,0)
                                            _tmp['teamid'] = value.cohort;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }else if(_.find(state.questionSet1, function(o) { return o === _tmp.quest_id; })){  //WHO-5
                                            let datatableWHO5:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableWHO5 = _.filter(datatable, { 'quest_id': 'WHO-5', 'team': teamId })
                                            }
                                            if((!datatableWHO5 || datatableWHO5.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'WHO-5'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet2, function(o) { return o === _tmp.quest_id; })){ // eRes
                                            let datatableeRes:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableeRes = _.filter(datatable, { 'quest_id': 'eRes', 'team': teamId })
                                            }
                                            if((!datatableeRes || datatableeRes.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'eRes'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet3, function(o) { return o === _tmp.quest_id; }) || _.find(questionCultureCustom, function(o) { return o === _tmp.quest_id; })){ // Culture
                                            // Check if Culture data already exists for this cohort
                                            let datatableCulture:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableCulture = _.filter(datatable, { 'quest_id': 'Culture', 'team': teamId })
                                            }
                                            if((!datatableCulture || datatableCulture.length == 0) && value.cohort){
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                
                                                // Calculate percentBefore and percentAfter based on custom or default questions
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const calculateCustomPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(const question of questionCultureCustom){
                                                            dataTeamSelect.push(dataSource[value.cohort+"_"+question])
                                                        }
                                                        
                                                        for(let i=0; i<dataTeamSelect.length; i++){
                                                            if(dataTeamSelect[i] && Object.keys(dataTeamSelect[i]).length > 0){
                                                                let questId = dataTeamSelect[i].quest_id
                                                                if(questionMasterArr[questId]){
                                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, questId, dataTeamSelect[i].answer);
                                                                    dataSum += result.dataSum;
                                                                    maxmimum += result.total;
                                                                }
                                                            }
                                                        }
                                                        
                                                        const percent = ((dataSum * 100) / maxmimum);
                                                        return isNaN(percent) ? 0 : percent;
                                                    };
                                                    
                                                    percentBefore = calculateCustomPercent(dataItemBefore);
                                                    percentAfter = calculateCustomPercent(dataItemAfter);
                                                }else{
                                                    // Default calculation using questionSet3
                                                    const calculateDefaultPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(let i=1; i<=5; i++){
                                                            dataTeamSelect.push(dataSource[value.cohort+"_"+state.questionSet3[i]])
                                                        }
                                                        
                                                        const allValid = dataTeamSelect.every((item, idx) => 
                                                            item && Object.keys(item).length > 0
                                                        );
                                                        
                                                        if(allValid){
                                                            for(let x=0; x<5; x++){
                                                                if(dataTeamSelect[x] && dataTeamSelect[x].answer && Object.keys(dataTeamSelect[x].answer).length > 0){
                                                                    for(let y=0; y<6; y++){
                                                                        if(dataTeamSelect[x].answer[y]){
                                                                            dataSum += (dataTeamSelect[x].answer[y]) * (5 - y)
                                                                            maxmimum += dataTeamSelect[x].answer[y] * 5
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            return ((dataSum * 100) / maxmimum);
                                                        }
                                                        return 0;
                                                    };
                                                    
                                                    percentBefore = calculateDefaultPercent(dataItemBefore);
                                                    percentAfter = calculateDefaultPercent(dataItemAfter);
                                                }
                                                
                                                // Set final values and push to datatable
                                                _tmp['quest_id'] = 'Culture'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet4, function(o) { return o === _tmp.type; })){ // DEBI
                                            let datatableDEBI:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableDEBI = _.filter(datatable, { 'type': 'DEBI', 'team': teamId })
                                            }
                                            if((!datatableDEBI || datatableDEBI.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectBefore[0] || dataTeamSelectBefore[1] || dataTeamSelectBefore[2] || dataTeamSelectBefore[3] || dataTeamSelectBefore[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && dataTeamSelectBefore[x].total){
                                                            // dataSumBefore += ((dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total) * state.questionSet4_weight[dataTeamSelectBefore[x].type])
                                                            let score = (dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectBefore[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectBefore[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumBefore += score
                                                        }
                                                    }
                                                    percentBefore = dataSumBefore * 100
                                                }else{
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectAfter[0] || dataTeamSelectAfter[1] || dataTeamSelectAfter[2] || dataTeamSelectAfter[3] || dataTeamSelectAfter[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && dataTeamSelectAfter[x].total){
                                                            // dataSumAfter += ((dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total) * state.questionSet4_weight[dataTeamSelectAfter[x].type])
                                                            let score = (dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectAfter[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectAfter[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumAfter += score
                                                        }
                                                    }
                                                    percentAfter = dataSumAfter * 100
                                                }else{
                                                    percentAfter = 0
                                                }
                                                _tmp['type'] = 'DEBI'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet5, function(o) { return o === _tmp.quest_id; })){ // Index & Variance
                                            // Index
                                            let datatableIndex:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableIndex = _.filter(datatable, { 'quest_id': 'Index', 'team': teamId })
                                            }
                                            if((!datatableIndex || datatableIndex.length == 0) && value.cohort){
                                                const dataTeamSelectBefore:any = {};
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemBefore[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentBefore = results.alignmentIndex * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentBefore = 0
                                                    }
                                                } else {
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter:any = {};
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemAfter[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentAfter = results.alignmentIndex * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentAfter = 0
                                                    }
                                                } else {
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'Index'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }

                                            //Variance
                                            let datatableVariance:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableVariance = _.filter(datatable, { 'quest_id': 'Variance', 'team': teamId })
                                            }
                                            if((!datatableVariance || datatableVariance.length == 0) && value.cohort){
                                                const dataTeamSelectBefore:any = {};
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemBefore[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentBefore = results.consistencyScore * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentBefore = 0
                                                    }
                                                } else {
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter:any = {};
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemAfter[value.cohort+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentAfter = results.consistencyScore * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentAfter = 0
                                                    }
                                                } else {
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'Variance'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.cohort;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_tmp.question_type == 'Scale'){
                                            _tmp['percent'] = (((value.percent.toFixed(1)) * 1) - ((dataItemBefore[key].percent.toFixed(1)) * 1)).toFixed(1)
                                            _tmp['teamid'] = value.cohort;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }else{
                                            _tmp['percent'] = Math.ceil(value.percent) - Math.ceil(dataItemBefore[key].percent)
                                            _tmp['teamid'] = value.cohort;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }
                                        // _tmp['teamid'] = value.cohort;
                                        // _tmp['team'] = temp_name;
                                        // datatable.push(_tmp);
                                    }
                                }
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExportCohort')
                            });
                        });
                    }else{
                        await firebase.firestore().collection('insight_teams_report_card').where('cohort', '==', cohortSelected[0].key).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItemBefore[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('cohort', '==', cohortSelected[0].key).where("quarter", "==", Number(state.quarterCompare.before)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItemBefore[data.cohort+"_"+data.type] = data
                                    }
                                });
                            });
                        });
                        await firebase.firestore().collection('insight_teams_report_card').where('cohort', '==', cohortSelected[0].key).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItemAfter[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('cohort', '==', cohortSelected[0].key).where("quarter", "==", Number(state.quarterCompare.after)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItemAfter[data.cohort+"_"+data.type] = data
                                    }
                                });
                                let datatable:any = []
                                _.forOwn(dataItemAfter, function(value, key) {
                                    if(dataItemBefore[key] !== undefined){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = value;
                                        let temp_name = '';
                                        if(state.allCohort[value.cohort]){
                                            temp_name = state.allCohort[value.cohort].name
                                        }
                                        if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][value.quest_id]){
                                            let nps_score_after:any = 0
                                            let nps_score_before:any = 0
                                            if(value.answer && Object.keys(value.answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(value.answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_after =((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                            }
                                            if(dataItemBefore[key] && dataItemBefore[key].answer && Object.keys(dataItemBefore[key].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(dataItemBefore[key].answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_before = ((promotors / Number(dataItemBefore[key].total)) - (detractors / Number(dataItemBefore[key].total)))*100
                                            }
                                            _tmp['percent'] = globalfunc.round(nps_score_after,0) - globalfunc.round(nps_score_before,0)
                                        }else if(_.find(state.questionSet1, function(o) { return o === _tmp.quest_id; })){  //WHO-5
                                            let datatableWHO5:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableWHO5 = _.filter(datatable, { 'quest_id': 'WHO-5', 'team': teamId })
                                            }
                                            if((!datatableWHO5 || datatableWHO5.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'WHO-5'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_.find(state.questionSet2, function(o) { return o === _tmp.quest_id; })){  //eRes
                                            let datatableeRes:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableeRes = _.filter(datatable, { 'quest_id': 'eRes', 'team': teamId })
                                            }
                                            if((!datatableeRes || datatableeRes.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'eRes'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_.find(state.questionSet3, function(o) { return o === _tmp.quest_id; }) || _.find(questionCultureCustom, function(o) { return o === _tmp.quest_id; })){ // Culture
                                            // Check if Culture data already exists for this cohort
                                            let datatableCulture:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableCulture = _.filter(datatable, { 'quest_id': 'Culture', 'team': teamId })
                                            }
                                            if((!datatableCulture || datatableCulture.length == 0) && value.cohort){
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                
                                                // Calculate percentBefore and percentAfter based on custom or default questions
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const calculateCustomPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(const question of questionCultureCustom){
                                                            dataTeamSelect.push(dataSource[value.cohort+"_"+question])
                                                        }
                                                        
                                                        for(let i=0; i<dataTeamSelect.length; i++){
                                                            if(dataTeamSelect[i] && Object.keys(dataTeamSelect[i]).length > 0){
                                                                let questId = dataTeamSelect[i].quest_id
                                                                if(questionMasterArr[questId]){
                                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, questId, dataTeamSelect[i].answer);
                                                                    dataSum += result.dataSum;
                                                                    maxmimum += result.total;
                                                                }
                                                            }
                                                        }
                                                        
                                                        const percent = ((dataSum * 100) / maxmimum);
                                                        return isNaN(percent) ? 0 : percent;
                                                    };
                                                    
                                                    percentBefore = calculateCustomPercent(dataItemBefore);
                                                    percentAfter = calculateCustomPercent(dataItemAfter);
                                                }else{
                                                    // Default calculation using questionSet3
                                                    const calculateDefaultPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(let i=1; i<=5; i++){
                                                            dataTeamSelect.push(dataSource[value.cohort+"_"+state.questionSet3[i]])
                                                        }
                                                        
                                                        const allValid = dataTeamSelect.every((item, idx) => 
                                                            item && Object.keys(item).length > 0
                                                        );
                                                        
                                                        if(allValid){
                                                            for(let x=0; x<5; x++){
                                                                if(dataTeamSelect[x] && dataTeamSelect[x].answer && Object.keys(dataTeamSelect[x].answer).length > 0){
                                                                    for(let y=0; y<6; y++){
                                                                        if(dataTeamSelect[x].answer[y]){
                                                                            dataSum += (dataTeamSelect[x].answer[y]) * (5 - y)
                                                                            maxmimum += dataTeamSelect[x].answer[y] * 5
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            return ((dataSum * 100) / maxmimum);
                                                        }
                                                        return 0;
                                                    };
                                                    
                                                    percentBefore = calculateDefaultPercent(dataItemBefore);
                                                    percentAfter = calculateDefaultPercent(dataItemAfter);
                                                }
                                                
                                                // Set final values and push to datatable
                                                _tmp['quest_id'] = 'Culture'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_.find(state.questionSet4, function(o) { return o === _tmp.type; })){  //DEBI
                                            let datatableDEBI:any
                                            if(datatable.length > 0 && _tmp.cohort){
                                                let teamId:string = (_tmp.cohort) ? _tmp.cohort : ''
                                                datatableDEBI = _.filter(datatable, { 'type': 'DEBI', 'team': teamId })
                                            }
                                            if((!datatableDEBI || datatableDEBI.length == 0) && value.cohort){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.cohort+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectBefore[0] || dataTeamSelectBefore[1] || dataTeamSelectBefore[2] || dataTeamSelectBefore[3] || dataTeamSelectBefore[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && dataTeamSelectBefore[x].total){
                                                            // dataSumBefore += ((dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total) * state.questionSet4_weight[dataTeamSelectBefore[x].type])
                                                            let score = (dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectBefore[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectBefore[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumBefore += score
                                                        }
                                                    }
                                                    percentBefore = dataSumBefore * 100
                                                }else{
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.cohort+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectAfter[0] || dataTeamSelectAfter[1] || dataTeamSelectAfter[2] || dataTeamSelectAfter[3] || dataTeamSelectAfter[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && dataTeamSelectAfter[x].total){
                                                            // dataSumAfter += ((dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total) * state.questionSet4_weight[dataTeamSelectAfter[x].type])
                                                            let score = (dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectAfter[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectAfter[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumAfter += score
                                                        }
                                                    }
                                                    percentAfter = dataSumAfter * 100
                                                }else{
                                                    percentAfter = 0
                                                }
                                                _tmp['type'] = 'DEBI'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_tmp.question_type == 'Scale'){
                                            _tmp['percent'] = (value.percent.toFixed(1) * 1) - (dataItemBefore[key].percent.toFixed(1) * 1)
                                        }else{
                                            _tmp['percent'] = Math.ceil(value.percent) - Math.ceil(dataItemBefore[key].percent)
                                        }
                                        _tmp['teamid'] = value.cohort;
                                        _tmp['team'] = temp_name;
                                        datatable.push(_tmp);
                                    }
                                });
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExportCohort')
                            });
                        });
                    }
                    
                }else{
                    if(cohortSelected.length > 1){
                        await firebase.firestore().collection('insight_teams_report_card').where('company', "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                        .then(function (querySnapshot) {
                            const dataItem: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItem[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItem[data.cohort+"_"+data.type] = data
                                    }
                                });
                                const datatable: Array<any> = [];
                                _.forOwn(dataItem, function(value, key) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = value;
                                    let temp_name = '';
                                    if(state.allCohort[value.cohort]){
                                        temp_name = state.allCohort[value.cohort].name
                                    }
                
                                    _tmp['teamid'] = value.cohort;
                                    _tmp['team'] = temp_name;
                                    datatable.push(_tmp);
                                });
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExportCohort')
                            });
                        });
                    }else{
                        await firebase.firestore().collection('insight_teams_report_card').where('cohort', '==', cohortSelected[0].key).where("quarter", "==", Number(state.quarterSelected.id)).get()
                        .then(function (querySnapshot) {
                            const dataItem: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                if(data.cohort){
                                    dataItem[data.cohort+"_"+data.quest_id] = data
                                }
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('cohort', '==', cohortSelected[0].key).where("quarter", "==", Number(state.quarterSelected.id)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.cohort !== undefined){
                                        dataItem[data.cohort+"_"+data.type] = data
                                    }
                                });
                                const datatable: Array<any> = [];
                                _.forOwn(dataItem, function(value, key) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = value;
                                    let temp_name = '';
                                    if(state.allCohort[value.cohort]){
                                        temp_name = state.allCohort[value.cohort].name
                                    }
                
                                    _tmp['teamid'] = value.cohort;
                                    _tmp['team'] = temp_name;
                                    datatable.push(_tmp);
                                });
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExportCohort')
                            });
                        });
                    }
                }
            }
        },
        async getDataExport({ commit, dispatch, rootState, state }: any) {
            commit('setSnackbar', true)
            const dateNow = new Date()
            // let organization1level: Array<any> = [];
            const organizations = state.organizations
            state.organization1level = {}
            const organization1level = state.organization1level
            const teams = organizations[state.teamselected]
            const questionCultureCustom = state.questionCultureCustom
            const questionMasterArr = state.questionMasterArr
            if(teams){
                organization1level[teams.team_id] = true
                _.forEach(teams.parent, (value)=> {
                    organization1level[value.team_id] = true
                    if(value.parent){
                        dispatch('getTeamOfParent', value.parent)
                    }
                });
            }else{
                organization1level[state.teamselected] = true
            }
            
            if(state.quarterSelected.type == 'recent'){
                const dateYesterday = format(addDays(dateNow, -1), 'YYYY-MM-DD')
                const quarter = getQuarter(dateYesterday)
                // const yearQuarter = 20231  // FIX Data
                const yearQuarter = format(dateYesterday, 'YYYY') + quarter;
                const datelast = format(dateYesterday, 'YYYY-MM-DD')

                if(Object.keys(organization1level).length > 10){
                    await firebase.firestore().collection('insight_teams_report_card_fix').where('company', "==", rootState.authen.user.company).get()
                    .then(function (querySnapshot) {
                        const dataItem: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            dataItem[data.team+"_"+data.quest_id] = data
                        });
                        firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('quarter','==',Number(yearQuarter)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItem[data.team+"_"+data.type] = data
                            });
                            const datatable: Array<any> = [];
                            _.forOwn(dataItem, function(value, key) {
                                let _tmp: { [key: string]: any } = {}
                                _tmp = value;
                                let temp_name = '';
                                if(state.teamkeys[value.team]){
                                temp_name = state.teamkeys[value.team].name
                                }
            
                                _tmp['teamid'] = value.team;
                                _tmp['team'] = temp_name;
                                datatable.push(_tmp);
                            });
                            commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                            dispatch('genDataExport')
                        });
                    });
                }else{
                    await firebase.firestore().collection('insight_teams_report_card_fix').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).get()
                    .then(function (querySnapshot) {
                        const dataItem: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            const data = doc.data();
                            dataItem[data.team+"_"+data.quest_id] = data
                        });
                        firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where('quarter','==',Number(yearQuarter)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItem[data.team+"_"+data.type] = data
                            });
                            const datatable: Array<any> = [];
                            _.forOwn(dataItem, function(value, key) {
                                let _tmp: { [key: string]: any } = {}
                                _tmp = value;
                                let temp_name = '';
                                if(state.teamkeys[value.team]){
                                temp_name = state.teamkeys[value.team].name
                                }
            
                                _tmp['teamid'] = value.team;
                                _tmp['team'] = temp_name;
                                datatable.push(_tmp);
                            });
                            commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                            dispatch('genDataExport')
                        });
                    });
                }
            }else{
                if(state.quarterSelected.type == 'compare'){
                    const dataItemBefore: Array<any> = [];
                    const dataItemAfter: Array<any> = [];
                    if(Object.keys(organization1level).length > 10){
                        await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItemBefore[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.before)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItemBefore[data.team+"_"+data.type] = data
                                    }
                                });
                            });
                        });

                        await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItemAfter[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterCompare.after)).get()
                            .then(async function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItemAfter[data.team+"_"+data.type] = data
                                    }
                                });
                                let datatable:any = []
                                // _.forOwn(dataItemAfter, function(value, key) {
                                for (const [key, value] of Object.entries(dataItemAfter)) {
                                    if(dataItemBefore[key] !== undefined){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = value;
                                        let temp_name = '';
                                        if(state.teamkeys[value.team]){
                                            temp_name = state.teamkeys[value.team].name
                                        }
                                        if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][value.quest_id]){
                                            let nps_score_after:any = 0
                                            let nps_score_before:any = 0
                                            if(value.answer && Object.keys(value.answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(value.answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_after =((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                            }
                                            if(dataItemBefore[key] && dataItemBefore[key].answer && Object.keys(dataItemBefore[key].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(dataItemBefore[key].answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_before = ((promotors / Number(dataItemBefore[key].total)) - (detractors / Number(dataItemBefore[key].total)))*100
                                            }
                                            _tmp['percent'] = globalfunc.round(nps_score_after,0) - globalfunc.round(nps_score_before,0)
                                            _tmp['teamid'] = value.team;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }else if(_.find(state.questionSet1, function(o) { return o === _tmp.quest_id; })){  //WHO-5
                                            let datatableWHO5:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableWHO5 = _.filter(datatable, { 'quest_id': 'WHO-5', 'team': teamId })
                                            }
                                            if((!datatableWHO5 || datatableWHO5.length == 0) && value.team){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'WHO-5'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet2, function(o) { return o === _tmp.quest_id; })){ // eRes
                                            let datatableeRes:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableeRes = _.filter(datatable, { 'quest_id': 'eRes', 'team': teamId })
                                            }
                                            if((!datatableeRes || datatableeRes.length == 0) && value.team){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'eRes'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet3, function(o) { return o === _tmp.quest_id; }) || _.find(questionCultureCustom, function(o) { return o === _tmp.quest_id; })){ // Culture
                                            let datatableCulture:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableCulture = _.filter(datatable, { 'quest_id': 'Culture', 'team': teamId })
                                            }
                                            if((!datatableCulture || datatableCulture.length == 0) && value.team){
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                
                                                // Calculate percentBefore and percentAfter based on custom or default questions
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const calculateCustomPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(const question of questionCultureCustom){
                                                            dataTeamSelect.push(dataSource[value.team+"_"+question])
                                                        }
                                                        
                                                        for(let i=0; i<dataTeamSelect.length; i++){
                                                            if(dataTeamSelect[i] && Object.keys(dataTeamSelect[i]).length > 0){
                                                                let questId = dataTeamSelect[i].quest_id
                                                                if(questionMasterArr[questId]){
                                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, questId, dataTeamSelect[i].answer);
                                                                    dataSum += result.dataSum;
                                                                    maxmimum += result.total;
                                                                }
                                                            }
                                                        }
                                                        
                                                        const percent = ((dataSum * 100) / maxmimum);
                                                        return isNaN(percent) ? 0 : percent;
                                                    };
                                                    
                                                    percentBefore = calculateCustomPercent(dataItemBefore);
                                                    percentAfter = calculateCustomPercent(dataItemAfter);
                                                }else{
                                                    // Default calculation using questionSet3
                                                    const calculateDefaultPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(let i=1; i<=5; i++){
                                                            dataTeamSelect.push(dataSource[value.team+"_"+state.questionSet3[i]])
                                                        }
                                                        
                                                        const allValid = dataTeamSelect.every((item, idx) => 
                                                            item && Object.keys(item).length > 0
                                                        );
                                                        
                                                        if(allValid){
                                                            for(let x=0; x<5; x++){
                                                                if(dataTeamSelect[x] && dataTeamSelect[x].answer && Object.keys(dataTeamSelect[x].answer).length > 0){
                                                                    for(let y=0; y<6; y++){
                                                                        if(dataTeamSelect[x].answer[y]){
                                                                            dataSum += (dataTeamSelect[x].answer[y]) * (5 - y)
                                                                            maxmimum += dataTeamSelect[x].answer[y] * 5
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            return ((dataSum * 100) / maxmimum);
                                                        }
                                                        return 0;
                                                    };
                                                    
                                                    percentBefore = calculateDefaultPercent(dataItemBefore);
                                                    percentAfter = calculateDefaultPercent(dataItemAfter);
                                                }
                                                
                                                // Set final values and push to datatable
                                                _tmp['quest_id'] = 'Culture'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet4, function(o) { return o === _tmp.type; })){ // DEBI
                                            let datatableDEBI:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableDEBI = _.filter(datatable, { 'type': 'DEBI', 'team': teamId })
                                            }
                                            if((!datatableDEBI || datatableDEBI.length == 0) && value.team){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectBefore[0] || dataTeamSelectBefore[1] || dataTeamSelectBefore[2] || dataTeamSelectBefore[3] || dataTeamSelectBefore[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && dataTeamSelectBefore[x].total){
                                                            // dataSumBefore += ((dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total) * state.questionSet4_weight[dataTeamSelectBefore[x].type])
                                                            let score = (dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectBefore[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectBefore[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumBefore += score
                                                        }
                                                    }
                                                    percentBefore = dataSumBefore * 100
                                                }else{
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectAfter[0] || dataTeamSelectAfter[1] || dataTeamSelectAfter[2] || dataTeamSelectAfter[3] || dataTeamSelectAfter[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && dataTeamSelectAfter[x].total){
                                                            // dataSumAfter += ((dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total) * state.questionSet4_weight[dataTeamSelectAfter[x].type])
                                                            let score = (dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectAfter[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectAfter[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumAfter += score
                                                        }
                                                    }
                                                    percentAfter = dataSumAfter * 100
                                                }else{
                                                    percentAfter = 0
                                                }
                                                _tmp['type'] = 'DEBI'
                                                let total:any = percentAfter - percentBefore
                                                total = total.toFixed(1) * 1
                                                _tmp['percent'] = total
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_.find(state.questionSet5, function(o) { return o === _tmp.quest_id; })){ // Index & Variance
                                            // Index
                                            let datatableIndex:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableIndex = _.filter(datatable, { 'quest_id': 'Index', 'team': teamId })
                                            }
                                            if((!datatableIndex || datatableIndex.length == 0) && value.team){
                                                const dataTeamSelectBefore:any = {};
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemBefore[value.team+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentBefore = results.alignmentIndex * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentBefore = 0
                                                    }
                                                } else {
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter:any = {};
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemAfter[value.team+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentAfter = results.alignmentIndex * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentAfter = 0
                                                    }
                                                } else {
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'Index'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }

                                            //Variance
                                            let datatableVariance:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableVariance = _.filter(datatable, { 'quest_id': 'Variance', 'team': teamId })
                                            }
                                            if((!datatableVariance || datatableVariance.length == 0) && value.team){
                                                const dataTeamSelectBefore:any = {};
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemBefore[value.team+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectBefore[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectBefore[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectBefore).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectBefore);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentBefore = results.consistencyScore * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentBefore = 0
                                                    }
                                                } else {
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter:any = {};
                                                for(let i = 1; i < 9; i++){
                                                    let response = dataItemAfter[value.team+"_"+state.questionSet5[i]]
                                                    if(response && Object.keys(response).length > 0 && response.answer){
                                                        dataTeamSelectAfter[state.questionSet5[i]] = [];
                                                        let dataAnswer:any = []
                                                        for(const choice in response.answer){
                                                            dataAnswer.push([Number(choice),response.answer[choice]])
                                                        }
                                                        dataTeamSelectAfter[state.questionSet5[i]] = dataAnswer
                
                                                    }
                                                }
                                                if (Object.keys(dataTeamSelectAfter).length > 0) {
                                                    try {
                                                        const _averages = await dispatch('calculateAverage', dataTeamSelectAfter);
                                                        const results = await dispatch('calculateMetrics', _averages);
                                                        percentAfter = results.consistencyScore * 1;
                                                    } catch (error) {
                                                        console.error('Error calculating Index:', error);
                                                        percentAfter = 0
                                                    }
                                                } else {
                                                    percentAfter = 0
                                                }
                                                _tmp['quest_id'] = 'Variance'
                                                let total:any = percentAfter - percentBefore
                                                _tmp['percent'] = total.toFixed(1) * 1
                                                _tmp['teamid'] = value.team;
                                                _tmp['team'] = temp_name;
                                                datatable.push(_tmp);
                                            }
                                        }else if(_tmp.question_type == 'Scale'){
                                            _tmp['percent'] = (((value.percent.toFixed(1)) * 1) - ((dataItemBefore[key].percent.toFixed(1)) * 1)).toFixed(1)
                                            _tmp['teamid'] = value.team;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }else{
                                            _tmp['percent'] = Math.ceil(value.percent) - Math.ceil(dataItemBefore[key].percent)
                                            _tmp['teamid'] = value.team;
                                            _tmp['team'] = temp_name;
                                            datatable.push(_tmp);
                                        }
                                        // _tmp['teamid'] = value.team;
                                        // _tmp['team'] = temp_name;
                                        // datatable.push(_tmp);
                                    }
                                }
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExport')
                            });
                        });
                    }else{
                        await firebase.firestore().collection('insight_teams_report_card').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where("quarter", "==", Number(state.quarterCompare.before)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItemBefore[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where("quarter", "==", Number(state.quarterCompare.before)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItemBefore[data.team+"_"+data.type] = data
                                    }
                                });
                            });
                        });
                        await firebase.firestore().collection('insight_teams_report_card').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where("quarter", "==", Number(state.quarterCompare.after)).get()
                        .then(function (querySnapshot) {
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItemAfter[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where("quarter", "==", Number(state.quarterCompare.after)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItemAfter[data.team+"_"+data.type] = data
                                    }
                                });
                                let datatable:any = []
                                _.forOwn(dataItemAfter, function(value, key) {
                                    if(dataItemBefore[key] !== undefined){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = value;
                                        let temp_name = '';
                                        if(state.teamkeys[value.team]){
                                            temp_name = state.teamkeys[value.team].name
                                        }
                                        if(state.questionMasterByCategory['nps'] && state.questionMasterByCategory['nps'][value.quest_id]){
                                            let nps_score_after:any = 0
                                            let nps_score_before:any = 0
                                            if(value.answer && Object.keys(value.answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(value.answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_after =((promotors / Number(value.total)) - (detractors / Number(value.total)))*100
                                            }
                                            if(dataItemBefore[key] && dataItemBefore[key].answer && Object.keys(dataItemBefore[key].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                _.forEach(dataItemBefore[key].answer, function (response, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= response
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= response
                                                    }
                                                });
                                                nps_score_before = ((promotors / Number(dataItemBefore[key].total)) - (detractors / Number(dataItemBefore[key].total)))*100
                                            }
                                            _tmp['percent'] = globalfunc.round(nps_score_after,0) - globalfunc.round(nps_score_before,0)
                                        }else if(_.find(state.questionSet1, function(o) { return o === _tmp.quest_id; })){  //WHO-5
                                            let datatableWHO5:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableWHO5 = _.filter(datatable, { 'quest_id': 'WHO-5', 'team': teamId })
                                            }
                                            if((!datatableWHO5 || datatableWHO5.length == 0) && value.team){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet1[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'WHO-5'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_.find(state.questionSet2, function(o) { return o === _tmp.quest_id; })){  //eRes
                                            let datatableeRes:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableeRes = _.filter(datatable, { 'quest_id': 'eRes', 'team': teamId })
                                            }
                                            if((!datatableeRes || datatableeRes.length == 0) && value.team){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                let maxmimumBefore:any = 0;
                                                let maxmimumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectBefore[0] && dataTeamSelectBefore[1] && dataTeamSelectBefore[2] && 
                                                       dataTeamSelectBefore[3] && dataTeamSelectBefore[4] && 
                                                       Object.keys(dataTeamSelectBefore[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectBefore[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && Object.keys(dataTeamSelectBefore[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectBefore[x].answer[y]){
                                                                    dataSumBefore += (dataTeamSelectBefore[x].answer[y]) * (5 - y)
                                                                    maxmimumBefore += dataTeamSelectBefore[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentBefore = ((dataSumBefore * 100) / maxmimumBefore);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentBefore = 0
                                                    // _tmp['percent'] = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet2[5]])
                                                if(dataTeamSelectAfter[0] && dataTeamSelectAfter[1] && dataTeamSelectAfter[2] && 
                                                       dataTeamSelectAfter[3] && dataTeamSelectAfter[4] && 
                                                       Object.keys(dataTeamSelectAfter[0]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[1]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[2]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[3]).length > 0 && 
                                                       Object.keys(dataTeamSelectAfter[4]).length > 0){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && Object.keys(dataTeamSelectAfter[x].answer).length > 0){
                                                            for(let y=0; y<6; y++){
                                                                if(dataTeamSelectAfter[x].answer[y]){
                                                                    dataSumAfter += (dataTeamSelectAfter[x].answer[y]) * (5 - y)
                                                                    maxmimumAfter += dataTeamSelectAfter[x].answer[y] * 5
                                                                }
                                                            }
                                                        }
                                                    }
                                                    percentAfter = ((dataSumAfter * 100) / maxmimumAfter);
                                                    // _tmp['percent'] = (((dataSum * 100) / maxmimum).toFixed(1)) * 1;
                                                }else{
                                                    percentAfter = 0
                                                    // _tmp['percent'] = 0
                                                }
                                                _tmp['quest_id'] = 'eRes'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_.find(state.questionSet3, function(o) { return o === _tmp.quest_id; }) || _.find(questionCultureCustom, function(o) { return o === _tmp.quest_id; })){ // Culture
                                            // Check if Culture data already exists for this team
                                            let datatableCulture:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableCulture = _.filter(datatable, { 'quest_id': 'Culture', 'team': teamId })
                                            }
                                            if((!datatableCulture || datatableCulture.length == 0) && value.team){
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0

                                                // Calculate percentBefore and percentAfter based on custom or default questions
                                                if(questionCultureCustom.length > 0){
                                                    // Custom calculation (auto-detects Scale vs MC)
                                                    const calculateCustomPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(const question of questionCultureCustom){
                                                            dataTeamSelect.push(dataSource[value.team+"_"+question])
                                                        }
                                                        
                                                        for(let i=0; i<dataTeamSelect.length; i++){
                                                            if(dataTeamSelect[i] && Object.keys(dataTeamSelect[i]).length > 0){
                                                                let questId = dataTeamSelect[i].quest_id
                                                                if(questionMasterArr[questId]){
                                                                    const result = globalfunc.calculateCultureScore(questionMasterArr, questId, dataTeamSelect[i].answer);
                                                                    dataSum += result.dataSum;
                                                                    maxmimum += result.total;
                                                                }
                                                            }
                                                        }
                                                        
                                                        const percent = ((dataSum * 100) / maxmimum);
                                                        return isNaN(percent) ? 0 : percent;
                                                    };
                                                    
                                                    percentBefore = calculateCustomPercent(dataItemBefore);
                                                    percentAfter = calculateCustomPercent(dataItemAfter);
                                                }else{
                                                    // Default calculation using questionSet3
                                                    const calculateDefaultPercent = (dataSource: any) => {
                                                        let dataSum = 0;
                                                        let maxmimum = 0;
                                                        const dataTeamSelect: Array<any> = [];
                                                        
                                                        for(let i=1; i<=5; i++){
                                                            dataTeamSelect.push(dataSource[value.team+"_"+state.questionSet3[i]])
                                                        }
                                                        
                                                        const allValid = dataTeamSelect.every((item, idx) => 
                                                            item && Object.keys(item).length > 0
                                                        );
                                                        
                                                        if(allValid){
                                                            for(let x=0; x<5; x++){
                                                                if(dataTeamSelect[x] && dataTeamSelect[x].answer && Object.keys(dataTeamSelect[x].answer).length > 0){
                                                                    for(let y=0; y<6; y++){
                                                                        if(dataTeamSelect[x].answer[y]){
                                                                            dataSum += (dataTeamSelect[x].answer[y]) * (5 - y)
                                                                            maxmimum += dataTeamSelect[x].answer[y] * 5
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                            return ((dataSum * 100) / maxmimum);
                                                        }
                                                        return 0;
                                                    };
                                                    
                                                    percentBefore = calculateDefaultPercent(dataItemBefore);
                                                    percentAfter = calculateDefaultPercent(dataItemAfter);
                                                }

                                                // Set final values and push to datatable
                                                _tmp['quest_id'] = 'Culture'
                                                let total:any = (percentAfter - percentBefore).toFixed(1)
                                                total = total * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_.find(state.questionSet4, function(o) { return o === _tmp.type; })){  //DEBI
                                            let datatableDEBI:any
                                            if(datatable.length > 0 && _tmp.team){
                                                let teamId:string = (_tmp.team) ? _tmp.team : ''
                                                datatableDEBI = _.filter(datatable, { 'type': 'DEBI', 'team': teamId })
                                            }
                                            if((!datatableDEBI || datatableDEBI.length == 0) && value.team){
                                                const dataTeamSelectBefore: Array<any> = [];
                                                let percentBefore:any = 0
                                                let percentAfter:any = 0
                                                let dataSumBefore:any = 0;
                                                let dataSumAfter:any = 0;
                                                
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[1]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[2]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[3]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[4]])
                                                dataTeamSelectBefore.push(dataItemBefore[value.team+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectBefore[0] || dataTeamSelectBefore[1] || dataTeamSelectBefore[2] || dataTeamSelectBefore[3] || dataTeamSelectBefore[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectBefore[x] && dataTeamSelectBefore[x].answer && dataTeamSelectBefore[x].total){
                                                            // dataSumBefore += ((dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total) * state.questionSet4_weight[dataTeamSelectBefore[x].type])
                                                            let score = (dataTeamSelectBefore[x].answer / dataTeamSelectBefore[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectBefore[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectBefore[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumBefore += score
                                                        }
                                                    }
                                                    percentBefore = dataSumBefore * 100
                                                }else{
                                                    percentBefore = 0
                                                }

                                                const dataTeamSelectAfter: Array<any> = [];
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[1]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[2]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[3]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[4]])
                                                dataTeamSelectAfter.push(dataItemAfter[value.team+"_"+state.questionSet4[5]])
                                                if(dataTeamSelectAfter[0] || dataTeamSelectAfter[1] || dataTeamSelectAfter[2] || dataTeamSelectAfter[3] || dataTeamSelectAfter[4]){
                                                    for(let x=0; x<5; x++){
                                                        if(dataTeamSelectAfter[x] && dataTeamSelectAfter[x].answer && dataTeamSelectAfter[x].total){
                                                            // dataSumAfter += ((dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total) * state.questionSet4_weight[dataTeamSelectAfter[x].type])
                                                            let score = (dataTeamSelectAfter[x].answer / dataTeamSelectAfter[x].total)
                                                            let weight = state.questionSet4_weight[dataTeamSelectAfter[x].type]
                                                            let max = state.questionSet4_max[dataTeamSelectAfter[x].type]
                                                            if(score > max){
                                                                score = 1
                                                            }else{
                                                                score = score/max
                                                            }
                                                            score = score * weight
                                                            dataSumAfter += score
                                                        }
                                                    }
                                                    percentAfter = dataSumAfter * 100
                                                }else{
                                                    percentAfter = 0
                                                }
                                                _tmp['type'] = 'DEBI'
                                                let total:any = percentAfter - percentBefore
                                                total = total.toFixed(1) * 1
                                                _tmp['percent'] = total
                                            }
                                        }else if(_tmp.question_type == 'Scale'){
                                            _tmp['percent'] = (value.percent.toFixed(1) * 1) - (dataItemBefore[key].percent.toFixed(1) * 1)
                                        }else{
                                            _tmp['percent'] = Math.ceil(value.percent) - Math.ceil(dataItemBefore[key].percent)
                                        }
                                        _tmp['teamid'] = value.team;
                                        _tmp['team'] = temp_name;
                                        datatable.push(_tmp);
                                    }
                                });
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExport')
                            });
                        });
                    }
                }else{
                    if(Object.keys(organization1level).length > 10){
                        await firebase.firestore().collection('insight_teams_report_card').where('company', "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                        .then(function (querySnapshot) {
                            const dataItem: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItem[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where("quarter", "==", Number(state.quarterSelected.id)).get()
                            .then(function (querySnapshot) {
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItem[data.team+"_"+data.type] = data
                                    }
                                });
                                const datatable: Array<any> = [];
                                _.forOwn(dataItem, function(value, key) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = value;
                                    let temp_name = '';
                                    if(state.teamkeys[value.team]){
                                    temp_name = state.teamkeys[value.team].name
                                    }
                
                                    _tmp['teamid'] = value.team;
                                    _tmp['team'] = temp_name;
                                    datatable.push(_tmp);
                                });
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExport')
                            });
                        });
                    }else{
                        await firebase.firestore().collection('insight_teams_report_card').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where("quarter", "==", Number(state.quarterSelected.id)).get()
                        .then(function (querySnapshot) {
                            const dataItem: Array<any> = [];
                            querySnapshot.forEach(function (doc) {
                                const data = doc.data();
                                dataItem[data.team+"_"+data.quest_id] = data
                            });
                            firebase.firestore().collection('engagement_index_quarter').where('company', "==", rootState.authen.user.company).where('team', 'in', Object.keys(organization1level)).where("quarter", "==", Number(state.quarterSelected.id)).get()
                            .then(function (querySnapshot) {
                                const dataItem: Array<any> = [];
                                querySnapshot.forEach(function (doc) {
                                    const data = doc.data();
                                    if(data.team !== undefined){
                                        dataItem[data.team+"_"+data.type] = data
                                    }
                                });
                                const datatable: Array<any> = [];
                                _.forOwn(dataItem, function(value, key) {
                                    let _tmp: { [key: string]: any } = {}
                                    _tmp = value;
                                    let temp_name = '';
                                    if(state.teamkeys[value.team]){
                                    temp_name = state.teamkeys[value.team].name
                                    }
                
                                    _tmp['teamid'] = value.team;
                                    _tmp['team'] = temp_name;
                                    datatable.push(_tmp);
                                });
                                commit('setDataExportAll', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                                dispatch('genDataExport')
                            });
                        });
                    }
                }
            }
        },
        async genDataExportCohort({ commit, state, dispatch, rootState }: any) {
            let cohortSelected: Array<any> = [];
            if(!state.cohortSelected){
                cohortSelected = state.allCohortOrderd
            }else{
                let item = state.allCohort[state.cohortSelected]
                item.key = state.cohortSelected
                item.value = item.name
                cohortSelected.push(item)
            }
            const dataexportall = state.dataexportall
            const questionMaster = state.questionMaster
            const categoryMaster = state.categoryMaster
            const questionMasterByCategory = state.questionMasterByCategory
            const questionType = state.questionType
            const questionCultureCustom = state.questionCultureCustom
            const questionMasterArr = state.questionMasterArr

            let header_team:any = ['','']
            let column_key:any = [
                { key:'blank' },
                { key: 'statement', width: 60 }
            ]
            let data_response:any = {statement:'Number of Responses'}
            
            /*NO. of Responses*/
            data_response = _.merge(data_response,state.allResponseCohorts)

            /*TEAM NAME*/
            _.forEach(cohortSelected, (value, index)=> {
                header_team.push(state.cohortkeys[value.key].name)
                column_key.push({key:value.key, width: 10})
                if(!data_response[value.key]){
                    data_response[value.key] = ''
                }
            });
            

            const Excel = require('exceljs');
            var wb = new Excel.Workbook();
            var ws = wb.addWorksheet('mySheet');

            /*TITLE*/
            ws.mergeCells('B2', 'E2');
            ws.getRow(2).height = 25
            ws.getCell('B2').font = { name: 'Arial', size: 18, bold: true }
            ws.getCell('B2').alignment = { vertical: 'middle' }

            ws.getCell('B2').value = 'Happily Report Card - ' + state.quarterSelected.title

            /*Column headers*/
            ws.getRow(4).values = header_team
            ws.getRow(4).height = 80
            ws.columns = column_key
            ws.getRow(5).values = data_response
            
            /*Data*/
            let dataDetail:any = []
            for(const x in questionMasterByCategory){
                let _tmpByCategory: Array<any> = [];
                dataDetail.push({statement: x})
                // _.forEach(questionMasterByCategory[x], function (value, key) {
                for (const key of Object.keys(state.questionMasterByCategory[x])) {
                    let _tmp:any = {}
                    _tmp['statement'] = key
                    if(x == 'set1' && key == 'WHO-5'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[5] }))
                        }
                        _.forEach(cohortSelected, (value, index)=> {
                            if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = value.key
                                    const dataTeamSelectWHO5:any = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': 'WHO-5' })
                                    if(dataTeamSelectWHO5.length > 0){
                                        _tmp[teamid] = dataTeamSelectWHO5[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': value.key }))
                                    if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                        let teamid = dataSelect[0][0]['teamid']
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataSelect[x][0].answer[y]){
                                                        dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[value.key] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[value.key] = -999
                                }
                            }
                        });
                    }else if(x == 'set1' && key == 'eRes'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[5] }))
                        }
                        _.forEach(cohortSelected, (value, index)=> {
                            if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = value.key
                                    const dataTeamSelecteRES:any = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': 'eRes' })
                                    if(dataTeamSelecteRES.length > 0){
                                        _tmp[teamid] = dataTeamSelecteRES[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': value.key }))
                                    if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                        let teamid = dataSelect[0][0]['teamid']
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataSelect[x][0].answer[y]){
                                                        dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[value.key] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[value.key] = -999
                                }
                            }
                        });
                    }else if(x == 'set1' && key == 'Culture'){
                        const dataTeamSelect: Array<any> = [];
                        // let dataSum:any = 0;
                        // let maxmimum:any = 0;
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                        }else{
                            if(questionCultureCustom.length > 0){
                                for(const question of questionCultureCustom){
                                    dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': question }))
                                }
                            }else{
                                dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[1] }))
                                dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[2] }))
                                dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[3] }))
                                dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[4] }))
                                dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[5] }))
                            }
                        }
                        _.forEach(cohortSelected, (value, index)=> {
                            if(questionCultureCustom.length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = value.key
                                    const dataTeamSelectCulture:any = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': 'Culture' })
                                    if(dataTeamSelectCulture.length > 0){
                                        _tmp[teamid] = dataTeamSelectCulture[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    for(let i=0; i<dataTeamSelect.length; i++){
                                        dataSelect.push(_.filter(dataTeamSelect[i], { 'teamid': value.key }))
                                    }
                                    // let teamid = dataSelect[0][0]['teamid']
                                    // for(let i=0; i<dataSelect.length; i++){
                                    //     if(dataSelect[i][0] && dataSelect[i][0].answer && Object.keys(dataSelect[i][0].answer).length > 0){
                                            
                                    //     }
                                    // }
                                    if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                        let teamid = dataSelect[0][0]['teamid']
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataSelect[x][0].answer[y]){
                                                        dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }
                            }else{
                                if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                    if(state.quarterSelected.type == 'compare'){
                                        let teamid = value.key
                                        const dataTeamSelectCulture:any = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': 'Culture' })
                                        if(dataTeamSelectCulture.length > 0){
                                            _tmp[teamid] = dataTeamSelectCulture[0]['percent']
                                        }else{
                                            if(state.sortBy == 'lowest'){
                                                _tmp[value.key] = 999
                                            }else if(state.sortBy == 'highest'){
                                                _tmp[value.key] = -999
                                            }
                                        }
                                    }else{
                                        const dataSelect: Array<any> = [];
                                        let dataSum:any = 0;
                                        let maxmimum:any = 0;
                                        dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': value.key }))
                                        dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': value.key }))
                                        dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': value.key }))
                                        dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': value.key }))
                                        dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': value.key }))
                                        if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                            let teamid = dataSelect[0][0]['teamid']
                                            for(let x=0; x<5; x++){
                                                if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                    for(let y=0; y<6; y++){
                                                        if(dataSelect[x][0].answer[y]){
                                                            dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                            maxmimum += dataSelect[x][0].answer[y] * 5
                                                        }
                                                    }
                                                }
                                            }
                                            let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                            total = total * 1
                                            _tmp[teamid] = total
                                        }else{
                                            if(state.sortBy == 'lowest'){
                                                _tmp[value.key] = 999
                                            }else if(state.sortBy == 'highest'){
                                                _tmp[value.key] = -999
                                            }
                                        }
                                    }
                                }else{
                                    if(state.sortBy == 'lowest'){
                                        _tmp[value.key] = 999
                                    }else if(state.sortBy == 'highest'){
                                        _tmp[value.key] = -999
                                    }
                                }
                            }
                        });
                    }else if(x == 'engagement' && key == 'DEBI'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': 'DEBI' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[5] }))
                        }
                        _.forEach(cohortSelected, (value, index)=> {
                            if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = value.key
                                    const dataTeamSelectCulture:any = _.filter(dataexportall, { 'teamid': value.key, 'type': 'DEBI' })
                                    if(dataTeamSelectCulture.length > 0){
                                        _tmp[teamid] = dataTeamSelectCulture[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': value.key }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': value.key }))
                                    if(dataSelect[0].length > 0 || dataSelect[1].length > 0 || dataSelect[2].length > 0 || dataSelect[3].length > 0 || dataSelect[4].length > 0){
                                        let teamid = value.key
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x] && dataSelect[x][0] && dataSelect[x][0].answer && dataSelect[x][0].total){
                                                // dataSum += ((dataSelect[x][0].answer / dataSelect[x][0].total) * state.questionSet4_weight[dataSelect[x][0].type])
                                                let score = (dataSelect[x][0].answer / dataSelect[x][0].total)
                                                let weight = state.questionSet4_weight[dataSelect[x][0].type]
                                                let max = state.questionSet4_max[dataSelect[x][0].type]
                                                if(score > max){
                                                    score = 1
                                                }else{
                                                    score = score/max
                                                }
                                                score = score * weight
                                                dataSum += score
                                            }
                                        }
                                        let total:any = (dataSum * 100).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[value.key] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[value.key] = -999
                                        }
                                    }
                                }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[value.key] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[value.key] = -999
                                }
                            }
                        });
                    }else if(x == 'strategic_alignment' && key == 'Index'){
                        let allResults = await Promise.all(cohortSelected.map(async (value) => {
                            let _tmp: any = {};
                            
                            if (state.quarterSelected.type == 'compare') {
                                let dataTeamSelectIndex = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': 'Index' });
                                _tmp[value.key] = dataTeamSelectIndex.length > 0 ? dataTeamSelectIndex[0]['percent'] : (state.sortBy == 'lowest' ? 999 : -999);
                            } else {
                                let teamResponses: any = {};
                                for (let i = 1; i < 9; i++) {
                                    let response = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': state.questionSet5[i] });
                                    if (response && response.length > 0 && response[0].answer) {
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer: any = []
                                        for (const choice in response[0].answer) {
                                            dataAnswer.push([Number(choice), response[0].answer[choice]]);
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer;
                                    }
                                }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        _tmp[value.key] = results.alignmentIndex * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        _tmp[value.key] = -999;
                                    }
                                } else {
                                    _tmp[value.key] = -999;
                                }
                            }
                            return _tmp; // ส่งคืนค่าของแต่ละทีม
                        }));
                        allResults.forEach(teamData => {
                            Object.assign(_tmp, teamData);
                        });
                    }else if(x == 'strategic_alignment' && key == 'Variance'){
                        let allResults = await Promise.all(cohortSelected.map(async (value) => {
                            let _tmp: any = {};
                            
                            if (state.quarterSelected.type == 'compare') {
                                let dataTeamSelectIndex = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': 'Variance' });
                                _tmp[value.key] = dataTeamSelectIndex.length > 0 ? dataTeamSelectIndex[0]['percent'] : (state.sortBy == 'lowest' ? 999 : -999);
                            } else {
                                let teamResponses: any = {};
                                for (let i = 1; i < 9; i++) {
                                    let response = _.filter(dataexportall, { 'teamid': value.key, 'quest_id': state.questionSet5[i] });
                                    if (response && response.length > 0 && response[0].answer) {
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer: any = []
                                        for (const choice in response[0].answer) {
                                            dataAnswer.push([Number(choice), response[0].answer[choice]]);
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer;
                                    }
                                }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        _tmp[value.key] = results.consistencyScore * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        _tmp[value.key] = -999;
                                    }
                                } else {
                                    _tmp[value.key] = -999;
                                }
                            }
                            return _tmp; // ส่งคืนค่าของแต่ละทีม
                        }));
                        allResults.forEach(teamData => {
                            Object.assign(_tmp, teamData);
                        });
                    }else{
                        const dataTeamSelect:any = _.filter(dataexportall, { 'quest_id': key })
                        _.forEach(cohortSelected, (value, index)=> {
                            if(dataTeamSelect.length > 0){
                                const dataSelect:any = _.filter(dataTeamSelect, { 'teamid': value.key })
                                if(dataSelect.length > 0){
                                    let teamid = dataSelect[0]['teamid']
                                    if(x == 'nps'){
                                        if(state.quarterSelected.type == 'compare'){
                                            _tmp[teamid] = Math.ceil(dataSelect[0]['percent']);
                                        }else{
                                            if(dataSelect[0] && dataSelect[0].answer && Object.keys(dataSelect[0].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                let nps_score:any = 0
                                                _.forEach(dataSelect[0].answer, function (value, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= value
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= value
                                                    }
                                                });
                                                nps_score = ((promotors / Number(dataSelect[0].total)) - (detractors / Number(dataSelect[0].total)))*100
                                                let total:any = globalfunc.round(nps_score,0)
                                                _tmp[teamid] = total
                                            }
                                        }
                                    }else if(dataSelect[0]['question_type'] == 'Scale'){
                                        _tmp[teamid] = (dataSelect[0]['percent'].toFixed(1)) * 1
                                    }else{
                                        _tmp[teamid] = Math.ceil(dataSelect[0]['percent'])
                                    }
                                }else{
                                    if(state.sortBy == 'lowest'){
                                        _tmp[value.key] = 999
                                    }else if(state.sortBy == 'highest'){
                                        _tmp[value.key] = -999
                                    }
                                    
                                }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[value.key] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[value.key] = -999
                                }
                            }
                        });
                    }
                    _tmpByCategory.push(_tmp)
                }
                if (state.sortBy == 'lowest') {
                    _tmpByCategory = _.orderBy(
                        _tmpByCategory,
                        [
                            function (o) {
                                // จัดลำดับให้ 'Index' มีค่าความสำคัญสูงสุด
                                return o.statement === 'Index' ? 0 : 1;
                            },
                            function (o) {
                                // ใช้ cohortSelected[0].key เป็นเงื่อนไขถัดไป
                                return o[cohortSelected[0].key];
                            }
                        ],
                        ['asc', 'asc'] // ทิศทางเรียงลำดับ
                    );
                } else if (state.sortBy == 'highest') {
                    _tmpByCategory = _.orderBy(
                        _tmpByCategory,
                        [
                            function (o) {
                                // จัดลำดับให้ 'Index' มีค่าความสำคัญสูงสุด
                                return o.statement === 'Index' ? 0 : 1;
                            },
                            function (o) {
                                // ใช้ state.teamselected เป็นเงื่อนไขถัดไป
                                return o[cohortSelected[0].key];
                            }
                        ],
                        ['asc', 'desc'] // ทิศทางเรียงลำดับ
                    );
                }
                // if(state.sortBy == 'lowest'){
                //     _tmpByCategory = _.orderBy(_tmpByCategory, [function (o) { return o[cohortSelected[0].key]; }], ['asc'])
                // }else if(state.sortBy == 'highest'){
                //     _tmpByCategory = _.orderBy(_tmpByCategory, [function (o) { return o[cohortSelected[0].key]; }], ['desc'])
                // }
                dataDetail = _.concat(dataDetail, _tmpByCategory);
            }
            _.forEach(dataDetail, (value, key)=> {
                ws.addRow(value)
            });
            ws.eachRow(function (row) {
                // console.log(row)
                if(row.number == 4){
                    row.eachCell(function (cell) {
                        if(cell.col > 2){
                            ws.getCell(cell.address).font = { name: 'Arial', size: 10, bold: true }
                            ws.getCell(cell.address).alignment = { textRotation: 45, horizontal: 'left', wrapText: true };
                        }
                    });
                    
                } else if(row.number == 5){
                    ws.getRow(row.number).height = 25
                    row.eachCell(function (cell) {
                        ws.getCell(cell.address).font = { name: 'Arial', size: 10, italic: true }
                        ws.getCell(cell.address).border = {top: {style:'thin', color: {argb:'B2B2B2'}}, left: {style:'thin', color: {argb:'B2B2B2'}}, bottom: {style:'thin', color: {argb:'B2B2B2'}}, right: {style:'thin', color: {argb:'B2B2B2'}}}
                        if(cell.col > 2){
                            ws.getCell(cell.address).alignment = { horizontal: 'center' }
                        }else{
                            ws.getCell(cell.address).alignment = { horizontal: 'right' }
                        }
                    });
                } else if(row.number > 5 ){
                    ws.getRow(row.number).height = 35
                    let type = ''
                    row.eachCell(function (cell) {
                        ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
                        ws.getCell(cell.address).border = {top: {style:'thin', color: {argb:'B2B2B2'}}, left: {style:'thin', color: {argb:'B2B2B2'}}, bottom: {style:'thin', color: {argb:'B2B2B2'}}, right: {style:'thin', color: {argb:'B2B2B2'}}}
                        if(cell.col > 2){
                            ws.getCell(cell.address).alignment = { vertical: 'middle', horizontal: 'center' }
                            // ws.getCell(cell.address).border = {top: {style:'thin', color: {argb:'B2B2B2'}}, left: {style:'thin', color: {argb:'B2B2B2'}}, bottom: {style:'thin', color: {argb:'B2B2B2'}}, right: {style:'thin', color: {argb:'B2B2B2'}}}
                            
                            if(ws.getCell(cell.address).value !== '-' && ws.getCell(cell.address).value !== -999 && ws.getCell(cell.address).value !== 999){
                                if(state.quarterSelected.type == 'compare'){
                                    if(cell.value == 0){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFFBF2'}}
                                    }else if(cell.value > 0){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'ACFFAC'}}
                                    }else if(cell.value < 0){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                    }

                                    let text = ''
                                    if(cell.value > 0){
                                        text = '+' + cell.value
                                    }else{
                                        text = cell.value
                                    }

                                    if(questionType[type] !== 'Scale' && questionType[type] !== 'NPS' && questionType[type] !== 'eNPS'){
                                        text = text + '%'
                                    }
                                    ws.getCell(cell.address).value = text
                                }else{
                                    let typeQuestion = questionType[type]
                                    let breakPoint = [ 0, 25, 50, 70, 90];
                                    switch (typeQuestion) {
                                        case "Scale":
                                          breakPoint = [ 0, 2.5, 5, 7, 9];
                                          break;
                                        case "NPS":
                                          breakPoint = [ -100, -30, 0, 30, 70];
                                          break;
                                        case "eNPS":
                                          breakPoint = [ -100, -30, 0, 30, 70];
                                          break;
                                        case "Multiple Choice":
                                          breakPoint = [ 0, 25, 50, 70, 90];
                                          break;
                                        case "WHO-5":
                                          breakPoint = [ 0, 39, 59, 80, 90];
                                          break;
                                        case "eRes":
                                            breakPoint = [0, 39, 59, 80, 90];
                                            break;
                                        case "Culture":
                                            breakPoint = [0, 39, 59, 80, 90];
                                            break;
                                        case "DEBI":
                                            breakPoint = [0, 19, 39, 70, 85];
                                            break;
                                    }
                                    if(cell.value >=  breakPoint[0] && cell.value <= breakPoint[1]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                    }else if(cell.value > breakPoint[1] && cell.value <= breakPoint[2]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFEAEA'}}
                                    }else if(cell.value > breakPoint[2] && cell.value < breakPoint[3]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'fff2cc'}}
                                    }else if(cell.value >= breakPoint[3] && cell.value < breakPoint[4]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'d9ead3'}}
                                    }else if(cell.value >= breakPoint[4]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'b7e1cd'}}
                                    }
                                    if(typeQuestion == 'NPS' || typeQuestion == 'eNPS'){
                                        if(cell.value > 0){
                                            ws.getCell(cell.address).value = '+' + cell.value
                                        }else{
                                            ws.getCell(cell.address).value = cell.value
                                        }
                                    }
                                    if(typeQuestion !== 'Scale' && typeQuestion !== 'NPS' && typeQuestion !== 'eNPS' && typeQuestion !== 'WHO-5'){
                                        ws.getCell(cell.address).value = cell.value + '%'
                                    }
                                }
                            }else{
                                ws.getCell(cell.address).value = '-'
                                ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F2F2F2'}}
                            }
                        }else{
                            if(cell.col == 2){
                                type = cell.value
                                if(questionMaster[cell.value] && type !== 'set1'){
                                    ws.getCell(cell.address).value = questionMaster[cell.value]
                                }else if(categoryMaster[cell.value]){
                                    ws.getCell(cell.address).value = categoryMaster[cell.value].category
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'nps'){
                                    ws.getCell(cell.address).value = 'Net Promoter Score ® (NPS)'
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'set1'){
                                    ws.getCell(cell.address).value = 'Culture, Resilience, Well-being Indexes'
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'engagement'){
                                    ws.getCell(cell.address).value = 'Engagement Score'
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'strategic_alignment'){
                                    ws.getCell(cell.address).value = 'Strategic Alignment'
                                    ws.getCell(cell.address).font = { bold: true }
                                }
                            }
                            ws.getCell(cell.address).alignment = { vertical: 'middle' }
                        }
                    });
                }
            });
            
            wb.xlsx.writeBuffer( {
                    base64: true
                })
                .then( function (xls64) {
                    // build anchor tag and attach file (works in chrome)
                    var a = document.createElement("a");
                    var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                    var url = URL.createObjectURL(data);
                    a.href = url;
                    a.download = 'Happily Report Card - ' + state.quarterSelected.title + ".xlsx";
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function() {
                        commit('setSnackbar', false)
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        },
                        0);
                }).then(function() {
                    dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        table: 'report_card',
                        status: 'export',
                        user: rootState.authen.user.email
                    }, {root:true})
                })
                .catch(function(error) {
                    console.log(error.message);
                });
        },
        async genDataExport({ commit, state, dispatch, rootState }: any) {
            const organization1level = state.organization1level
            const dataexportall = state.dataexportall
            const questionMaster = state.questionMaster
            const categoryMaster = state.categoryMaster
            const questionMasterByCategory = state.questionMasterByCategory
            const questionType = state.questionType

            let header_team:any = ['','']
            let column_key:any = [
                { key:'blank' },
                { key: 'statement', width: 60 }
            ]
            let data_response:any = {statement:'Number of Responses'}
            
            /*NO. of Responses*/
            data_response = _.merge(data_response,state.allResponse)

            /*TEAM NAME*/
            _.forEach(organization1level, (value, team_id)=> {
                header_team.push(state.teamkeys[team_id].name)
                column_key.push({key:team_id, width: 10})
                if(!data_response[team_id]){
                    data_response[team_id] = ''
                }
            });
            

            const Excel = require('exceljs');
            var wb = new Excel.Workbook();
            var ws = wb.addWorksheet('mySheet');

            /*TITLE*/
            ws.mergeCells('B2', 'E2');
            ws.getRow(2).height = 25
            ws.getCell('B2').font = { name: 'Arial', size: 18, bold: true }
            ws.getCell('B2').alignment = { vertical: 'middle' }

            ws.getCell('B2').value = 'Happily Report Card - ' + state.quarterSelected.title

            /*Column headers*/
            ws.getRow(4).values = header_team
            ws.getRow(4).height = 80
            ws.columns = column_key
            ws.getRow(5).values = data_response
            
            /*Data*/
            let dataDetail:any = []
            for(const x in questionMasterByCategory){
                let _tmpByCategory: Array<any> = [];
                dataDetail.push({statement: x})
                // _.forEach(questionMasterByCategory[x], function (value, key) {
                for (const key of Object.keys(state.questionMasterByCategory[x])) {
                    let _tmp:any = {}
                    _tmp['statement'] = key
                    if(x == 'set1' && key == 'WHO-5'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'WHO-5' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet1[5] }))
                        }
                        _.forEach(organization1level, (value, team_id)=> {
                            if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = team_id
                                    const dataTeamSelectWHO5:any = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': 'WHO-5' })
                                    if(dataTeamSelectWHO5.length > 0){
                                        _tmp[teamid] = dataTeamSelectWHO5[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': team_id }))
                                    if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                        let teamid = dataSelect[0][0]['teamid']
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataSelect[x][0].answer[y]){
                                                        dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[team_id] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[team_id] = -999
                                }
                            }
                        });
                    }else if(x == 'set1' && key == 'eRes'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'eRes' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet2[5] }))
                        }
                        _.forEach(organization1level, (value, team_id)=> {
                            if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = team_id
                                    const dataTeamSelecteRES:any = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': 'eRes' })
                                    if(dataTeamSelecteRES.length > 0){
                                        _tmp[teamid] = dataTeamSelecteRES[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': team_id }))
                                    if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                        let teamid = dataSelect[0][0]['teamid']
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataSelect[x][0].answer[y]){
                                                        dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }
                                // }else{
                                //     if(state.sortBy == 'lowest'){
                                //         _tmp[team_id] = 999
                                //     }else if(state.sortBy == 'highest'){
                                //         _tmp[team_id] = -999
                                //     }
                                    
                                // }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[team_id] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[team_id] = -999
                                }
                            }
                        });
                    }else if(x == 'set1' && key == 'Culture'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': 'Culture' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'quest_id': state.questionSet3[5] }))
                        }
                        _.forEach(organization1level, (value, team_id)=> {
                            if(dataTeamSelect[0].length > 0 && dataTeamSelect[1].length > 0 && dataTeamSelect[2].length > 0 && dataTeamSelect[3].length > 0 && dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = team_id
                                    const dataTeamSelectCulture:any = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': 'Culture' })
                                    if(dataTeamSelectCulture.length > 0){
                                        _tmp[teamid] = dataTeamSelectCulture[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    let maxmimum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': team_id }))
                                    if(dataSelect[0].length > 0 && dataSelect[1].length > 0 && dataSelect[2].length > 0 && dataSelect[3].length > 0 && dataSelect[4].length > 0){
                                        let teamid = dataSelect[0][0]['teamid']
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x][0] && dataSelect[x][0].answer && Object.keys(dataSelect[x][0].answer).length > 0){
                                                for(let y=0; y<6; y++){
                                                    if(dataSelect[x][0].answer[y]){
                                                        dataSum += (dataSelect[x][0].answer[y]) * (5 - y)
                                                        maxmimum += dataSelect[x][0].answer[y] * 5
                                                    }
                                                }
                                            }
                                        }
                                        let total:any = ((dataSum * 100) / maxmimum).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }
                                // }else{
                                //     if(state.sortBy == 'lowest'){
                                //         _tmp[team_id] = 999
                                //     }else if(state.sortBy == 'highest'){
                                //         _tmp[team_id] = -999
                                //     }
                                    
                                // }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[team_id] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[team_id] = -999
                                }
                            }
                        });
                    }else if(x == 'engagement' && key == 'DEBI'){
                        const dataTeamSelect: Array<any> = [];
                        if(state.quarterSelected.type == 'compare'){
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': 'DEBI' }))
                        }else{
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[1] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[2] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[3] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[4] }))
                            dataTeamSelect.push(_.filter(dataexportall, { 'type': state.questionSet4[5] }))
                        }
                        _.forEach(organization1level, (value, team_id)=> {
                            if(dataTeamSelect[0].length > 0 || dataTeamSelect[1].length > 0 || dataTeamSelect[2].length > 0 || dataTeamSelect[3].length > 0 || dataTeamSelect[4].length > 0){
                                if(state.quarterSelected.type == 'compare'){
                                    let teamid = team_id
                                    const dataTeamSelectDEBI:any = _.filter(dataexportall, { 'teamid': team_id, 'type': 'DEBI' })
                                    if(dataTeamSelectDEBI.length > 0){
                                        _tmp[teamid] = dataTeamSelectDEBI[0]['percent']
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }else{
                                    const dataSelect: Array<any> = [];
                                    let dataSum:any = 0;
                                    dataSelect.push(_.filter(dataTeamSelect[0], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[1], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[2], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[3], { 'teamid': team_id }))
                                    dataSelect.push(_.filter(dataTeamSelect[4], { 'teamid': team_id }))
                                    if(dataSelect[0].length > 0 || dataSelect[1].length > 0 || dataSelect[2].length > 0 || dataSelect[3].length > 0 || dataSelect[4].length > 0){
                                        let teamid = team_id
                                        for(let x=0; x<5; x++){
                                            if(dataSelect[x] && dataSelect[x][0] && dataSelect[x][0].answer && dataSelect[x][0].total){
                                                // dataSum += ((dataSelect[x][0].answer / dataSelect[x][0].total) * state.questionSet4_weight[dataSelect[x][0].type])
                                                let score = (dataSelect[x][0].answer / dataSelect[x][0].total)
                                                let weight = state.questionSet4_weight[dataSelect[x][0].type]
                                                let max = state.questionSet4_max[dataSelect[x][0].type]
                                                if(score > max){
                                                    score = 1
                                                }else{
                                                    score = score/max
                                                }
                                                score = score * weight
                                                dataSum += score
                                            }
                                        }
                                        let total:any = (dataSum * 100).toFixed(1)
                                        total = total * 1
                                        _tmp[teamid] = total
                                    }else{
                                        if(state.sortBy == 'lowest'){
                                            _tmp[team_id] = 999
                                        }else if(state.sortBy == 'highest'){
                                            _tmp[team_id] = -999
                                        }
                                    }
                                }
                                // }else{
                                //     if(state.sortBy == 'lowest'){
                                //         _tmp[team_id] = 999
                                //     }else if(state.sortBy == 'highest'){
                                //         _tmp[team_id] = -999
                                //     }
                                    
                                // }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[team_id] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[team_id] = -999
                                }
                            }
                        });
                    }else if(x == 'strategic_alignment' && key == 'Index'){
                        let allResults = await Promise.all(Object.keys(organization1level).map(async (team_id) => {
                            let _tmp: any = {};
                            
                            if (state.quarterSelected.type == 'compare') {
                                let dataTeamSelectIndex = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': 'Index' });
                                _tmp[team_id] = dataTeamSelectIndex.length > 0 ? dataTeamSelectIndex[0]['percent'] : (state.sortBy == 'lowest' ? 999 : -999);
                            } else {
                                let teamResponses: any = {};
                                for (let i = 1; i < 9; i++) {
                                    let response = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': state.questionSet5[i] });
                                    if (response && response.length > 0 && response[0].answer) {
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer: any = []
                                        for (const choice in response[0].answer) {
                                            dataAnswer.push([Number(choice), response[0].answer[choice]]);
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer;
                                    }
                                }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        _tmp[team_id] = results.alignmentIndex * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        _tmp[team_id] = -999;
                                    }
                                } else {
                                    _tmp[team_id] = -999;
                                }
                            }
                            return _tmp; // ส่งคืนค่าของแต่ละทีม
                        }));
                        allResults.forEach(teamData => {
                            Object.assign(_tmp, teamData);
                        });
                    }else if(x == 'strategic_alignment' && key == 'Variance'){
                        let allResults = await Promise.all(Object.keys(organization1level).map(async (team_id) => {
                            let _tmp: any = {};
                            
                            if (state.quarterSelected.type == 'compare') {
                                let dataTeamSelectIndex = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': 'Variance' });
                                _tmp[team_id] = dataTeamSelectIndex.length > 0 ? dataTeamSelectIndex[0]['percent'] : (state.sortBy == 'lowest' ? 999 : -999);
                            } else {
                                let teamResponses: any = {};
                                for (let i = 1; i < 9; i++) {
                                    let response = _.filter(dataexportall, { 'teamid': team_id, 'quest_id': state.questionSet5[i] });
                                    if (response && response.length > 0 && response[0].answer) {
                                        teamResponses[state.questionSet5[i]] = [];
                                        let dataAnswer: any = []
                                        for (const choice in response[0].answer) {
                                            dataAnswer.push([Number(choice), response[0].answer[choice]]);
                                        }
                                        teamResponses[state.questionSet5[i]] = dataAnswer;
                                    }
                                }
                                if (Object.keys(teamResponses).length > 0) {
                                    try {
                                        const _averages = await dispatch('calculateAverage', teamResponses);
                                        const results = await dispatch('calculateMetrics', _averages);
                                        _tmp[team_id] = results.consistencyScore * 1;
                                    } catch (error) {
                                        console.error('Error calculating Index:', error);
                                        _tmp[team_id] = -999;
                                    }
                                } else {
                                    _tmp[team_id] = -999;
                                }
                            }
                            return _tmp; // ส่งคืนค่าของแต่ละทีม
                        }));
                        allResults.forEach(teamData => {
                            Object.assign(_tmp, teamData);
                        });
                    }else{
                        const dataTeamSelect:any = _.filter(dataexportall, { 'quest_id': key })
                        _.forEach(organization1level, (value, team_id)=> {
                            if(dataTeamSelect.length > 0){
                                const dataSelect:any = _.filter(dataTeamSelect, { 'teamid': team_id })
                                if(dataSelect.length > 0){
                                    let teamid = dataSelect[0]['teamid']
                                    if(x == 'nps'){
                                        if(state.quarterSelected.type == 'compare'){
                                            _tmp[teamid] = Math.ceil(dataSelect[0]['percent']);
                                        }else{
                                            if(dataSelect[0] && dataSelect[0].answer && Object.keys(dataSelect[0].answer).length > 0){
                                                let promotors:any = 0
                                                let detractors:any = 0
                                                let nps_score:any = 0
                                                _.forEach(dataSelect[0].answer, function (value, key:number) {
                                                    if(key >= 0 && key <= 6){
                                                        detractors+= value
                                                    }else if(key >=9 && key <= 10){
                                                        promotors+= value
                                                    }
                                                });
                                                nps_score = ((promotors / Number(dataSelect[0].total)) - (detractors / Number(dataSelect[0].total)))*100
                                                let total:any = globalfunc.round(nps_score,0)
                                                _tmp[teamid] = total
                                            }
                                        }
                                    }else if(dataSelect[0]['question_type'] == 'Scale'){
                                        _tmp[teamid] = (dataSelect[0]['percent'].toFixed(1)) * 1
                                    }else{
                                        _tmp[teamid] = Math.ceil(dataSelect[0]['percent'])
                                    }
                                }else{
                                    if(state.sortBy == 'lowest'){
                                        _tmp[team_id] = 999
                                    }else if(state.sortBy == 'highest'){
                                        _tmp[team_id] = -999
                                    }
                                    
                                }
                            }else{
                                if(state.sortBy == 'lowest'){
                                    _tmp[team_id] = 999
                                }else if(state.sortBy == 'highest'){
                                    _tmp[team_id] = -999
                                }
                            }
                        });
                    }
                    _tmpByCategory.push(_tmp)
                }
                if (state.sortBy == 'lowest') {
                    _tmpByCategory = _.orderBy(
                        _tmpByCategory,
                        [
                            function (o) {
                                // จัดลำดับให้ 'Index' มีค่าความสำคัญสูงสุด
                                return o.statement === 'Index' ? 0 : 1;
                            },
                            function (o) {
                                // ใช้ state.teamselected เป็นเงื่อนไขถัดไป
                                return o[state.teamselected];
                            }
                        ],
                        ['asc', 'asc'] // ทิศทางเรียงลำดับ
                    );
                } else if (state.sortBy == 'highest') {
                    _tmpByCategory = _.orderBy(
                        _tmpByCategory,
                        [
                            function (o) {
                                // จัดลำดับให้ 'Index' มีค่าความสำคัญสูงสุด
                                return o.statement === 'Index' ? 0 : 1;
                            },
                            function (o) {
                                // ใช้ state.teamselected เป็นเงื่อนไขถัดไป
                                return o[state.teamselected];
                            }
                        ],
                        ['asc', 'desc'] // ทิศทางเรียงลำดับ
                    );
                }
                // if(state.sortBy == 'lowest'){
                //     _tmpByCategory = _.orderBy(_tmpByCategory, [function (o) { return o[state.teamselected]; }], ['asc'])
                // }else if(state.sortBy == 'highest'){
                //     _tmpByCategory = _.orderBy(_tmpByCategory, [function (o) { return o[state.teamselected]; }], ['desc'])
                // }
                dataDetail = _.concat(dataDetail, _tmpByCategory);
            }
            // _.forEach(questionMaster, (value, key)=> {
            //     const dataTeamSelect = _.filter(dataexportall, { 'quest_id': key })
            //     let _tmp:any = {}
            //     _tmp['statement'] = key
            //     _.forEach(organization1level, (value, team_id)=> {
            //         if(dataTeamSelect.length > 0){
            //             const dataSelect = _.filter(dataTeamSelect, { 'teamid': team_id })
            //             if(dataSelect.length > 0){
            //                 let teamid = dataSelect[0]['teamid']
            //                 if(dataSelect[0]['question_type'] == 'Scale'){
            //                     _tmp[teamid] = (dataSelect[0]['percent'].toFixed(1)) * 1
            //                 }else{
            //                     _tmp[teamid] = Math.ceil(dataSelect[0]['percent'])
            //                 }
            //             }else{
            //                 if(state.sortBy == 'lowest'){
            //                     _tmp[team_id] = 999
            //                 }else if(state.sortBy == 'highest'){
            //                     _tmp[team_id] = -999
            //                 }
                            
            //             }
            //         }else{
            //             if(state.sortBy == 'lowest'){
            //                 _tmp[team_id] = 999
            //             }else if(state.sortBy == 'highest'){
            //                 _tmp[team_id] = -999
            //             }
            //         }
            //     });

            //     dataDetail.push(_tmp)
            // });

            // if(state.sortBy == 'lowest'){
            //     dataDetail = _.orderBy(dataDetail, [function (o) { return o[state.teamselected]; }], ['asc'])
            // }else if(state.sortBy == 'highest'){
            //     dataDetail = _.orderBy(dataDetail, [function (o) { return o[state.teamselected]; }], ['desc'])
            // }
            _.forEach(dataDetail, (value, key)=> {
                ws.addRow(value)
            });
            ws.eachRow(function (row) {
                // console.log(row)
                if(row.number == 4){
                    row.eachCell(function (cell) {
                        if(cell.col > 2){
                            ws.getCell(cell.address).font = { name: 'Arial', size: 10, bold: true }
                            ws.getCell(cell.address).alignment = { textRotation: 45, horizontal: 'left', wrapText: true };
                        }
                    });
                    
                } else if(row.number == 5){
                    ws.getRow(row.number).height = 25
                    row.eachCell(function (cell) {
                        ws.getCell(cell.address).font = { name: 'Arial', size: 10, italic: true }
                        ws.getCell(cell.address).border = {top: {style:'thin', color: {argb:'B2B2B2'}}, left: {style:'thin', color: {argb:'B2B2B2'}}, bottom: {style:'thin', color: {argb:'B2B2B2'}}, right: {style:'thin', color: {argb:'B2B2B2'}}}
                        if(cell.col > 2){
                            ws.getCell(cell.address).alignment = { horizontal: 'center' }
                        }else{
                            ws.getCell(cell.address).alignment = { horizontal: 'right' }
                        }
                    });
                } else if(row.number > 5 ){
                    ws.getRow(row.number).height = 35
                    let type = ''
                    row.eachCell(function (cell) {
                        ws.getCell(cell.address).font = { name: 'Arial', size: 10 }
                        ws.getCell(cell.address).border = {top: {style:'thin', color: {argb:'B2B2B2'}}, left: {style:'thin', color: {argb:'B2B2B2'}}, bottom: {style:'thin', color: {argb:'B2B2B2'}}, right: {style:'thin', color: {argb:'B2B2B2'}}}
                        if(cell.col > 2){
                            ws.getCell(cell.address).alignment = { vertical: 'middle', horizontal: 'center' }
                            // ws.getCell(cell.address).border = {top: {style:'thin', color: {argb:'B2B2B2'}}, left: {style:'thin', color: {argb:'B2B2B2'}}, bottom: {style:'thin', color: {argb:'B2B2B2'}}, right: {style:'thin', color: {argb:'B2B2B2'}}}
                            
                            if(ws.getCell(cell.address).value !== '-' && ws.getCell(cell.address).value !== -999 && ws.getCell(cell.address).value !== 999){
                                if(state.quarterSelected.type == 'compare'){
                                    if(cell.value == 0){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFFBF2'}}
                                    }else if(cell.value > 0){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'ACFFAC'}}
                                    }else if(cell.value < 0){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                    }

                                    let text = ''
                                    if(cell.value > 0){
                                        text = '+' + cell.value
                                    }else{
                                        text = cell.value
                                    }

                                    if(questionType[type] !== 'Scale' && questionType[type] !== 'NPS' && questionType[type] !== 'eNPS'){
                                        text = text + '%'
                                    }
                                    ws.getCell(cell.address).value = text
                                }else{
                                    let typeQuestion = questionType[type]
                                    let breakPoint = [ 0, 25, 50, 70, 90];
                                    switch (typeQuestion) {
                                        case "Scale":
                                          breakPoint = [ 0, 2.5, 5, 7, 9];
                                          break;
                                        case "NPS":
                                          breakPoint = [ -100, -30, 0, 30, 70];
                                          break;
                                        case "eNPS":
                                          breakPoint = [ -100, -30, 0, 30, 70];
                                          break;
                                        case "Multiple Choice":
                                          breakPoint = [ 0, 25, 50, 70, 90];
                                          break;
                                        case "WHO-5":
                                          breakPoint = [ 0, 39, 59, 80, 90];
                                          break;
                                        case "eRes":
                                            breakPoint = [0, 39, 59, 80, 90];
                                            break;
                                        case "Culture":
                                            breakPoint = [0, 39, 59, 80, 90];
                                            break;
                                        case "DEBI":
                                            breakPoint = [0, 19, 39, 70, 85];
                                            break;
                                    }
                                    if(cell.value >=  breakPoint[0] && cell.value <= breakPoint[1]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                    }else if(cell.value > breakPoint[1] && cell.value <= breakPoint[2]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFEAEA'}}
                                    }else if(cell.value > breakPoint[2] && cell.value < breakPoint[3]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'fff2cc'}}
                                    }else if(cell.value >= breakPoint[3] && cell.value < breakPoint[4]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'d9ead3'}}
                                    }else if(cell.value >= breakPoint[4]){
                                        ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'b7e1cd'}}
                                    }
                                    if(typeQuestion == 'NPS' || typeQuestion == 'eNPS'){
                                        if(cell.value > 0){
                                            ws.getCell(cell.address).value = '+' + cell.value
                                        }else{
                                            ws.getCell(cell.address).value = cell.value
                                        }
                                    }
                                    if(typeQuestion !== 'Scale' && typeQuestion !== 'NPS' && typeQuestion !== 'eNPS' && typeQuestion !== 'WHO-5'){
                                        ws.getCell(cell.address).value = cell.value + '%'
                                    }
                                }
                                //  else if(questionType[type] == 'NPS'){
                                //     let breakPoint = [ -100, -30, 0, 30, 70];
                                //     if(cell.value >=  breakPoint[0] && cell.value <= breakPoint[1]){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                //     }else if(cell.value > breakPoint[1] && cell.value <= breakPoint[2]){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFEAEA'}}
                                //     }else if(cell.value > breakPoint[2] && cell.value < breakPoint[3]){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'fff2cc'}}
                                //     }else if(cell.value >= breakPoint[3] && cell.value < breakPoint[4]){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'d9ead3'}}
                                //     }else if(cell.value >= breakPoint[4]){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'b7e1cd'}}
                                //     }
                                // } else if(questionType[type] == 'Scale'){
                                //     if(cell.value >= 0 && cell.value <= 2.5){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                //     }else if(cell.value > 2.5 && cell.value <= 5){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFEAEA'}}
                                //     }else if(cell.value > 5 && cell.value < 7){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'fff2cc'}}
                                //     }else if(cell.value >= 7 && cell.value < 9){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'d9ead3'}}
                                //     }else if(cell.value >= 9){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'b7e1cd'}}
                                //     }
                                // }else{
                                //     if(cell.value >= 0 && cell.value <= 25){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F7CFD0'}}
                                //     }else if(cell.value > 25 && cell.value <= 50){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'FFEAEA'}}
                                //     }else if(cell.value > 50 && cell.value < 70){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'fff2cc'}}
                                //     }else if(cell.value >= 70 && cell.value < 90){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'d9ead3'}}
                                //     }else if(cell.value >= 90){
                                //         ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'b7e1cd'}}
                                //     }
                                //     ws.getCell(cell.address).value = cell.value + '%'
                                // }
                            }else{
                                ws.getCell(cell.address).value = '-'
                                ws.getCell(cell.address).fill = {type: 'pattern', pattern:'solid', fgColor:{argb:'F2F2F2'}}
                            }
                        }else{
                            if(cell.col == 2){
                                type = cell.value
                                if(questionMaster[cell.value] && type !== 'set1'){
                                    ws.getCell(cell.address).value = questionMaster[cell.value]
                                }else if(categoryMaster[cell.value]){
                                    ws.getCell(cell.address).value = categoryMaster[cell.value].category
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'nps'){
                                    ws.getCell(cell.address).value = 'Net Promoter Score ® (NPS)'
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'set1'){
                                    ws.getCell(cell.address).value = 'Culture, Resilience, Well-being Indexes'
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'engagement'){
                                    ws.getCell(cell.address).value = 'Engagement Score'
                                    ws.getCell(cell.address).font = { bold: true }
                                }else if(cell.value == 'strategic_alignment'){
                                    ws.getCell(cell.address).value = 'Strategic Alignment'
                                    ws.getCell(cell.address).font = { bold: true }
                                }
                            }
                            ws.getCell(cell.address).alignment = { vertical: 'middle' }
                        }
                    });
                }
            });
            
            wb.xlsx.writeBuffer( {
                    base64: true
                })
                .then( function (xls64) {
                    // build anchor tag and attach file (works in chrome)
                    var a = document.createElement("a");
                    var data = new Blob([xls64], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                    var url = URL.createObjectURL(data);
                    a.href = url;
                    a.download = 'Happily Report Card - ' + state.quarterSelected.title + ".xlsx";
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(function() {
                        commit('setSnackbar', false)
                            document.body.removeChild(a);
                            window.URL.revokeObjectURL(url);
                        },
                        0);
                }).then(function() {
                    dispatch('authen/addLogs', {
                        company: rootState.authen.user.company,
                        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        table: 'report_card',
                        status: 'export',
                        user: rootState.authen.user.email
                    }, {root:true})
                })
                .catch(function(error) {
                    console.log(error.message);
                });
        },
        sortBy({ commit, state }: any, type: string) {
            state.sortBy = type
            let dataTable = state.datatable
            let dataSort: Array<any> = [];
            let tempData:any = [];
            dataSort.push(dataTable[0])
            dataSort.push(dataTable[1])
            _.forEach(dataTable, function (value, key) {
                if(value[0] !== 'NO. OF RESPONSES' && value[0] !== 'MOST RECENT SCORES'){
                    if(state.questionMasterByCategory[value[0]]){
                        dataSort.push(value)
                        tempData = []
                    }else{
                        tempData.push(value)
                        if(dataTable[key+1] == undefined || (dataTable[key+1] && dataTable[key+1][1] == undefined)){
                            if(state.sortBy == 'lowest'){
                                tempData.sort((a, b) => {
                                    if (a[0] === 'Index') return -1;
                                    if (b[0] === 'Index') return 1;        
                                    if(a[1] == -999 && b[1] == -999){
                                        return (a[1] - b[1]) * -1; 
                                    }else if(a[1] == -999 || b[1] == -999){
                                        let x = (a[1] == -999)?a[1]: 0;
                                        let y = (b[1] == -999)?b[1]: 0;
                                        return y - x;
                                    }else{
                                        return (b[1] - a[1]) * -1; 
                                    }
                                });
                            }else if(state.sortBy == 'highest'){
                                tempData.sort((a, b) => {
                                    if (a[0] === 'Index') return -1;
                                    if (b[0] === 'Index') return 1;        
                                    return b[1] - a[1];
                                });
                            }
                            dataSort = _.concat(dataSort, tempData);
                        }
                    }
                }
            })
            commit('setDataTable',dataSort)
        },
        async getScoreHistoryChartCohort({ commit, state, dispatch, rootState }: any, obj: any) {
            const questionMaster = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            const questId:any = obj.data.row[0]
            const dateNow = new Date()
            const cohortId:any = obj.cohortId
            commit('setChartDataMaxChange','-')
            let citiesRef = firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company)
            if(cohortId == 'all'){
                citiesRef = citiesRef.where("team", "==", state.teamHeight)
            }else{
                citiesRef = citiesRef.where("cohort", "==", cohortId)
            }
            await citiesRef.get()
            .then(function (querySnapshot) {
                const response: Array<any> = [];
                querySnapshot.forEach(function (doc) {
                    const data = doc.data();
                    response[data.quarter] = data.members
                });
                commit('setAllQuarterScoreHistory', response)
            });
            let citiesRef2 = firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company)
            if(questId == 'WHO-5'){
                const arrQuestionSet = Object.values(state.questionSet1)
                if(cohortId == 'all'){
                    citiesRef2 = citiesRef2.where("team", "==", state.teamHeight)
                }else{
                    citiesRef2 = citiesRef2.where("cohort", "==", cohortId)
                }
                citiesRef2 = citiesRef2.where("quest_id", "in", arrQuestionSet)
                await citiesRef2.get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(cohortId == 'all'){
                            if(state.teamkeys[_tmp.team]){
                                temp_name = state.teamkeys[_tmp.team].name
                            }
                            _tmp['teamid'] = _tmp.team;
                        }else{
                            if(state.allCohort[_tmp.cohort]){
                                temp_name = state.allCohort[_tmp.cohort].name
                            }
                            _tmp['teamid'] = _tmp.cohort;
                        }
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                });
            }else if(questId == 'eRes'){
                const arrQuestionSet = Object.values(state.questionSet2)
                if(cohortId == 'all'){
                    citiesRef2 = citiesRef2.where("team", "==", state.teamHeight)
                }else{
                    citiesRef2 = citiesRef2.where("cohort", "==", cohortId)
                }
                citiesRef2 = citiesRef2.where("quest_id", "in", arrQuestionSet)
                await citiesRef2.get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(cohortId == 'all'){
                            if(state.teamkeys[_tmp.team]){
                                temp_name = state.teamkeys[_tmp.team].name
                            }
                            _tmp['teamid'] = _tmp.team;
                        }else{
                            if(state.allCohort[_tmp.cohort]){
                                temp_name = state.allCohort[_tmp.cohort].name
                            }
                            _tmp['teamid'] = _tmp.cohort;
                        }
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                });
            }else if(questId == 'Culture'){
                let arrQuestionSet: any[] = [];
                if(questionCultureCustom.length > 0){
                    arrQuestionSet = Object.values(questionCultureCustom)
                }else{
                    arrQuestionSet = Object.values(state.questionSet3)
                }
                if(cohortId == 'all'){
                    citiesRef2 = citiesRef2.where("team", "==", state.teamHeight)
                }else{
                    citiesRef2 = citiesRef2.where("cohort", "==", cohortId)
                }
                citiesRef2 = citiesRef2.where("quest_id", "in", arrQuestionSet)
                await citiesRef2.get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(cohortId == 'all'){
                            if(state.teamkeys[_tmp.team]){
                                temp_name = state.teamkeys[_tmp.team].name
                            }
                            _tmp['teamid'] = _tmp.team;
                        }else{
                            if(state.allCohort[_tmp.cohort]){
                                temp_name = state.allCohort[_tmp.cohort].name
                            }
                            _tmp['teamid'] = _tmp.cohort;
                        }
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                });
            }else if(questId == 'DEBI'){
            let citiesRef3 = firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company)
                const arrQuestionSet = Object.values(state.questionSet4)
                if(cohortId == 'all'){
                    citiesRef3 = citiesRef3.where("team", "==", state.teamHeight)
                }else{
                    citiesRef3 = citiesRef3.where("cohort", "==", cohortId)
                }
                citiesRef3 = citiesRef3.where("type", "in", arrQuestionSet)
                await citiesRef3.get().then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    const response: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(cohortId == 'all'){
                            if(state.teamkeys[_tmp.team]){
                                temp_name = state.teamkeys[_tmp.team].name
                            }
                            _tmp['teamid'] = _tmp.team;
                        }else{
                            if(state.allCohort[_tmp.cohort]){
                                temp_name = state.allCohort[_tmp.cohort].name
                            }
                            _tmp['teamid'] = _tmp.cohort;
                        }
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                        response[_tmp.quarter] = 0
                    });
                    commit('setAllQuarterScoreHistory', response)
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                });
            }else if(questId == 'Index'){
                const arrQuestionSet = Object.values(state.questionSet5)
                if(cohortId == 'all'){
                    citiesRef2 = citiesRef2.where("team", "==", state.teamHeight)
                }else{
                    citiesRef2 = citiesRef2.where("cohort", "==", cohortId)
                }
                citiesRef2 = citiesRef2.where("quest_id", "in", arrQuestionSet)
                await citiesRef2.get().then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(cohortId == 'all'){
                            if(state.teamkeys[_tmp.team]){
                                temp_name = state.teamkeys[_tmp.team].name
                            }
                            _tmp['teamid'] = _tmp.team;
                        }else{
                            if(state.allCohort[_tmp.cohort]){
                                temp_name = state.allCohort[_tmp.cohort].name
                            }
                            _tmp['teamid'] = _tmp.cohort;
                        }
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                });
            }else if(questId == 'Variance'){
                const arrQuestionSet = Object.values(state.questionSet5)
                if(cohortId == 'all'){
                    citiesRef2 = citiesRef2.where("team", "==", state.teamHeight)
                }else{
                    citiesRef2 = citiesRef2.where("cohort", "==", cohortId)
                }
                citiesRef2 = citiesRef2.where("quest_id", "in", arrQuestionSet)
                await citiesRef2.get().then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(cohortId == 'all'){
                            if(state.teamkeys[_tmp.team]){
                                temp_name = state.teamkeys[_tmp.team].name
                            }
                            _tmp['teamid'] = _tmp.team;
                        }else{
                            if(state.allCohort[_tmp.cohort]){
                                temp_name = state.allCohort[_tmp.cohort].name
                            }
                            _tmp['teamid'] = _tmp.cohort;
                        }
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                });
            }else{
                if(questionMaster[questId].repeats == 'monthly'){
                    const cohorts = (await firebase.database().ref(`/cohorts/${rootState.authen.user.company}`).once('value')).val();
                    const teams: any[] = [];
                    await firebase.firestore().collection('organization').where('company', '==', rootState.authen.user.company).get().then((querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                        const data = doc.data();
                        teams[data.team_id] = [];
                        teams[data.team_id][data.team_id] = 1;
                        if (data.parent !== undefined) {
                            teams[data.team_id] = globalfunc.getTeamOfParent(data.parent, teams[data.team_id]);
                        }
                        });
                    });
                    const answers:any = [];
                    const answersCohorts:any = [];
                    const dateToday = format(dateNow, 'YYYY-MM-DD')
                    await firebase.firestore().collection('users_questions').where("company", "==", rootState.authen.user.company).where("quest_id", "==", questId).where("date", "<", dateToday).get()
                    .then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            if (doc.data().team !== undefined && doc.data().answer !== undefined) {
                                if(answers[doc.data().date] === undefined){
                                    answers[doc.data().date] = {};
                                }
                                if (answers[doc.data().date][doc.data().team] === undefined) {
                                  answers[doc.data().date][doc.data().team] = {};
                                  answers[doc.data().date][doc.data().team].answer = [];
                                  answers[doc.data().date][doc.data().team].total = 0;
                                }
                                if (answers[doc.data().date][doc.data().team].answer[doc.data().answer] === undefined) {
                                  answers[doc.data().date][doc.data().team].answer[doc.data().answer] = 0;
                                }
                                answers[doc.data().date][doc.data().team].answer[doc.data().answer]++;
                                answers[doc.data().date][doc.data().team].total++;
                                for (const x in teams) {
                                    if (teams[x][doc.data().team] !== undefined) {
                                        if (doc.data().team !== x) {
                                            if (answers[doc.data().date] === undefined) {
                                                answers[doc.data().date] = {};
                                            }
                                            if (answers[doc.data().date][x] === undefined) {
                                                answers[doc.data().date][x] = {};
                                                answers[doc.data().date][x].answer = [];
                                                answers[doc.data().date][x].total = 0;
                                            }
                                            if (answers[doc.data().date][x].answer[doc.data().answer] === undefined) {
                                                answers[doc.data().date][x].answer[doc.data().answer] = 0;
                                            }
                                            answers[doc.data().date][x].answer[doc.data().answer]++;
                                            answers[doc.data().date][x].total++;
                                        }
                                    }
                                }

                                for(const x in cohorts){
                                  if(cohorts[x].users){
                                    for(const xx in cohorts[x].users){
                                      if(cohorts[x].users[xx] === doc.data().users){
                                        if (answersCohorts[doc.data().date] === undefined) {
                                            answersCohorts[doc.data().date] = {};
                                        }
                                        if (answersCohorts[doc.data().date][x] === undefined) {
                                          answersCohorts[doc.data().date][x] = {};
                                          answersCohorts[doc.data().date][x].answer = [];
                                          answersCohorts[doc.data().date][x].total = 0;
                                        }
                                        if (answersCohorts[doc.data().date][x].answer[doc.data().answer] === undefined) {
                                          answersCohorts[doc.data().date][x].answer[doc.data().answer] = 0;
                                        }
                                        answersCohorts[doc.data().date][x].answer[doc.data().answer]++;
                                        answersCohorts[doc.data().date][x].total++;
                                      }
                                    }
                                  }
                                }
                              }
                        });
                        const response: Array<any> = [];
                        const datatable: Array<any> = [];
                        const max:any = _.max(questionMaster[questId]['m_choice'].weight);
                        if(cohortId == 'all'){
                            if(Object.keys(answers).length > 0){
                                for(const date in answers){
                                    response[date] = date
                                    for(const team in answers[date]){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = answers[date][team];
                                        let temp_name = '';
                                        if(state.teamkeys[team]){
                                            temp_name = state.teamkeys[team].name
                                        }
                                        _tmp['teamid'] = team;
                                        _tmp['team'] = temp_name;
                                        _tmp['date'] = date
                                        _tmp['quest_id'] = questId
                                        _tmp['question_type'] = questionMaster[questId].type
    
                                        let cal = 0;
                                        for (const answer in answers[date][team].answer) {
                                            if (answers[date][team].answer.hasOwnProperty(answer)) {
                                                cal += questionMaster[questId]['m_choice'].weight[answer] * answers[date][team].answer[answer];
                                            }
                                        }
                                        const total = Number(max) * answers[date][team].total;
                                        const percent = (cal * 100) / total;
                                        answers[date][team].percent = percent;
                                        datatable.push(_tmp);
                                    }
                                }
                            }
                        }else{
                            if(Object.keys(answersCohorts).length > 0){
                                for(const date in answersCohorts){
                                    response[date] = date
                                    for(const cohort in answersCohorts[date]){
                                        let _tmp: { [key: string]: any } = {}
                                        _tmp = answersCohorts[date][cohort];
                                        let temp_name = '';
                                        if(cohorts[cohort]){
                                            temp_name = cohorts[cohort].name
                                        }
                                        _tmp['teamid'] = cohort;
                                        _tmp['team'] = temp_name;
                                        _tmp['date'] = date
                                        _tmp['quest_id'] = questId
                                        _tmp['question_type'] = questionMaster[questId].type
                                        let cal = 0;
                                        for (const answer in answersCohorts[date][cohort].answer) {
                                            if (answersCohorts[date][cohort].answer.hasOwnProperty(answer)) {
                                                cal += questionMaster[questId]['m_choice'].weight[answer] * answersCohorts[date][cohort].answer[answer];
                                            }
                                        }
                                        const total = Number(max) * answersCohorts[date][cohort].total;
                                        const percent = (cal * 100) / total;
                                        answersCohorts[date][cohort].percent = percent;
                                        datatable.push(_tmp);
                                    }
                                }
                            }
                        }
                        commit('setDataTableAllScoreHistoryMonthly', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                        commit('setAllQuarterScoreHistoryMonthly', response)
                        dispatch('getDataTablebyTeamScoreHistoryMonthly', {questId, type:'cohort',cohortId})
                    });
                }else{
                    if(cohortId == 'all'){
                        citiesRef2 = citiesRef2.where("team", "==", state.teamHeight)
                    }else{
                        citiesRef2 = citiesRef2.where("cohort", "==", cohortId)
                    }
                    citiesRef2 = citiesRef2.where("quest_id", "==", questId)
                    await citiesRef2.get()
                    .then(function (querySnapshot) {
                        const datatable: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            let _tmp: { [key: string]: any } = {}
                            _tmp = doc.data();
                            let temp_name = '';
                            if(cohortId == 'all'){
                                if(state.teamkeys[_tmp.team]){
                                    temp_name = state.teamkeys[_tmp.team].name
                                }
                                _tmp['teamid'] = _tmp.team;
                            }else{
                                if(state.allCohort[_tmp.cohort]){
                                    temp_name = state.allCohort[_tmp.cohort].name
                                }
                                _tmp['teamid'] = _tmp.cohort;
                            }
                            _tmp['team'] = temp_name;
                            datatable.push(_tmp);
                        });
                        commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                        dispatch('getDataTablebyTeamScoreHistory', {questId, type:'cohort',cohortId})
                    });
                }
            }
        },
        async getScoreHistoryChart({ commit, state, dispatch, rootState }: any, data: any) {
            const questionMaster = state.questionMasterArr
            const questionCultureCustom = state.questionCultureCustom
            const questId:any = data.row[0]
            const dateNow = new Date()
            commit('setChartDataMaxChange','-')
            if(questId !== 'DEBI'){
                await firebase.firestore().collection('insight_teams_report_card_active_by_quarter').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).get()
                .then(function (querySnapshot) {
                    const response: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        const data = doc.data();
                        response[data.quarter] = data.members
                    });
                    commit('setAllQuarterScoreHistory', response)
                });
            }
            if(questId == 'WHO-5'){
                const arrQuestionSet = Object.values(state.questionSet1)
                await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "in", arrQuestionSet).get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(state.teamkeys[doc.data().team]){
                            temp_name = state.teamkeys[doc.data().team].name
                        }

                        _tmp['teamid'] = doc.data().team;
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                });
            }else if(questId == 'eRes'){
                const arrQuestionSet = Object.values(state.questionSet2)
                await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "in", arrQuestionSet).get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(state.teamkeys[doc.data().team]){
                            temp_name = state.teamkeys[doc.data().team].name
                        }

                        _tmp['teamid'] = doc.data().team;
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                });
            }else if(questId == 'Culture'){
                let arrQuestionSet: any[] = [];
                if(questionCultureCustom.length > 0){
                    arrQuestionSet = Object.values(questionCultureCustom)
                }else{
                    arrQuestionSet = Object.values(state.questionSet3)
                }
                await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "in", arrQuestionSet).get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(state.teamkeys[doc.data().team]){
                            temp_name = state.teamkeys[doc.data().team].name
                        }

                        _tmp['teamid'] = doc.data().team;
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                });
            }else if(questId == 'DEBI'){
                const arrQuestionSet = Object.values(state.questionSet4)
                await firebase.firestore().collection('engagement_index_quarter').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("type", "in", arrQuestionSet).get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    const response: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(state.teamkeys[doc.data().team]){
                            temp_name = state.teamkeys[doc.data().team].name
                        }

                        _tmp['teamid'] = doc.data().team;
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                        response[_tmp.quarter] = 0
                    });
                    commit('setAllQuarterScoreHistory', response)
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                });
            }else if(questId == 'Index'){
                const arrQuestionSet = Object.values(state.questionSet5)
                await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "in", arrQuestionSet).get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(state.teamkeys[doc.data().team]){
                            temp_name = state.teamkeys[doc.data().team].name
                        }

                        _tmp['teamid'] = doc.data().team;
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                });
            }else if(questId == 'Variance'){
                const arrQuestionSet = Object.values(state.questionSet5)
                await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "in", arrQuestionSet).get()
                .then(function (querySnapshot) {
                    const datatable: Array<any> = [];
                    querySnapshot.forEach(function (doc) {
                        let _tmp: { [key: string]: any } = {}
                        _tmp = doc.data();
                        let temp_name = '';
                        if(state.teamkeys[doc.data().team]){
                            temp_name = state.teamkeys[doc.data().team].name
                        }

                        _tmp['teamid'] = doc.data().team;
                        _tmp['team'] = temp_name;
                        datatable.push(_tmp);
                    });
                    commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                    dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                });
            }else{
                if(questionMaster[questId].repeats == 'monthly'){
                    await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "==", questId).get()
                    .then(function (querySnapshot) {
                        const datatable: Array<any> = [];
                        const response: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            let date = doc.data().date
                            if(questionMaster[questId].rolling !== undefined && questionMaster[questId].rolling == true){
                                date = format(doc.data().date, 'YYYY-MM')
                            }
                            let _tmp: { [key: string]: any } = {}
                            _tmp = doc.data();
                            _tmp['date'] = date
                            let temp_name = '';
                            if(state.teamkeys[doc.data().team]){
                                temp_name = state.teamkeys[doc.data().team].name
                            }
                            _tmp['teamid'] = doc.data().team;
                            _tmp['team'] = temp_name;
                            response[date] = date
                            datatable.push(_tmp);
                        });
                        commit('setDataTableAllScoreHistoryMonthly', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                        commit('setAllQuarterScoreHistoryMonthly', response)
                        dispatch('getDataTablebyTeamScoreHistoryMonthly', {questId, type:'team'})
                    });
                }else{
                    await firebase.firestore().collection('insight_teams_report_card').where("company", "==", rootState.authen.user.company).where("team", "==", state.teamselected).where("quest_id", "==", questId).get()
                    .then(function (querySnapshot) {
                        const datatable: Array<any> = [];
                        const response: Array<any> = [];
                        querySnapshot.forEach(function (doc) {
                            let _tmp: { [key: string]: any } = {}
                            _tmp = doc.data();
                            let temp_name = '';
                            if(state.teamkeys[doc.data().team]){
                                temp_name = state.teamkeys[doc.data().team].name
                            }
                            _tmp['teamid'] = doc.data().team;
                            _tmp['team'] = temp_name;
                            response[data.date] = data.members
                            datatable.push(_tmp);
                        });
                        commit('setDataTableAllScoreHistory', _.sortBy(datatable, [function (o: any) { return o.team; }]))
                        dispatch('getDataTablebyTeamScoreHistory', {questId, type:'team'})
                    });
                }
            }
        }
    },
    getters: {
        datatable: (state: any) => {
            return state.datatable
        },
        teamkeys: (state:any) => {
            return state.teamkeys
        },
        cohortkeys: (state:any) => {
            return state.cohortkeys
        },
        categoryMaster: (state:any) => {
            return state.categoryMaster
        },
        questionMaster: (state:any) => {
            return state.questionMaster
        },
        quarterSelected: (state:any) => {
            return state.quarterSelected
        },
        quarterOption: (state:any) => {
            return state.quarterOption
        },
        quarterOptionModal: (state:any) => {
            return state.quarterOptionModal
        },
        teamsetup: (state:any) => {
            return state.teamsetup
        },
        questionType: (state:any) => {
            return state.questionType
        },
        showSnackbar: (state:any) => {
            return state.showSnackbar
        },
        chartData: (state:any) => {
            return state.chartData
        },
        chartLabel: (state:any) => {
            return state.chartLabel
        },
        chartMaxChange: (state:any) => {
            return state.chartMaxChange
        },
    }
}
